var _rect, _defs, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _polyline, _line60, _line61, _polyline2, _line62, _line63, _polyline3, _polyline4, _line64, _line65, _polyline5, _line66, _line67, _polyline6, _polyline7, _line68, _polyline8, _line69, _polyline9, _polyline10, _line70, _line71, _polyline11, _line72, _line73, _polyline12, _polyline13, _line74, _line75, _polyline14, _line76, _line77, _polyline15, _polyline16, _line78, _line79, _polyline17, _line80, _line81, _polyline18, _polyline19, _line82, _line83, _line84, _polyline20, _line85, _line86, _polyline21, _polyline22, _polyline23, _line87, _line88, _line89, _polyline24, _line90, _line91, _polyline25, _polyline26, _polyline27, _line92, _line93, _line94, _polyline28, _line95, _line96, _line97, _polyline29, _polyline30, _line98, _line99, _line100, _polyline31, _polyline32, _line101, _line102, _polyline33, _polyline34, _line103, _line104, _line105, _polyline35, _polyline36, _line106, _line107, _polyline37, _polyline38, _line108, _line109, _line110, _polyline39, _polyline40, _line111, _line112, _polyline41, _polyline42, _polyline43, _line113, _line114, _polyline44, _line115, _line116, _polyline45, _polyline46, _polyline47, _polyline48, _line117, _line118, _polyline49, _line119, _line120, _polyline50, _polyline51, _polyline52, _line121, _line122, _line123, _polyline53, _line124, _line125, _line126, _polyline54, _polyline55, _line127, _line128, _polyline56, _polyline57, _polyline58, _line129, _line130, _polyline59, _polyline60, _line131, _line132, _polyline61, _polyline62, _polyline63, _line133, _line134, _polyline64, _polyline65, _line135, _line136, _polyline66, _polyline67, _polyline68, _line137, _line138, _polyline69, _polyline70, _polyline71, _line139, _line140, _polyline72, _line141, _line142, _line143, _polyline73, _polyline74, _polyline75, _line144, _line145, _polyline76, _line146, _line147, _line148, _polyline77, _polyline78, _line149, _line150, _line151, _polyline79, _line152, _line153, _line154, _polyline80, _polyline81, _line155, _line156, _polyline82, _polyline83, _line157, _line158, _line159, _polyline84, _polyline85, _line160, _line161, _polyline86, _polyline87, _line162, _line163, _line164, _polyline88, _polyline89, _line165, _line166, _polyline90, _polyline91, _line167, _line168, _line169, _polyline92, _polyline93, _line170, _line171, _polyline94, _line172, _line173, _polyline95, _polyline96, _line174, _line175, _polyline97, _line176, _line177, _polyline98, _polyline99, _line178, _polyline100, _line179, _polyline101, _polyline102, _line180, _line181, _polyline103, _line182, _line183, _polyline104, _polyline105, _line184, _line185, _polyline106, _line186, _line187, _polyline107, _polyline108, _line188, _line189, _polyline109, _line190, _line191, _polyline110, _polyline111, _line192, _line193, _polyline112, _line194, _line195, _polyline113, _polyline114, _line196, _line197, _polyline115, _line198, _line199, _polyline116, _polyline117, _line200, _polyline118, _line201, _polyline119, _polyline120, _line202, _line203, _polyline121, _line204, _line205, _polyline122, _polyline123, _line206, _line207, _polyline124, _line208, _line209, _polyline125, _polyline126, _line210, _line211, _polyline127, _line212, _line213, _polyline128, _polyline129, _line214, _line215, _line216, _polyline130, _line217, _line218, _polyline131, _polyline132, _line219, _line220, _line221, _polyline133, _line222, _line223, _polyline134, _polyline135, _line224, _line225, _line226, _polyline136, _line227, _line228, _polyline137, _polyline138, _line229, _line230, _line231, _polyline139, _line232, _polyline140, _polyline141, _line233, _line234, _line235, _polyline142, _line236, _line237, _polyline143, _polyline144, _line238, _line239, _line240, _polyline145, _line241, _line242, _polyline146, _polyline147, _line243, _line244, _line245, _polyline148, _line246, _line247, _line248, _polyline149, _line249, _line250, _line251, _polyline150, _line252, _polyline151, _polyline152, _line253, _line254, _polyline153, _line255, _line256, _polyline154, _polyline155, _line257, _line258, _line259, _polyline156, _polyline157, _line260, _line261, _polyline158, _polyline159, _line262, _line263, _polyline160, _polyline161, _polyline162, _line264, _line265, _polyline163, _polyline164, _line266, _line267, _polyline165, _polyline166, _line268, _line269, _line270, _polyline167, _polyline168, _line271, _line272, _polyline169, _line273, _line274, _polyline170, _polyline171, _line275, _line276, _polyline172, _line277, _line278, _polyline173, _polyline174, _line279, _line280, _line281, _polyline175, _line282, _line283, _polyline176, _line284, _line285, _line286, _line287, _line288, _line289, _line290, _line291, _line292, _line293, _polyline177, _line294, _line295, _polyline178, _line296, _line297, _line298, _line299, _polyline179, _line300, _line301, _polyline180, _line302, _polyline181, _line303, _line304, _line305, _line306, _polyline182, _line307, _line308, _line309, _line310, _line311, _line312, _line313, _polyline183, _line314, _line315, _line316, _line317, _line318, _line319, _line320, _line321, _line322, _line323, _line324, _line325, _line326, _line327, _line328, _line329, _line330, _line331, _line332, _line333, _line334, _line335, _line336, _line337, _line338, _polyline184, _line339, _line340, _line341, _line342, _polyline185, _line343, _line344, _line345, _line346, _polyline186, _line347, _line348, _line349, _line350, _polyline187, _line351, _polyline188, _line352, _polyline189, _line353, _line354, _line355, _line356, _polyline190, _line357, _line358, _line359, _line360, _polyline191, _line361, _polyline192, _line362, _polyline193, _line363, _line364, _line365, _line366, _line367, _line368, _line369, _line370, _polyline194, _line371, _polyline195, _line372, _line373, _line374, _polyline196, _polyline197, _line375, _line376, _line377, _polyline198, _polyline199, _line378, _polyline200, _line379, _polyline201, _line380, _line381, _polyline202, _line382, _line383, _line384, _polyline203, _polyline204, _line385, _line386, _polyline205, _line387, _line388, _line389, _polyline206, _polyline207, _line390, _polyline208, _line391, _polyline209, _line392, _line393, _line394, _line395, _line396, _line397, _line398, _line399, _line400, _line401, _line402, _line403, _line404, _line405, _line406, _line407, _line408, _line409, _line410, _line411, _line412, _line413, _line414, _line415, _line416, _line417, _line418, _line419, _line420, _line421, _line422, _line423, _line424, _line425, _line426, _line427, _line428, _line429, _line430, _line431, _line432, _line433, _line434, _line435, _line436, _line437, _line438, _line439, _line440, _line441, _line442, _line443, _line444, _line445, _line446, _line447, _line448, _line449, _line450, _line451, _line452, _line453, _line454, _line455, _line456, _line457, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _line458, _line459, _line460, _line461, _line462, _line463, _line464, _line465, _line466, _line467, _line468, _line469, _line470, _line471, _line472, _line473, _line474, _line475, _line476, _line477, _line478, _line479, _line480, _line481, _line482, _line483, _line484, _line485, _line486, _line487, _line488, _line489, _line490, _line491, _polyline210, _rect15, _rect16, _line492, _polyline211, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _line493, _line494, _line495, _line496, _line497, _line498, _line499, _line500, _line501, _line502, _line503, _line504, _line505, _line506, _line507, _line508, _line509, _line510, _line511, _line512, _line513, _line514, _line515, _line516, _line517, _line518, _line519, _line520, _line521, _line522, _line523, _line524, _line525, _line526, _line527, _line528, _line529, _line530, _line531, _line532, _line533, _line534, _line535, _line536, _line537, _line538, _line539, _line540, _line541, _polyline212, _rect24, _rect25, _line542, _line543, _line544, _line545, _line546, _line547, _line548, _line549, _line550, _line551, _line552, _line553, _line554, _line555, _line556, _line557, _line558, _line559, _line560, _line561, _line562, _line563, _line564, _rect26, _polyline213, _polyline214, _polyline215, _line565, _line566, _line567, _rect27, _rect28, _line568, _line569, _line570, _line571, _line572, _line573, _rect29, _rect30, _rect31, _line574, _line575, _line576, _line577, _line578, _polygon, _line579, _line580, _line581, _line582, _polyline216, _polyline217, _polyline218, _polyline219, _line583, _line584, _line585, _line586, _line587, _line588, _line589, _line590, _line591, _line592, _line593, _line594, _line595, _line596, _line597, _line598, _line599, _line600, _line601, _line602, _line603, _line604, _line605, _line606, _line607, _line608, _line609, _line610, _line611, _line612, _line613, _line614, _line615, _line616, _line617, _line618, _line619, _line620, _line621, _line622, _line623, _line624, _line625, _line626, _line627, _line628, _line629, _line630, _line631, _line632, _line633, _line634, _line635, _line636, _line637, _polyline220, _polyline221, _polyline222, _polyline223, _line638, _line639, _line640, _line641, _line642, _line643, _line644, _line645, _line646, _line647, _line648, _line649, _line650, _line651, _line652, _line653, _line654, _line655, _line656, _line657, _line658, _line659, _line660, _line661, _line662, _line663, _line664, _line665, _line666, _line667, _line668, _polyline224, _polyline225, _polyline226, _polyline227, _line669, _line670, _line671, _line672, _line673, _line674, _line675, _line676, _line677, _line678, _line679, _line680, _line681, _line682, _line683, _line684, _line685, _line686, _line687, _line688, _line689, _line690, _line691, _line692, _line693, _line694, _line695, _line696, _line697, _line698, _line699, _polyline228, _polyline229, _polyline230, _polyline231, _line700, _line701, _line702, _line703, _line704, _line705, _line706, _line707, _line708, _line709, _line710, _line711, _line712, _line713, _line714, _line715, _line716, _line717, _line718, _line719, _line720, _line721, _line722, _line723, _line724, _line725, _line726, _line727, _line728, _line729, _line730, _polyline232, _polyline233, _polyline234, _polyline235, _line731, _line732, _line733, _line734, _line735, _line736, _line737, _line738, _line739, _line740, _line741, _line742, _line743, _line744, _line745, _line746, _line747, _line748, _line749, _line750, _line751, _line752, _line753, _line754, _line755, _line756, _line757, _line758, _line759, _line760, _line761, _polyline236, _polyline237, _polyline238, _polyline239, _line762, _line763, _line764, _line765, _line766, _line767, _line768, _line769, _line770, _line771, _line772, _line773, _line774, _line775, _line776, _line777, _line778, _line779, _line780, _line781, _line782, _line783, _line784, _line785, _line786, _line787, _line788, _line789, _line790, _line791, _line792, _polyline240, _polyline241, _polyline242, _polyline243, _line793, _line794, _line795, _line796, _line797, _line798, _line799, _line800, _line801, _line802, _line803, _line804, _line805, _line806, _line807, _line808, _line809, _line810, _line811, _line812, _line813, _line814, _line815, _line816, _line817, _line818, _line819, _line820, _line821, _line822, _line823, _polyline244, _polyline245, _polyline246, _polyline247, _line824, _line825, _line826, _line827, _line828, _line829, _line830, _line831, _line832, _line833, _line834, _line835, _line836, _line837, _line838, _line839, _line840, _line841, _line842, _line843, _line844, _line845, _line846, _line847, _line848, _line849, _line850, _line851, _line852, _line853, _line854, _polyline248, _polyline249, _polyline250, _polyline251, _line855, _line856, _line857, _line858, _line859, _line860, _line861, _line862, _line863, _line864, _line865, _line866, _line867, _line868, _line869, _line870, _line871, _line872, _line873, _line874, _line875, _line876, _line877, _line878, _line879, _line880, _line881, _line882, _line883, _line884, _line885, _polyline252, _polyline253, _polyline254, _polyline255, _line886, _line887, _line888, _line889, _line890, _line891, _line892, _line893, _line894, _line895, _line896, _line897, _line898, _line899, _line900, _line901, _line902, _line903, _line904, _line905, _line906, _line907, _line908, _line909, _line910, _line911, _line912, _line913, _line914, _line915, _line916, _polyline256, _polyline257, _polyline258, _polyline259, _line917, _line918, _line919, _line920, _line921, _line922, _line923, _line924, _line925, _line926, _line927, _line928, _line929, _line930, _line931, _line932, _line933, _line934, _line935, _line936, _line937, _line938, _line939, _line940, _line941, _line942, _line943, _line944, _line945, _line946, _line947, _polyline260, _polyline261, _polyline262, _polyline263, _line948, _line949, _line950, _line951, _line952, _line953, _line954, _line955, _line956, _line957, _line958, _line959, _line960, _line961, _line962, _line963, _line964, _line965, _line966, _line967, _line968, _line969, _line970, _line971, _line972, _line973, _line974, _line975, _line976, _line977, _line978, _polyline264, _polyline265, _polyline266, _polyline267, _line979, _line980, _line981, _line982, _line983, _line984, _line985, _line986, _line987, _line988, _line989, _line990, _line991, _line992, _line993, _line994, _line995, _line996, _line997, _line998, _line999, _line1000, _line1001, _line1002, _line1003, _line1004, _line1005, _line1006, _line1007, _line1008, _line1009, _polyline268, _polyline269, _polyline270, _polyline271, _line1010, _line1011, _line1012, _line1013, _line1014, _line1015, _line1016, _line1017, _line1018, _line1019, _line1020, _line1021, _line1022, _line1023, _line1024, _line1025, _line1026, _line1027, _line1028, _line1029, _line1030, _line1031, _line1032, _line1033, _line1034, _line1035, _line1036, _line1037, _line1038, _line1039, _line1040, _polyline272, _polyline273, _polyline274, _polyline275, _line1041, _line1042, _line1043, _line1044, _line1045, _line1046, _line1047, _line1048, _line1049, _line1050, _line1051, _line1052, _line1053, _line1054, _line1055, _line1056, _line1057, _line1058, _line1059, _line1060, _line1061, _line1062, _line1063, _line1064, _line1065, _line1066, _line1067, _line1068, _line1069, _line1070, _line1071, _polyline276, _polyline277, _polyline278, _polyline279, _line1072, _line1073, _line1074, _line1075, _line1076, _line1077, _line1078, _line1079, _line1080, _line1081, _line1082, _line1083, _line1084, _line1085, _line1086, _line1087, _line1088, _line1089, _line1090, _line1091, _line1092, _line1093, _line1094, _line1095, _line1096, _line1097, _line1098, _line1099, _line1100, _line1101, _line1102, _polyline280, _polyline281, _polyline282, _polyline283, _line1103, _line1104, _line1105, _line1106, _line1107, _line1108, _line1109, _line1110, _line1111, _line1112, _line1113, _line1114, _line1115, _line1116, _line1117, _line1118, _line1119, _line1120, _line1121, _line1122, _line1123, _line1124, _line1125, _line1126, _line1127, _line1128, _line1129, _line1130, _line1131, _line1132, _line1133, _polyline284, _polyline285, _polyline286, _polyline287, _line1134, _line1135, _line1136, _line1137, _line1138, _line1139, _line1140, _line1141, _line1142, _line1143, _line1144, _line1145, _line1146, _line1147, _line1148, _line1149, _line1150, _line1151, _line1152, _line1153, _line1154, _line1155, _line1156, _polyline288, _polyline289, _polyline290, _polyline291, _line1157, _line1158, _line1159, _line1160, _line1161, _line1162, _line1163, _line1164, _line1165, _line1166, _line1167, _line1168, _line1169, _line1170, _line1171, _line1172, _line1173, _line1174, _line1175, _line1176, _line1177, _line1178, _line1179, _polyline292, _polyline293, _polyline294, _polyline295, _line1180, _line1181, _line1182, _line1183, _line1184, _line1185, _line1186, _line1187, _line1188, _line1189, _line1190, _line1191, _line1192, _line1193, _line1194, _line1195, _line1196, _line1197, _line1198, _line1199, _line1200, _line1201, _line1202, _line1203, _line1204, _line1205, _line1206, _line1207, _line1208, _line1209, _line1210, _line1211, _line1212, _line1213, _line1214, _line1215, _line1216, _line1217, _line1218, _line1219, _line1220, _line1221, _line1222, _line1223, _line1224, _line1225, _line1226, _line1227, _line1228, _line1229, _line1230, _line1231, _line1232, _line1233, _line1234, _line1235, _line1236, _line1237, _line1238, _line1239, _line1240, _line1241, _line1242, _line1243, _line1244, _line1245, _line1246, _line1247, _line1248, _line1249, _polyline296, _line1250, _polyline297, _polyline298, _line1251, _line1252, _line1253, _line1254, _line1255, _line1256, _line1257, _line1258, _line1259, _line1260, _line1261, _line1262, _line1263, _line1264, _line1265, _line1266, _line1267, _line1268, _line1269, _line1270, _line1271, _line1272, _line1273, _line1274, _line1275, _line1276, _line1277, _line1278, _line1279, _line1280, _line1281, _line1282, _line1283, _line1284, _line1285, _line1286, _line1287, _line1288, _line1289, _line1290, _line1291, _line1292, _line1293, _line1294, _line1295, _line1296, _line1297, _line1298, _line1299, _line1300, _line1301, _line1302, _line1303, _line1304, _line1305, _line1306, _line1307, _line1308, _line1309, _line1310, _line1311, _line1312, _line1313, _line1314, _line1315, _line1316, _line1317, _line1318, _line1319, _line1320, _line1321, _line1322, _line1323, _line1324, _line1325, _line1326, _line1327, _line1328, _line1329, _line1330, _line1331, _line1332, _line1333, _line1334, _line1335, _line1336, _line1337, _line1338, _line1339, _line1340, _line1341, _line1342, _line1343, _line1344, _line1345, _line1346, _line1347, _line1348, _line1349, _line1350, _line1351, _line1352, _line1353, _line1354, _line1355, _line1356, _line1357, _line1358, _line1359, _line1360, _line1361, _line1362, _line1363, _line1364, _line1365, _line1366, _line1367, _line1368, _line1369, _line1370, _line1371, _line1372, _line1373, _line1374, _line1375, _line1376, _line1377, _line1378, _line1379, _line1380, _line1381, _polyline299, _line1382, _polyline300, _polyline301, _line1383, _line1384, _line1385, _line1386, _line1387, _line1388, _line1389, _line1390, _line1391, _line1392, _line1393, _line1394, _line1395, _line1396, _line1397, _line1398, _line1399, _line1400, _line1401, _line1402, _line1403, _line1404, _line1405, _line1406, _line1407, _line1408, _polyline302, _line1409, _polyline303, _polyline304, _line1410, _line1411, _polyline305, _line1412, _line1413, _line1414, _line1415, _line1416, _line1417, _line1418, _line1419, _line1420, _line1421, _line1422, _line1423, _line1424, _line1425, _line1426, _line1427, _line1428, _line1429, _line1430, _line1431, _line1432, _line1433, _line1434, _polyline306, _line1435, _polyline307, _polyline308, _line1436, _line1437, _line1438, _line1439, _line1440, _line1441, _line1442, _line1443, _line1444, _line1445, _line1446, _line1447, _line1448, _line1449, _line1450, _line1451, _line1452, _line1453, _line1454, _line1455, _line1456, _line1457, _line1458, _line1459, _line1460, _line1461, _polyline309, _line1462, _polyline310, _polyline311, _line1463, _line1464, _polyline312, _line1465, _line1466, _line1467, _line1468, _line1469, _line1470, _line1471, _line1472, _line1473, _line1474, _line1475, _line1476, _line1477, _line1478, _line1479, _line1480, _line1481, _line1482, _line1483, _line1484, _line1485, _line1486, _line1487, _polyline313, _line1488, _polyline314, _line1489, _line1490, _line1491, _polyline315, _line1492, _line1493, _line1494, _line1495, _line1496, _line1497, _line1498, _line1499, _line1500, _line1501, _line1502, _line1503, _line1504, _line1505, _line1506, _line1507, _line1508, _line1509, _line1510, _line1511, _line1512, _line1513, _line1514, _line1515, _line1516, _polyline316, _polyline317, _line1517, _line1518, _line1519, _line1520, _line1521, _line1522, _line1523, _line1524, _line1525, _line1526, _line1527, _line1528, _line1529, _line1530, _line1531, _line1532, _line1533, _line1534, _line1535, _line1536, _line1537, _line1538, _line1539, _line1540, _line1541, _line1542, _line1543, _line1544, _line1545, _polyline318, _line1546, _line1547, _polyline319, _line1548, _line1549, _line1550, _line1551, _line1552, _line1553, _line1554, _line1555, _line1556, _line1557, _line1558, _line1559, _line1560, _line1561, _line1562, _line1563, _line1564, _line1565, _line1566, _line1567, _line1568, _line1569, _line1570, _polyline320, _line1571, _polyline321, _line1572, _line1573, _line1574, _line1575, _line1576, _line1577, _line1578, _line1579, _line1580, _line1581, _line1582, _line1583, _line1584, _line1585, _line1586, _line1587, _line1588, _line1589, _line1590, _line1591, _line1592, _line1593, _line1594, _line1595, _line1596, _line1597, _line1598, _line1599, _line1600, _line1601, _polyline322, _line1602, _line1603, _polyline323, _line1604, _line1605, _line1606, _line1607, _line1608, _line1609, _line1610, _line1611, _line1612, _line1613, _line1614, _line1615, _line1616, _line1617, _line1618, _line1619, _line1620, _line1621, _line1622, _line1623, _line1624, _line1625, _line1626, _line1627, _line1628, _line1629, _polyline324, _line1630, _line1631, _polyline325, _line1632, _line1633, _line1634, _line1635, _line1636, _line1637, _line1638, _line1639, _line1640, _line1641, _line1642, _line1643, _line1644, _line1645, _line1646, _line1647, _line1648, _line1649, _line1650, _line1651, _line1652, _line1653, _line1654, _line1655, _line1656, _line1657, _polyline326, _line1658, _line1659, _polyline327, _line1660, _line1661, _line1662, _line1663, _line1664, _line1665, _line1666, _line1667, _line1668, _line1669, _line1670, _line1671, _line1672, _line1673, _line1674, _line1675, _line1676, _line1677, _line1678, _line1679, _line1680, _line1681, _line1682, _line1683, _line1684, _polyline328, _polyline329, _line1685, _line1686, _line1687, _line1688, _line1689, _line1690, _line1691, _line1692, _line1693, _line1694, _line1695, _line1696, _line1697, _line1698, _line1699, _line1700, _line1701, _line1702, _line1703, _line1704, _line1705, _line1706, _line1707, _line1708, _line1709, _line1710, _line1711, _line1712, _line1713, _polyline330, _line1714, _line1715, _polyline331, _line1716, _line1717, _line1718, _line1719, _line1720, _line1721, _line1722, _line1723, _line1724, _line1725, _line1726, _line1727, _line1728, _line1729, _line1730, _line1731, _line1732, _line1733, _line1734, _line1735, _line1736, _line1737, _line1738, _line1739, _line1740, _line1741, _polyline332, _line1742, _line1743, _polyline333, _line1744, _line1745, _line1746, _line1747, _line1748, _line1749, _line1750, _line1751, _line1752, _line1753, _line1754, _line1755, _line1756, _line1757, _line1758, _line1759, _line1760, _line1761, _line1762, _line1763, _line1764, _line1765, _line1766, _line1767, _line1768, _line1769, _polyline334, _line1770, _line1771, _polyline335, _line1772, _line1773, _line1774, _line1775, _line1776, _line1777, _line1778, _line1779, _line1780, _line1781, _line1782, _line1783, _line1784, _line1785, _line1786, _line1787, _line1788, _line1789, _line1790, _line1791, _line1792, _line1793, _line1794, _line1795, _line1796, _line1797, _polyline336, _line1798, _line1799, _polyline337, _line1800, _line1801, _line1802, _line1803, _line1804, _line1805, _line1806, _line1807, _line1808, _line1809, _line1810, _line1811, _line1812, _line1813, _line1814, _line1815, _line1816, _line1817, _line1818, _line1819, _line1820, _line1821, _line1822, _polyline338, _line1823, _polyline339, _line1824, _line1825, _line1826, _line1827, _line1828, _line1829, _line1830, _line1831, _line1832, _line1833, _line1834, _line1835, _line1836, _line1837, _line1838, _line1839, _line1840, _line1841, _line1842, _line1843, _line1844, _line1845, _line1846, _line1847, _line1848, _line1849, _line1850, _line1851, _line1852, _line1853, _polyline340, _line1854, _line1855, _polyline341, _line1856, _line1857, _line1858, _line1859, _line1860, _line1861, _line1862, _line1863, _line1864, _line1865, _line1866, _line1867, _line1868, _line1869, _line1870, _line1871, _line1872, _line1873, _line1874, _line1875, _line1876, _line1877, _line1878, _line1879, _line1880, _polyline342, _polyline343, _line1881, _line1882, _line1883, _line1884, _line1885, _line1886, _line1887, _line1888, _line1889, _line1890, _line1891, _line1892, _line1893, _line1894, _line1895, _line1896, _line1897, _line1898, _line1899, _line1900, _line1901, _line1902, _line1903, _line1904, _line1905, _line1906, _line1907, _line1908, _line1909, _line1910, _line1911, _line1912, _line1913, _line1914, _line1915, _line1916, _line1917, _line1918, _line1919, _line1920, _line1921, _line1922, _line1923, _line1924, _line1925, _line1926, _line1927, _line1928, _line1929, _line1930, _line1931, _line1932, _line1933, _line1934, _line1935, _line1936, _line1937, _line1938, _line1939, _line1940, _line1941, _line1942, _line1943, _line1944, _line1945, _line1946, _line1947, _line1948, _line1949, _line1950, _line1951, _line1952, _line1953, _line1954, _line1955, _line1956, _line1957, _line1958, _line1959, _line1960, _line1961, _line1962, _line1963, _line1964, _line1965, _line1966, _line1967, _line1968, _line1969, _line1970, _line1971, _line1972, _line1973, _line1974, _line1975, _line1976, _line1977, _line1978, _line1979, _line1980, _line1981, _line1982, _line1983, _line1984, _line1985, _line1986, _line1987, _line1988, _line1989, _line1990, _line1991, _line1992, _line1993, _line1994, _line1995, _line1996, _line1997, _line1998, _line1999, _line2000, _line2001, _line2002, _line2003, _line2004, _line2005, _line2006, _line2007, _line2008, _line2009, _line2010, _line2011, _line2012, _line2013, _line2014, _line2015, _line2016, _line2017, _line2018, _line2019, _line2020, _line2021, _line2022, _line2023, _line2024, _line2025, _line2026, _line2027, _line2028, _line2029, _line2030, _line2031, _line2032, _line2033, _line2034, _line2035, _line2036, _line2037, _line2038, _line2039, _line2040, _line2041, _line2042, _line2043, _line2044, _line2045, _line2046, _line2047, _line2048, _line2049, _line2050, _line2051, _line2052, _line2053, _line2054, _line2055, _line2056, _line2057, _line2058, _line2059, _line2060, _line2061, _line2062, _line2063, _line2064, _line2065, _line2066, _line2067, _line2068, _line2069, _line2070, _line2071, _line2072, _line2073, _line2074, _line2075, _line2076, _line2077, _line2078, _line2079, _line2080, _line2081, _line2082, _line2083, _line2084, _line2085, _line2086, _line2087, _line2088, _line2089, _line2090, _line2091, _line2092, _line2093, _line2094, _line2095, _line2096, _line2097, _line2098, _line2099, _line2100, _line2101, _line2102, _line2103, _line2104, _line2105, _line2106, _line2107, _line2108, _line2109, _line2110, _line2111, _line2112, _line2113, _line2114, _line2115, _line2116, _line2117, _line2118, _line2119, _line2120, _line2121, _line2122, _line2123, _line2124, _line2125, _line2126, _line2127, _line2128, _line2129, _line2130, _line2131, _line2132, _line2133, _line2134, _line2135, _line2136, _line2137, _line2138, _line2139, _line2140, _line2141, _line2142, _line2143, _line2144, _line2145, _line2146, _line2147, _line2148, _line2149, _line2150, _line2151, _line2152, _line2153, _line2154, _line2155, _line2156, _line2157, _line2158, _line2159, _line2160, _line2161, _line2162, _line2163, _line2164, _line2165, _line2166, _line2167, _line2168, _line2169, _line2170, _line2171, _line2172, _line2173, _line2174, _line2175, _line2176, _line2177, _line2178, _line2179, _line2180, _line2181, _line2182, _line2183, _line2184, _line2185, _line2186, _line2187, _line2188, _line2189, _line2190, _line2191, _line2192, _line2193, _line2194, _line2195, _line2196, _line2197, _line2198, _line2199, _line2200, _line2201, _line2202, _line2203, _line2204, _line2205, _line2206, _line2207, _line2208, _line2209, _line2210, _line2211, _line2212, _line2213, _line2214, _line2215, _line2216, _line2217, _line2218, _line2219, _line2220, _line2221, _line2222, _line2223, _line2224, _line2225, _line2226, _line2227, _line2228, _line2229, _line2230, _line2231, _line2232, _line2233, _line2234, _line2235, _line2236, _line2237, _line2238, _line2239, _line2240, _line2241, _line2242, _line2243, _line2244, _line2245, _line2246, _line2247, _line2248, _line2249, _line2250, _line2251, _line2252, _line2253, _line2254, _line2255, _line2256, _line2257, _line2258, _line2259, _line2260, _line2261, _line2262, _line2263, _line2264, _line2265, _line2266, _line2267, _line2268, _line2269, _line2270, _line2271, _line2272, _line2273, _line2274, _line2275, _line2276, _line2277, _line2278, _line2279, _line2280, _line2281, _line2282, _line2283, _line2284, _line2285, _line2286, _line2287, _line2288, _line2289, _line2290, _line2291, _line2292, _line2293, _line2294, _line2295, _line2296, _line2297, _line2298, _line2299, _line2300, _line2301, _line2302, _line2303, _line2304, _line2305, _line2306, _line2307, _line2308, _line2309, _line2310, _line2311, _line2312, _line2313, _line2314, _line2315, _line2316, _line2317, _line2318, _line2319, _line2320, _line2321, _line2322, _line2323, _line2324, _line2325, _line2326, _line2327, _line2328, _line2329, _line2330, _line2331, _line2332, _line2333, _line2334, _line2335, _line2336, _line2337, _line2338, _line2339, _line2340, _line2341, _line2342, _line2343, _line2344, _line2345, _line2346, _line2347, _line2348, _line2349, _line2350, _line2351, _line2352, _line2353, _line2354, _line2355, _line2356, _line2357, _line2358, _line2359, _line2360, _line2361, _line2362, _line2363, _line2364, _line2365, _line2366, _line2367, _line2368, _line2369, _polyline344, _polyline345, _polyline346, _polyline347, _line2370, _line2371, _line2372, _line2373, _line2374, _line2375, _line2376, _line2377, _line2378, _line2379, _line2380, _line2381, _line2382, _line2383, _line2384, _line2385, _line2386, _line2387, _line2388, _line2389, _line2390, _line2391, _line2392, _line2393, _line2394, _line2395, _line2396, _line2397, _line2398, _line2399, _line2400, _polyline348, _polyline349, _polyline350, _polyline351, _line2401, _line2402, _line2403, _line2404, _line2405, _line2406, _line2407, _line2408, _line2409, _line2410, _line2411, _line2412, _line2413, _line2414, _line2415, _line2416, _line2417, _line2418, _line2419, _line2420, _line2421, _line2422, _line2423, _line2424, _line2425, _line2426, _line2427, _line2428, _line2429, _line2430, _line2431, _polyline352, _polyline353, _polyline354, _polyline355, _line2432, _line2433, _line2434, _line2435, _line2436, _line2437, _line2438, _line2439, _line2440, _line2441, _line2442, _line2443, _line2444, _line2445, _line2446, _line2447, _line2448, _line2449, _line2450, _line2451, _line2452, _line2453, _line2454, _line2455, _line2456, _line2457, _line2458, _line2459, _line2460, _line2461, _line2462, _polyline356, _polyline357, _polyline358, _polyline359, _line2463, _line2464, _line2465, _line2466, _line2467, _line2468, _line2469, _line2470, _line2471, _line2472, _line2473, _line2474, _line2475, _line2476, _line2477, _line2478, _line2479, _line2480, _line2481, _line2482, _line2483, _line2484, _line2485, _line2486, _line2487, _line2488, _line2489, _line2490, _line2491, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _line2492, _line2493, _line2494, _line2495, _line2496;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamiMapsFullCpareAupstairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1224 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: square;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: .75px;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke-width: 0px;\n      }\n    "))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 834.22,
    y: 285.86,
    width: 1.27,
    height: 1.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 834.22,
    y: 78.11,
    width: 1.27,
    height: 1.15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 834.22,
    y: 437.19,
    width: 1.27,
    height: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 490.6,
    x2: 808.17,
    y2: 490.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 490.6,
    x2: 808.39,
    y2: 490.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 439.27,
    x2: 808.17,
    y2: 439.27
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 439.27,
    x2: 808.39,
    y2: 439.27
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 334.92,
    x2: 808.17,
    y2: 334.92
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 336.66,
    x2: 808.17,
    y2: 336.66
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 336.66,
    x2: 808.39,
    y2: 336.66
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 334.92,
    x2: 808.39,
    y2: 334.92
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 232.35,
    x2: 808.17,
    y2: 232.35
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 232.35,
    x2: 808.39,
    y2: 232.35
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 129.66,
    x2: 808.17,
    y2: 129.66
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 129.66,
    x2: 808.39,
    y2: 129.66
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 78.42,
    x2: 808.17,
    y2: 78.42
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 78.42,
    x2: 808.39,
    y2: 78.42
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 490.6,
    x2: 542.22,
    y2: 490.6
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 490.6,
    x2: 542.31,
    y2: 490.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 439.27,
    x2: 542.22,
    y2: 439.27
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 439.27,
    x2: 542.31,
    y2: 439.27
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 334.92,
    x2: 542.22,
    y2: 334.92
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 336.66,
    x2: 542.22,
    y2: 336.66
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 336.66,
    x2: 542.31,
    y2: 336.66
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 334.92,
    x2: 542.31,
    y2: 334.92
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 232.35,
    x2: 542.22,
    y2: 232.35
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 232.35,
    x2: 542.31,
    y2: 232.35
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 129.66,
    x2: 542.22,
    y2: 129.66
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 129.66,
    x2: 542.31,
    y2: 129.66
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 78.42,
    x2: 542.22,
    y2: 78.42
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 78.42,
    x2: 542.31,
    y2: 78.42
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 490.6,
    x2: 475.65,
    y2: 490.6
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 490.6,
    x2: 475.86,
    y2: 490.6
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 439.27,
    x2: 475.65,
    y2: 439.27
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 439.27,
    x2: 475.86,
    y2: 439.27
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 334.92,
    x2: 475.65,
    y2: 334.92
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 336.66,
    x2: 475.65,
    y2: 336.66
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 336.66,
    x2: 475.86,
    y2: 336.66
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 334.92,
    x2: 475.86,
    y2: 334.92
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 232.35,
    x2: 475.65,
    y2: 232.35
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 232.35,
    x2: 475.86,
    y2: 232.35
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 129.66,
    x2: 475.65,
    y2: 129.66
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 129.66,
    x2: 475.86,
    y2: 129.66
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 78.42,
    x2: 475.65,
    y2: 78.42
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 78.42,
    x2: 475.86,
    y2: 78.42
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 78.42,
    x2: 409.29,
    y2: 78.42
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 129.66,
    x2: 409.29,
    y2: 129.66
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 232.35,
    x2: 409.29,
    y2: 232.35
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 336.66,
    x2: 409.29,
    y2: 336.66
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 334.92,
    x2: 409.29,
    y2: 334.92
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 439.27,
    x2: 409.29,
    y2: 439.27
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 490.6,
    x2: 409.29,
    y2: 490.6
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 541.85,
    x2: 409.29,
    y2: 541.85
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 588.61,
    x2: 409.29,
    y2: 588.61
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 586.84,
    x2: 409.29,
    y2: 586.84
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 633.5,
    x2: 808.17,
    y2: 633.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 633.5,
    x2: 808.39,
    y2: 633.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.01,
    y1: 633.5,
    x2: 542.22,
    y2: 633.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.22,
    y1: 633.5,
    x2: 542.31,
    y2: 633.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.57,
    y1: 633.5,
    x2: 475.65,
    y2: 633.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 475.65,
    y1: 633.5,
    x2: 475.86,
    y2: 633.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 633.5,
    x2: 409.29,
    y2: 633.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 488.64 807.11 488.64 807.11 488.85 808.05 488.85"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 488.93,
    x2: 808.05,
    y2: 488.85
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 488.93,
    x2: 808.05,
    y2: 490.6
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 490.6 807.11 490.6 807.11 490.72 809.11 490.72 809.11 490.6 808.17 490.6"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 490.6,
    x2: 808.17,
    y2: 488.93
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 488.85,
    x2: 808.17,
    y2: 488.93
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 488.85 809.11 488.85 809.11 488.64"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 437.4 807.11 437.4 807.11 437.48 808.05 437.48"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 437.69,
    x2: 808.05,
    y2: 437.48
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 437.69,
    x2: 808.05,
    y2: 439.27
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 439.27 807.11 439.27 807.11 439.48 809.11 439.48 809.11 439.27 808.17 439.27"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 439.27,
    x2: 808.17,
    y2: 437.69
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 437.48,
    x2: 808.17,
    y2: 437.69
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 437.48 809.11 437.48 809.11 437.4"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 334.71 807.11 334.71 807.11 334.92 808.05 334.92"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 334.92,
    x2: 808.05,
    y2: 336.66
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 336.66 807.11 336.66 807.11 336.79 809.11 336.79 809.11 336.66 808.17 336.66"
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 336.66,
    x2: 808.17,
    y2: 334.92
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 334.92 809.11 334.92 809.11 334.71"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 232.14 807.11 232.14 807.11 232.35 808.05 232.35"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 232.35,
    x2: 808.05,
    y2: 233.89
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 234.1,
    x2: 808.05,
    y2: 233.89
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 234.1 807.11 234.1 807.11 234.22 809.11 234.22 809.11 234.1 808.17 234.1"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 233.89,
    x2: 808.17,
    y2: 234.1
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 233.89,
    x2: 808.17,
    y2: 232.35
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 232.35 809.11 232.35 809.11 232.14"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 129.54 807.11 129.54 807.11 129.66 808.05 129.66"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 129.66,
    x2: 808.05,
    y2: 131.32
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 131.53,
    x2: 808.05,
    y2: 131.32
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 131.53 807.11 131.53 809.11 131.53 808.17 131.53"
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 131.32,
    x2: 808.17,
    y2: 131.53
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 131.32,
    x2: 808.17,
    y2: 129.66
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 129.66 809.11 129.66 809.11 129.54"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 78.21 807.11 78.21 807.11 78.42 808.05 78.42"
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 78.42,
    x2: 808.05,
    y2: 80.08
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 80.17,
    x2: 808.05,
    y2: 80.08
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 80.17 807.11 80.17 809.11 80.17 808.17 80.17"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 80.08,
    x2: 808.17,
    y2: 80.17
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 80.08,
    x2: 808.17,
    y2: 78.42
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 78.42 809.11 78.42 809.11 78.21"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 488.64 740.62 488.64 740.62 488.85 741.47 488.85"
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 488.93,
    x2: 741.47,
    y2: 488.85
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 488.93,
    x2: 741.69,
    y2: 490.6
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 490.6,
    x2: 741.69,
    y2: 490.6
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 490.6 740.62 490.6 740.62 490.72 742.53 490.72 742.53 490.6 741.81 490.6"
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 490.6,
    x2: 741.81,
    y2: 490.6
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 490.6,
    x2: 741.69,
    y2: 488.93
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 488.85 741.69 488.85 741.69 488.93"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 488.85 742.53 488.85 742.53 488.64"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 437.4 740.62 437.4 740.62 437.48 741.47 437.48"
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 437.69,
    x2: 741.47,
    y2: 437.48
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 437.69,
    x2: 741.69,
    y2: 439.27
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 439.27,
    x2: 741.69,
    y2: 439.27
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 439.27 740.62 439.27 740.62 439.48 742.53 439.48 742.53 439.27 741.81 439.27"
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 439.27,
    x2: 741.81,
    y2: 439.27
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 439.27,
    x2: 741.69,
    y2: 437.69
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 437.48 741.69 437.48 741.69 437.69"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 437.48 742.53 437.48 742.53 437.4"
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 334.71 740.62 334.71 740.62 334.92 741.47 334.92"
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 334.92,
    x2: 741.47,
    y2: 334.92
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 334.92,
    x2: 741.69,
    y2: 336.66
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 336.66,
    x2: 741.69,
    y2: 336.66
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 336.66 740.62 336.66 740.62 336.79 742.53 336.79 742.53 336.66 741.81 336.66"
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 336.66,
    x2: 741.81,
    y2: 336.66
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 336.66,
    x2: 741.69,
    y2: 334.92
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 334.92,
    x2: 741.69,
    y2: 334.92
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 334.92 742.53 334.92 742.53 334.71"
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 232.14 740.62 232.14 740.62 232.35 741.47 232.35"
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 232.35,
    x2: 741.47,
    y2: 232.35
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 232.35,
    x2: 741.69,
    y2: 233.89
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 234.1,
    x2: 741.69,
    y2: 233.89
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 234.1 740.62 234.1 740.62 234.22 742.53 234.22 742.53 234.1 741.81 234.1"
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.69 233.89 741.69 234.1 741.81 234.1"
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 233.89,
    x2: 741.69,
    y2: 232.35
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 232.35,
    x2: 741.69,
    y2: 232.35
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 232.35 742.53 232.35 742.53 232.14"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 129.54 740.62 129.54 740.62 129.66 741.47 129.66"
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 129.66,
    x2: 741.47,
    y2: 129.66
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 129.66,
    x2: 741.69,
    y2: 131.32
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 131.53,
    x2: 741.69,
    y2: 131.32
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 131.53 740.62 131.53 742.53 131.53 741.81 131.53"
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.69 131.32 741.69 131.53 741.81 131.53"
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 131.32,
    x2: 741.69,
    y2: 129.66
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 129.66,
    x2: 741.69,
    y2: 129.66
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 129.66 742.53 129.66 742.53 129.54"
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 78.21 740.62 78.21 740.62 78.42 741.47 78.42"
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 78.42,
    x2: 741.47,
    y2: 78.42
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 78.42,
    x2: 741.69,
    y2: 80.08
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 80.17,
    x2: 741.69,
    y2: 80.08
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 80.17 740.62 80.17 742.53 80.17 741.81 80.17"
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.69 80.08 741.69 80.17 741.81 80.17"
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 80.08,
    x2: 741.69,
    y2: 78.42
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 78.42,
    x2: 741.69,
    y2: 78.42
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 78.42 742.53 78.42 742.53 78.21"
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 488.64 674.1 488.64 674.1 488.85 675.03 488.85"
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.16 488.93 675.16 488.85 675.03 488.85"
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 488.93,
    x2: 675.16,
    y2: 490.6
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.03,
    y1: 490.6,
    x2: 675.16,
    y2: 490.6
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 490.6 674.1 490.6 674.1 490.72 676.22 490.72 676.22 490.6 675.24 490.6"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 490.6,
    x2: 675.24,
    y2: 490.6
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 490.6,
    x2: 675.16,
    y2: 488.93
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 488.85 675.16 488.85 675.16 488.93"
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 488.85 676.22 488.85 676.22 488.64"
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 437.4 674.1 437.4 674.1 437.48 675.03 437.48"
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.16 437.69 675.16 437.48 675.03 437.48"
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 437.69,
    x2: 675.16,
    y2: 439.27
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.03,
    y1: 439.27,
    x2: 675.16,
    y2: 439.27
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 439.27 674.1 439.27 674.1 439.48 676.22 439.48 676.22 439.27 675.24 439.27"
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 439.27,
    x2: 675.24,
    y2: 439.27
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 439.27,
    x2: 675.16,
    y2: 437.69
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 437.48 675.16 437.48 675.16 437.69"
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 437.48 676.22 437.48 676.22 437.4"
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 334.71 674.1 334.71 674.1 334.92 675.03 334.92"
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 334.92,
    x2: 675.03,
    y2: 334.92
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 334.92,
    x2: 675.16,
    y2: 336.66
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.03,
    y1: 336.66,
    x2: 675.16,
    y2: 336.66
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 336.66 674.1 336.66 674.1 336.79 676.22 336.79 676.22 336.66 675.24 336.66"
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 336.66,
    x2: 675.24,
    y2: 336.66
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 336.66,
    x2: 675.16,
    y2: 334.92
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 334.92,
    x2: 675.16,
    y2: 334.92
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 334.92 676.22 334.92 676.22 334.71"
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 232.14 674.1 232.14 674.1 232.35 675.03 232.35"
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 232.35,
    x2: 675.03,
    y2: 232.35
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 232.35,
    x2: 675.16,
    y2: 233.89
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 234.1 675.16 234.1 675.16 233.89"
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 234.1 674.1 234.1 674.1 234.22 676.22 234.22 676.22 234.1 675.24 234.1"
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.16 233.89 675.16 234.1 675.24 234.1"
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 233.89,
    x2: 675.16,
    y2: 232.35
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 232.35,
    x2: 675.16,
    y2: 232.35
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 232.35 676.22 232.35 676.22 232.14"
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 129.54 674.1 129.54 674.1 129.66 675.03 129.66"
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 129.66,
    x2: 675.03,
    y2: 129.66
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 129.66,
    x2: 675.16,
    y2: 131.32
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 131.53 675.16 131.53 675.16 131.32"
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 131.53 674.1 131.53 676.22 131.53 675.24 131.53"
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.16 131.32 675.16 131.53 675.24 131.53"
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 131.32,
    x2: 675.16,
    y2: 129.66
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 129.66,
    x2: 675.16,
    y2: 129.66
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 129.66 676.22 129.66 676.22 129.54"
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 78.21 674.1 78.21 674.1 78.42 675.03 78.42"
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 78.42,
    x2: 675.03,
    y2: 78.42
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 78.42,
    x2: 675.16,
    y2: 80.08
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 80.17 675.16 80.17 675.16 80.08"
  })), _polyline67 || (_polyline67 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 80.17 674.1 80.17 676.22 80.17 675.24 80.17"
  })), _polyline68 || (_polyline68 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.16 80.08 675.16 80.17 675.24 80.17"
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 80.08,
    x2: 675.16,
    y2: 78.42
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 78.42,
    x2: 675.16,
    y2: 78.42
  })), _polyline69 || (_polyline69 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 78.42 676.22 78.42 676.22 78.21"
  })), _polyline70 || (_polyline70 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 488.64 607.74 488.64 607.74 488.85 608.46 488.85"
  })), _polyline71 || (_polyline71 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.58 488.93 608.58 488.85 608.46 488.85"
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 488.93,
    x2: 608.58,
    y2: 490.6
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.46,
    y1: 490.6,
    x2: 608.58,
    y2: 490.6
  })), _polyline72 || (_polyline72 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 490.6 607.74 490.6 607.74 490.72 609.64 490.72 609.64 490.6 608.8 490.6"
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 490.6,
    x2: 608.8,
    y2: 490.6
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 490.6,
    x2: 608.58,
    y2: 488.93
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 488.85,
    x2: 608.58,
    y2: 488.93
  })), _polyline73 || (_polyline73 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 488.85 609.64 488.85 609.64 488.64"
  })), _polyline74 || (_polyline74 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 437.4 607.74 437.4 607.74 437.48 608.46 437.48"
  })), _polyline75 || (_polyline75 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.58 437.69 608.58 437.48 608.46 437.48"
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 437.69,
    x2: 608.58,
    y2: 439.27
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.46,
    y1: 439.27,
    x2: 608.58,
    y2: 439.27
  })), _polyline76 || (_polyline76 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 439.27 607.74 439.27 607.74 439.48 609.64 439.48 609.64 439.27 608.8 439.27"
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 439.27,
    x2: 608.8,
    y2: 439.27
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 439.27,
    x2: 608.58,
    y2: 437.69
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 437.48,
    x2: 608.58,
    y2: 437.69
  })), _polyline77 || (_polyline77 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 437.48 609.64 437.48 609.64 437.4"
  })), _polyline78 || (_polyline78 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 334.71 607.74 334.71 607.74 334.92 608.46 334.92"
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 334.92,
    x2: 608.46,
    y2: 334.92
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 334.92,
    x2: 608.58,
    y2: 336.66
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.46,
    y1: 336.66,
    x2: 608.58,
    y2: 336.66
  })), _polyline79 || (_polyline79 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 336.66 607.74 336.66 607.74 336.79 609.64 336.79 609.64 336.66 608.8 336.66"
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 336.66,
    x2: 608.8,
    y2: 336.66
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 336.66,
    x2: 608.58,
    y2: 334.92
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 334.92,
    x2: 608.58,
    y2: 334.92
  })), _polyline80 || (_polyline80 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 334.92 609.64 334.92 609.64 334.71"
  })), _polyline81 || (_polyline81 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 232.14 607.74 232.14 607.74 232.35 608.46 232.35"
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 232.35,
    x2: 608.46,
    y2: 232.35
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 232.35,
    x2: 608.58,
    y2: 233.89
  })), _polyline82 || (_polyline82 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 234.1 608.58 234.1 608.58 233.89"
  })), _polyline83 || (_polyline83 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 234.1 607.74 234.1 607.74 234.22 609.64 234.22 609.64 234.1 608.8 234.1"
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 233.89,
    x2: 608.8,
    y2: 234.1
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 233.89,
    x2: 608.58,
    y2: 232.35
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 232.35,
    x2: 608.58,
    y2: 232.35
  })), _polyline84 || (_polyline84 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 232.35 609.64 232.35 609.64 232.14"
  })), _polyline85 || (_polyline85 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 129.54 607.74 129.54 607.74 129.66 608.46 129.66"
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 129.66,
    x2: 608.46,
    y2: 129.66
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 129.66,
    x2: 608.58,
    y2: 131.32
  })), _polyline86 || (_polyline86 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 131.53 608.58 131.53 608.58 131.32"
  })), _polyline87 || (_polyline87 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 131.53 607.74 131.53 609.64 131.53 608.8 131.53"
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 131.32,
    x2: 608.8,
    y2: 131.53
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 131.32,
    x2: 608.58,
    y2: 129.66
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 129.66,
    x2: 608.58,
    y2: 129.66
  })), _polyline88 || (_polyline88 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 129.66 609.64 129.66 609.64 129.54"
  })), _polyline89 || (_polyline89 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 78.21 607.74 78.21 607.74 78.42 608.46 78.42"
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 78.42,
    x2: 608.46,
    y2: 78.42
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 78.42,
    x2: 608.58,
    y2: 80.08
  })), _polyline90 || (_polyline90 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 80.17 608.58 80.17 608.58 80.08"
  })), _polyline91 || (_polyline91 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 80.17 607.74 80.17 609.64 80.17 608.8 80.17"
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 80.08,
    x2: 608.8,
    y2: 80.17
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 80.08,
    x2: 608.58,
    y2: 78.42
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 78.42,
    x2: 608.58,
    y2: 78.42
  })), _polyline92 || (_polyline92 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 78.42 609.64 78.42 609.64 78.21"
  })), _polyline93 || (_polyline93 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 488.64 541.16 488.64 541.16 488.85 542.01 488.85"
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 488.93,
    x2: 542.01,
    y2: 488.85
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 488.93,
    x2: 542.01,
    y2: 490.6
  })), _polyline94 || (_polyline94 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 490.6 541.16 490.6 541.16 490.72 543.07 490.72 543.07 490.6 542.22 490.6"
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 490.6,
    x2: 542.22,
    y2: 488.93
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 488.85,
    x2: 542.22,
    y2: 488.93
  })), _polyline95 || (_polyline95 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 488.85 543.07 488.85 543.07 488.64"
  })), _polyline96 || (_polyline96 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 437.4 541.16 437.4 541.16 437.48 542.01 437.48"
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 437.69,
    x2: 542.01,
    y2: 437.48
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 437.69,
    x2: 542.01,
    y2: 439.27
  })), _polyline97 || (_polyline97 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 439.27 541.16 439.27 541.16 439.48 543.07 439.48 543.07 439.27 542.22 439.27"
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 439.27,
    x2: 542.22,
    y2: 437.69
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 437.48,
    x2: 542.22,
    y2: 437.69
  })), _polyline98 || (_polyline98 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 437.48 543.07 437.48 543.07 437.4"
  })), _polyline99 || (_polyline99 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 334.71 541.16 334.71 541.16 334.92 542.01 334.92"
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 334.92,
    x2: 542.01,
    y2: 336.66
  })), _polyline100 || (_polyline100 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 336.66 541.16 336.66 541.16 336.79 543.07 336.79 543.07 336.66 542.22 336.66"
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 336.66,
    x2: 542.22,
    y2: 334.92
  })), _polyline101 || (_polyline101 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 334.92 543.07 334.92 543.07 334.71"
  })), _polyline102 || (_polyline102 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 232.14 541.16 232.14 541.16 232.35 542.01 232.35"
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 232.35,
    x2: 542.01,
    y2: 233.89
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 234.1,
    x2: 542.01,
    y2: 233.89
  })), _polyline103 || (_polyline103 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 234.1 541.16 234.1 541.16 234.22 543.07 234.22 543.07 234.1 542.22 234.1"
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 233.89,
    x2: 542.22,
    y2: 234.1
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 233.89,
    x2: 542.22,
    y2: 232.35
  })), _polyline104 || (_polyline104 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 232.35 543.07 232.35 543.07 232.14"
  })), _polyline105 || (_polyline105 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 129.54 541.16 129.54 541.16 129.66 542.01 129.66"
  })), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 129.66,
    x2: 542.01,
    y2: 131.32
  })), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 131.53,
    x2: 542.01,
    y2: 131.32
  })), _polyline106 || (_polyline106 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 131.53 541.16 131.53 543.07 131.53 542.22 131.53"
  })), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 131.32,
    x2: 542.22,
    y2: 131.53
  })), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 131.32,
    x2: 542.22,
    y2: 129.66
  })), _polyline107 || (_polyline107 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 129.66 543.07 129.66 543.07 129.54"
  })), _polyline108 || (_polyline108 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 78.21 541.16 78.21 541.16 78.42 542.01 78.42"
  })), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 78.42,
    x2: 542.01,
    y2: 80.08
  })), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 80.17,
    x2: 542.01,
    y2: 80.08
  })), _polyline109 || (_polyline109 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 80.17 541.16 80.17 543.07 80.17 542.22 80.17"
  })), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 80.08,
    x2: 542.22,
    y2: 80.17
  })), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 80.08,
    x2: 542.22,
    y2: 78.42
  })), _polyline110 || (_polyline110 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 78.42 543.07 78.42 543.07 78.21"
  })), _polyline111 || (_polyline111 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 488.64 474.59 488.64 474.59 488.85 475.57 488.85"
  })), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 488.93,
    x2: 475.57,
    y2: 488.85
  })), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 488.93,
    x2: 475.57,
    y2: 490.6
  })), _polyline112 || (_polyline112 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 490.6 474.59 490.6 474.59 490.72 476.63 490.72 476.63 490.6 475.65 490.6"
  })), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 490.6,
    x2: 475.65,
    y2: 488.93
  })), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 488.85,
    x2: 475.65,
    y2: 488.93
  })), _polyline113 || (_polyline113 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 488.85 476.63 488.85 476.63 488.64"
  })), _polyline114 || (_polyline114 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 437.4 474.59 437.4 474.59 437.48 475.57 437.48"
  })), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 437.69,
    x2: 475.57,
    y2: 437.48
  })), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 437.69,
    x2: 475.57,
    y2: 439.27
  })), _polyline115 || (_polyline115 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 439.27 474.59 439.27 474.59 439.48 476.63 439.48 476.63 439.27 475.65 439.27"
  })), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 439.27,
    x2: 475.65,
    y2: 437.69
  })), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 437.48,
    x2: 475.65,
    y2: 437.69
  })), _polyline116 || (_polyline116 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 437.48 476.63 437.48 476.63 437.4"
  })), _polyline117 || (_polyline117 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 334.71 474.59 334.71 474.59 334.92 475.57 334.92"
  })), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 334.92,
    x2: 475.57,
    y2: 336.66
  })), _polyline118 || (_polyline118 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 336.66 474.59 336.66 474.59 336.79 476.63 336.79 476.63 336.66 475.65 336.66"
  })), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 336.66,
    x2: 475.65,
    y2: 334.92
  })), _polyline119 || (_polyline119 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 334.92 476.63 334.92 476.63 334.71"
  })), _polyline120 || (_polyline120 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 232.14 474.59 232.14 474.59 232.35 475.57 232.35"
  })), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 232.35,
    x2: 475.57,
    y2: 233.89
  })), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 234.1,
    x2: 475.57,
    y2: 233.89
  })), _polyline121 || (_polyline121 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 234.1 474.59 234.1 474.59 234.22 476.63 234.22 476.63 234.1 475.65 234.1"
  })), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 233.89,
    x2: 475.65,
    y2: 234.1
  })), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 233.89,
    x2: 475.65,
    y2: 232.35
  })), _polyline122 || (_polyline122 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 232.35 476.63 232.35 476.63 232.14"
  })), _polyline123 || (_polyline123 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 129.54 474.59 129.54 474.59 129.66 475.57 129.66"
  })), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 129.66,
    x2: 475.57,
    y2: 131.32
  })), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 131.53,
    x2: 475.57,
    y2: 131.32
  })), _polyline124 || (_polyline124 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 131.53 474.59 131.53 476.63 131.53 475.65 131.53"
  })), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 131.32,
    x2: 475.65,
    y2: 131.53
  })), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 131.32,
    x2: 475.65,
    y2: 129.66
  })), _polyline125 || (_polyline125 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 129.66 476.63 129.66 476.63 129.54"
  })), _polyline126 || (_polyline126 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 78.21 474.59 78.21 474.59 78.42 475.57 78.42"
  })), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 78.42,
    x2: 475.57,
    y2: 80.08
  })), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 80.17,
    x2: 475.57,
    y2: 80.08
  })), _polyline127 || (_polyline127 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 80.17 474.59 80.17 476.63 80.17 475.65 80.17"
  })), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 80.08,
    x2: 475.65,
    y2: 80.17
  })), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 80.08,
    x2: 475.65,
    y2: 78.42
  })), _polyline128 || (_polyline128 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 78.42 476.63 78.42 476.63 78.21"
  })), _polyline129 || (_polyline129 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 78.21 408.02 78.21 408.02 78.42 408.99 78.42"
  })), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 78.42,
    x2: 408.99,
    y2: 78.42
  })), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 78.42,
    x2: 409.08,
    y2: 80.08
  })), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 80.17,
    x2: 409.08,
    y2: 80.08
  })), _polyline130 || (_polyline130 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 80.17 408.02 80.17 410.06 80.17 409.08 80.17"
  })), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 80.08,
    x2: 409.08,
    y2: 80.17
  })), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 80.08,
    x2: 409.08,
    y2: 78.42
  })), _polyline131 || (_polyline131 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 78.42 410.06 78.42 410.06 78.21"
  })), _polyline132 || (_polyline132 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 129.54 408.02 129.54 408.02 129.66 408.99 129.66"
  })), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 129.66,
    x2: 408.99,
    y2: 129.66
  })), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 129.66,
    x2: 409.08,
    y2: 131.32
  })), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 131.53,
    x2: 409.08,
    y2: 131.32
  })), _polyline133 || (_polyline133 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 131.53 408.02 131.53 410.06 131.53 409.08 131.53"
  })), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 131.32,
    x2: 409.08,
    y2: 131.53
  })), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 131.32,
    x2: 409.08,
    y2: 129.66
  })), _polyline134 || (_polyline134 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 129.66 410.06 129.66 410.06 129.54"
  })), _polyline135 || (_polyline135 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 232.14 408.02 232.14 408.02 232.35 408.99 232.35"
  })), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 232.35,
    x2: 408.99,
    y2: 232.35
  })), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 232.35,
    x2: 409.08,
    y2: 233.89
  })), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 234.1,
    x2: 409.08,
    y2: 233.89
  })), _polyline136 || (_polyline136 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 234.1 408.02 234.1 408.02 234.22 410.06 234.22 410.06 234.1 409.08 234.1"
  })), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 233.89,
    x2: 409.08,
    y2: 234.1
  })), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 233.89,
    x2: 409.08,
    y2: 232.35
  })), _polyline137 || (_polyline137 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 232.35 410.06 232.35 410.06 232.14"
  })), _polyline138 || (_polyline138 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 334.71 408.02 334.71 408.02 334.92 408.99 334.92"
  })), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 334.92,
    x2: 408.99,
    y2: 334.92
  })), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 334.92,
    x2: 409.08,
    y2: 336.66
  })), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 336.66,
    x2: 409.08,
    y2: 336.66
  })), _polyline139 || (_polyline139 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 336.66 408.02 336.66 408.02 336.79 410.06 336.79 410.06 336.66 409.08 336.66"
  })), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 336.66,
    x2: 409.08,
    y2: 334.92
  })), _polyline140 || (_polyline140 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 334.92 410.06 334.92 410.06 334.71"
  })), _polyline141 || (_polyline141 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 437.4 408.02 437.4 408.02 437.48 408.99 437.48"
  })), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 437.69,
    x2: 408.99,
    y2: 437.48
  })), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 437.69,
    x2: 409.08,
    y2: 439.27
  })), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 439.27,
    x2: 409.08,
    y2: 439.27
  })), _polyline142 || (_polyline142 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 439.27 408.02 439.27 408.02 439.48 410.06 439.48 410.06 439.27 409.08 439.27"
  })), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 439.27,
    x2: 409.08,
    y2: 437.69
  })), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 437.48,
    x2: 409.08,
    y2: 437.69
  })), _polyline143 || (_polyline143 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 437.48 410.06 437.48 410.06 437.4"
  })), _polyline144 || (_polyline144 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 488.64 408.02 488.64 408.02 488.85 408.99 488.85"
  })), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 488.93,
    x2: 408.99,
    y2: 488.85
  })), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 488.93,
    x2: 409.08,
    y2: 490.6
  })), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 490.6,
    x2: 409.08,
    y2: 490.6
  })), _polyline145 || (_polyline145 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 490.6 408.02 490.6 408.02 490.72 410.06 490.72 410.06 490.6 409.08 490.6"
  })), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 490.6,
    x2: 409.08,
    y2: 488.93
  })), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 488.85,
    x2: 409.08,
    y2: 488.93
  })), _polyline146 || (_polyline146 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 488.85 410.06 488.85 410.06 488.64"
  })), _polyline147 || (_polyline147 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 540.08 408.02 540.08 408.99 540.08"
  })), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 540.29,
    x2: 408.99,
    y2: 540.08
  })), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 540.29,
    x2: 409.08,
    y2: 541.85
  })), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 541.85,
    x2: 409.08,
    y2: 541.85
  })), _polyline148 || (_polyline148 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 541.85 408.02 541.85 408.02 542.06 410.06 542.06 410.06 541.85 409.08 541.85"
  })), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 541.85,
    x2: 409.08,
    y2: 540.29
  })), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 540.08,
    x2: 409.08,
    y2: 540.29
  })), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 540.08,
    x2: 410.06,
    y2: 540.08
  })), _polyline149 || (_polyline149 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 586.63 408.02 586.63 408.02 586.84 408.99 586.84"
  })), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 586.84,
    x2: 408.99,
    y2: 586.84
  })), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 586.84,
    x2: 409.08,
    y2: 588.61
  })), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 588.61,
    x2: 409.08,
    y2: 588.61
  })), _polyline150 || (_polyline150 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 588.61 408.02 588.61 408.02 588.71 410.06 588.71 410.06 588.61 409.08 588.61"
  })), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 588.61,
    x2: 409.08,
    y2: 586.84
  })), _polyline151 || (_polyline151 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 586.84 410.06 586.84 410.06 586.63"
  })), _polyline152 || (_polyline152 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 633.39 807.11 633.39 807.11 633.5 808.05 633.5"
  })), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 633.5,
    x2: 808.05,
    y2: 635.16
  })), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 635.27,
    x2: 808.05,
    y2: 635.16
  })), _polyline153 || (_polyline153 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 635.27 807.11 635.27 809.11 635.27 808.17 635.27"
  })), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 635.16,
    x2: 808.17,
    y2: 635.27
  })), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 635.16,
    x2: 808.17,
    y2: 633.5
  })), _polyline154 || (_polyline154 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 633.5 809.11 633.5 809.11 633.39"
  })), _polyline155 || (_polyline155 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 633.39 740.62 633.39 740.62 633.5 741.47 633.5"
  })), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 633.5,
    x2: 741.47,
    y2: 633.5
  })), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 633.5,
    x2: 741.69,
    y2: 635.16
  })), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.47,
    y1: 635.27,
    x2: 741.69,
    y2: 635.16
  })), _polyline156 || (_polyline156 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.47 635.27 740.62 635.27 742.53 635.27 741.81 635.27"
  })), _polyline157 || (_polyline157 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.69 635.16 741.69 635.27 741.81 635.27"
  })), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.69,
    y1: 635.16,
    x2: 741.69,
    y2: 633.5
  })), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 633.5,
    x2: 741.69,
    y2: 633.5
  })), _polyline158 || (_polyline158 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.81 633.5 742.53 633.5 742.53 633.39"
  })), _polyline159 || (_polyline159 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "676.22 633.39 674.1 633.39 674.1 633.5 675.03 633.5"
  })), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 633.5,
    x2: 675.03,
    y2: 633.5
  })), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 633.5,
    x2: 675.16,
    y2: 635.16
  })), _polyline160 || (_polyline160 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 635.27 675.16 635.27 675.16 635.16"
  })), _polyline161 || (_polyline161 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.03 635.27 674.1 635.27 676.22 635.27 675.24 635.27"
  })), _polyline162 || (_polyline162 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.16 635.16 675.16 635.27 675.24 635.27"
  })), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.16,
    y1: 635.16,
    x2: 675.16,
    y2: 633.5
  })), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 633.5,
    x2: 675.16,
    y2: 633.5
  })), _polyline163 || (_polyline163 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "675.24 633.5 676.22 633.5 676.22 633.39"
  })), _polyline164 || (_polyline164 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "609.64 633.39 607.74 633.39 607.74 633.5 608.46 633.5"
  })), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 633.5,
    x2: 608.46,
    y2: 633.5
  })), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 633.5,
    x2: 608.58,
    y2: 635.16
  })), _polyline165 || (_polyline165 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 635.27 608.58 635.27 608.58 635.16"
  })), _polyline166 || (_polyline166 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.46 635.27 607.74 635.27 609.64 635.27 608.8 635.27"
  })), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 635.16,
    x2: 608.8,
    y2: 635.27
  })), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.58,
    y1: 635.16,
    x2: 608.58,
    y2: 633.5
  })), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 633.5,
    x2: 608.58,
    y2: 633.5
  })), _polyline167 || (_polyline167 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "608.8 633.5 609.64 633.5 609.64 633.39"
  })), _polyline168 || (_polyline168 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 633.39 541.16 633.39 541.16 633.5 542.01 633.5"
  })), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 633.5,
    x2: 542.01,
    y2: 635.16
  })), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 635.27,
    x2: 542.01,
    y2: 635.16
  })), _polyline169 || (_polyline169 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.01 635.27 541.16 635.27 543.07 635.27 542.22 635.27"
  })), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 635.16,
    x2: 542.22,
    y2: 635.27
  })), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 635.16,
    x2: 542.22,
    y2: 633.5
  })), _polyline170 || (_polyline170 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.22 633.5 543.07 633.5 543.07 633.39"
  })), _polyline171 || (_polyline171 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 633.39 474.59 633.39 474.59 633.5 475.57 633.5"
  })), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 633.5,
    x2: 475.57,
    y2: 635.16
  })), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.57,
    y1: 635.27,
    x2: 475.57,
    y2: 635.16
  })), _polyline172 || (_polyline172 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.57 635.27 474.59 635.27 476.63 635.27 475.65 635.27"
  })), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 635.16,
    x2: 475.65,
    y2: 635.27
  })), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 635.16,
    x2: 475.65,
    y2: 633.5
  })), _polyline173 || (_polyline173 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.65 633.5 476.63 633.5 476.63 633.39"
  })), _polyline174 || (_polyline174 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "410.06 633.39 408.02 633.39 408.02 633.5 408.99 633.5"
  })), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 633.5,
    x2: 408.99,
    y2: 633.5
  })), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 633.5,
    x2: 409.08,
    y2: 635.16
  })), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 635.27,
    x2: 409.08,
    y2: 635.16
  })), _polyline175 || (_polyline175 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 635.27 408.02 635.27 410.06 635.27 409.08 635.27"
  })), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 635.16,
    x2: 409.08,
    y2: 635.27
  })), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 635.16,
    x2: 409.08,
    y2: 633.5
  })), _polyline176 || (_polyline176 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 633.5 410.06 633.5 410.06 633.39"
  })), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 807.32,
    y1: 541.85,
    x2: 807.41,
    y2: 541.85
  })), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 740.75,
    y1: 541.85,
    x2: 740.96,
    y2: 541.85
  })), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 676.09,
    y1: 541.85,
    x2: 676.22,
    y2: 541.85
  })), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 674.18,
    y1: 541.85,
    x2: 674.39,
    y2: 541.85
  })), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 609.52,
    y1: 541.85,
    x2: 609.64,
    y2: 541.85
  })), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.94,
    y1: 541.85,
    x2: 543.07,
    y2: 541.85
  })), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 541.29,
    y1: 541.85,
    x2: 541.5,
    y2: 541.85
  })), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 476.42,
    y1: 541.85,
    x2: 476.63,
    y2: 541.85
  })), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 474.8,
    y1: 541.85,
    x2: 474.93,
    y2: 541.85
  })), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.02,
    y1: 540.08,
    x2: 807.32,
    y2: 540.08
  })), _polyline177 || (_polyline177 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 540.29 809.02 540.29 809.02 540.08"
  })), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.11,
    y1: 541.85,
    x2: 809.11,
    y2: 540.29
  })), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.02,
    y1: 540.08,
    x2: 807.32,
    y2: 540.08
  })), _polyline178 || (_polyline178 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 540.29 809.11 540.08 809.02 540.08"
  })), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.11,
    y1: 541.85,
    x2: 809.11,
    y2: 540.29
  })), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.32,
    y1: 540.29,
    x2: 807.32,
    y2: 541.85
  })), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.32,
    y1: 540.08,
    x2: 807.32,
    y2: 540.29
  })), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.11,
    y1: 540.29,
    x2: 807.11,
    y2: 541.85
  })), _polyline179 || (_polyline179 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "807.32 540.08 807.11 540.08 807.11 540.29"
  })), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.02,
    y1: 541.85,
    x2: 809.11,
    y2: 541.85
  })), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.32,
    y1: 541.85,
    x2: 809.02,
    y2: 541.85
  })), _polyline180 || (_polyline180 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.02 542.06 809.11 542.06 809.11 541.85"
  })), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.32,
    y1: 542.06,
    x2: 809.02,
    y2: 542.06
  })), _polyline181 || (_polyline181 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "807.11 541.85 807.11 542.06 807.32 542.06"
  })), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.45,
    y1: 540.08,
    x2: 740.75,
    y2: 540.08
  })), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.53,
    y1: 540.29,
    x2: 742.45,
    y2: 540.08
  })), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.53,
    y1: 541.85,
    x2: 742.53,
    y2: 540.29
  })), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.45,
    y1: 540.08,
    x2: 740.75,
    y2: 540.08
  })), _polyline182 || (_polyline182 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.53 540.29 742.53 540.08 742.45 540.08"
  })), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.53,
    y1: 541.85,
    x2: 742.53,
    y2: 540.29
  })), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 540.29,
    x2: 740.75,
    y2: 541.85
  })), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 540.08,
    x2: 740.75,
    y2: 540.29
  })), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.62,
    y1: 540.29,
    x2: 740.62,
    y2: 541.85
  })), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 540.08,
    x2: 740.62,
    y2: 540.29
  })), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.45,
    y1: 541.85,
    x2: 742.53,
    y2: 541.85
  })), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 541.85,
    x2: 742.45,
    y2: 541.85
  })), _polyline183 || (_polyline183 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "742.45 542.06 742.53 542.06 742.53 541.85"
  })), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 542.06,
    x2: 742.45,
    y2: 542.06
  })), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.62,
    y1: 541.85,
    x2: 740.75,
    y2: 542.06
  })), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.09,
    y1: 540.08,
    x2: 674.18,
    y2: 540.08
  })), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.09,
    y1: 540.29,
    x2: 676.09,
    y2: 540.08
  })), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.09,
    y1: 541.85,
    x2: 676.09,
    y2: 540.29
  })), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.09,
    y1: 540.08,
    x2: 674.18,
    y2: 540.08
  })), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.22,
    y1: 540.29,
    x2: 676.09,
    y2: 540.08
  })), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.22,
    y1: 541.85,
    x2: 676.22,
    y2: 540.29
  })), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 540.29,
    x2: 674.18,
    y2: 541.85
  })), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 540.08,
    x2: 674.18,
    y2: 540.29
  })), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.1,
    y1: 540.29,
    x2: 674.1,
    y2: 541.85
  })), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 540.08,
    x2: 674.1,
    y2: 540.29
  })), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 541.85,
    x2: 676.09,
    y2: 541.85
  })), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 676.09,
    y1: 542.06,
    x2: 676.22,
    y2: 541.85
  })), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 542.06,
    x2: 676.09,
    y2: 542.06
  })), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.1,
    y1: 541.85,
    x2: 674.18,
    y2: 542.06
  })), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.52,
    y1: 540.08,
    x2: 607.82,
    y2: 540.08
  })), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.52,
    y1: 540.29,
    x2: 609.52,
    y2: 540.08
  })), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.52,
    y1: 541.85,
    x2: 609.52,
    y2: 540.29
  })), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.52,
    y1: 540.08,
    x2: 607.82,
    y2: 540.08
  })), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.64,
    y1: 540.29,
    x2: 609.52,
    y2: 540.08
  })), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.64,
    y1: 541.85,
    x2: 609.64,
    y2: 540.29
  })), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.74,
    y1: 540.29,
    x2: 607.74,
    y2: 541.85
  })), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.82,
    y1: 540.08,
    x2: 607.74,
    y2: 540.29
  })), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.74,
    y1: 540.29,
    x2: 607.74,
    y2: 541.85
  })), _polyline184 || (_polyline184 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "607.82 540.08 607.74 540.08 607.74 540.29"
  })), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.82,
    y1: 541.85,
    x2: 609.52,
    y2: 541.85
  })), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.52,
    y1: 542.06,
    x2: 609.64,
    y2: 541.85
  })), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.82,
    y1: 542.06,
    x2: 609.52,
    y2: 542.06
  })), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.74,
    y1: 541.85,
    x2: 607.82,
    y2: 541.85
  })), _polyline185 || (_polyline185 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "607.74 541.85 607.74 542.06 607.82 542.06"
  })), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.94,
    y1: 540.08,
    x2: 541.29,
    y2: 540.08
  })), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.94,
    y1: 540.29,
    x2: 542.94,
    y2: 540.08
  })), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.94,
    y1: 541.85,
    x2: 542.94,
    y2: 540.29
  })), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.94,
    y1: 540.08,
    x2: 541.29,
    y2: 540.08
  })), _polyline186 || (_polyline186 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.07 540.29 543.07 540.08 542.94 540.08"
  })), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 543.07,
    y1: 541.85,
    x2: 543.07,
    y2: 540.29
  })), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.29,
    y1: 540.29,
    x2: 541.29,
    y2: 541.85
  })), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.29,
    y1: 540.08,
    x2: 541.29,
    y2: 540.29
  })), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.16,
    y1: 540.29,
    x2: 541.16,
    y2: 541.85
  })), _polyline187 || (_polyline187 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "541.29 540.08 541.16 540.08 541.16 540.29"
  })), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.29,
    y1: 541.85,
    x2: 542.94,
    y2: 541.85
  })), _polyline188 || (_polyline188 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "542.94 542.06 543.07 542.06 543.07 541.85"
  })), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.29,
    y1: 542.06,
    x2: 542.94,
    y2: 542.06
  })), _polyline189 || (_polyline189 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "541.16 541.85 541.16 542.06 541.29 542.06"
  })), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.42,
    y1: 540.08,
    x2: 474.8,
    y2: 540.08
  })), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.42,
    y1: 540.29,
    x2: 476.42,
    y2: 540.08
  })), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.42,
    y1: 541.85,
    x2: 476.42,
    y2: 540.29
  })), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.42,
    y1: 540.08,
    x2: 474.8,
    y2: 540.08
  })), _polyline190 || (_polyline190 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.63 540.29 476.63 540.08 476.42 540.08"
  })), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.63,
    y1: 541.85,
    x2: 476.63,
    y2: 540.29
  })), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.8,
    y1: 540.29,
    x2: 474.8,
    y2: 541.85
  })), _line359 || (_line359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.8,
    y1: 540.08,
    x2: 474.8,
    y2: 540.29
  })), _line360 || (_line360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.59,
    y1: 540.29,
    x2: 474.59,
    y2: 541.85
  })), _polyline191 || (_polyline191 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "474.8 540.08 474.59 540.08 474.59 540.29"
  })), _line361 || (_line361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.8,
    y1: 541.85,
    x2: 476.42,
    y2: 541.85
  })), _polyline192 || (_polyline192 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "476.42 542.06 476.63 542.06 476.63 541.85"
  })), _line362 || (_line362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.8,
    y1: 542.06,
    x2: 476.42,
    y2: 542.06
  })), _polyline193 || (_polyline193 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "474.59 541.85 474.59 542.06 474.8 542.06"
  })), _line363 || (_line363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 166.43,
    x2: 409.29,
    y2: 166.43
  })), _line364 || (_line364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 164.64,
    x2: 409.29,
    y2: 164.64
  })), _line365 || (_line365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 402.59,
    x2: 409.29,
    y2: 402.59
  })), _line366 || (_line366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 409.08,
    y1: 371.69,
    x2: 409.29,
    y2: 371.69
  })), _line367 || (_line367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 586.84,
    x2: 808.17,
    y2: 586.84
  })), _line368 || (_line368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.05,
    y1: 588.61,
    x2: 808.17,
    y2: 588.61
  })), _line369 || (_line369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 588.61,
    x2: 808.39,
    y2: 588.61
  })), _line370 || (_line370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 808.17,
    y1: 586.84,
    x2: 808.39,
    y2: 586.84
  })), _polyline194 || (_polyline194 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.02 166.64 410.06 166.64 410.06 166.43 409.08 166.43"
  })), _line371 || (_line371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 166.43,
    x2: 409.08,
    y2: 164.64
  })), _polyline195 || (_polyline195 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 164.64 410.06 164.64 410.06 164.51 408.02 164.51 408.02 164.64 408.99 164.64"
  })), _line372 || (_line372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 164.64,
    x2: 408.99,
    y2: 164.64
  })), _line373 || (_line373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 164.64,
    x2: 409.08,
    y2: 166.43
  })), _line374 || (_line374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 166.43,
    x2: 409.08,
    y2: 166.43
  })), _polyline196 || (_polyline196 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 166.43 408.02 166.43 408.02 166.64"
  })), _polyline197 || (_polyline197 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.02 199.12 410.06 199.12 409.08 199.12"
  })), _line375 || (_line375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 198.99,
    x2: 409.08,
    y2: 199.12
  })), _line376 || (_line376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 198.99,
    x2: 409.08,
    y2: 197.33
  })), _line377 || (_line377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 197.25,
    x2: 409.08,
    y2: 197.33
  })), _polyline198 || (_polyline198 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 197.25 410.06 197.25 408.02 197.25 408.99 197.25"
  })), _polyline199 || (_polyline199 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 197.33 408.99 197.33 408.99 197.25"
  })), _line378 || (_line378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 197.33,
    x2: 409.08,
    y2: 198.99
  })), _polyline200 || (_polyline200 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 199.12 408.99 198.99 409.08 198.99"
  })), _line379 || (_line379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 199.12,
    x2: 408.02,
    y2: 199.12
  })), _polyline201 || (_polyline201 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.02 404.5 410.06 404.5 410.06 404.38 409.08 404.38"
  })), _line380 || (_line380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 404.17,
    x2: 409.08,
    y2: 404.38
  })), _line381 || (_line381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 404.17,
    x2: 409.08,
    y2: 402.59
  })), _polyline202 || (_polyline202 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 402.59 410.06 402.59 410.06 402.38 408.02 402.38 408.02 402.59 408.99 402.59"
  })), _line382 || (_line382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 402.59,
    x2: 408.99,
    y2: 402.59
  })), _line383 || (_line383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 402.59,
    x2: 409.08,
    y2: 404.17
  })), _line384 || (_line384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 404.38,
    x2: 409.08,
    y2: 404.17
  })), _polyline203 || (_polyline203 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 404.38 408.02 404.38 408.02 404.5"
  })), _polyline204 || (_polyline204 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.02 371.77 410.06 371.77 410.06 371.69 409.08 371.69"
  })), _line385 || (_line385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 371.69,
    x2: 409.08,
    y2: 370.02
  })), _line386 || (_line386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 369.81,
    x2: 409.08,
    y2: 370.02
  })), _polyline205 || (_polyline205 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "409.08 369.81 410.06 369.81 408.02 369.81 408.99 369.81"
  })), _line387 || (_line387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 370.02,
    x2: 408.99,
    y2: 369.81
  })), _line388 || (_line388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 370.02,
    x2: 409.08,
    y2: 371.69
  })), _line389 || (_line389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.99,
    y1: 371.69,
    x2: 409.08,
    y2: 371.69
  })), _polyline206 || (_polyline206 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "408.99 371.69 408.02 371.69 408.02 371.77"
  })), _polyline207 || (_polyline207 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "809.11 586.63 807.11 586.63 807.11 586.84 808.05 586.84"
  })), _line390 || (_line390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.05,
    y1: 586.84,
    x2: 808.05,
    y2: 588.61
  })), _polyline208 || (_polyline208 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.05 588.61 807.11 588.61 807.11 588.71 809.11 588.71 809.11 588.61 808.17 588.61"
  })), _line391 || (_line391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 588.61,
    x2: 808.17,
    y2: 586.84
  })), _polyline209 || (_polyline209 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "808.17 586.84 809.11 586.84 809.11 586.63"
  })), _line392 || (_line392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 170.46,
    x2: 403.48,
    y2: 170.46
  })), _line393 || (_line393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 193.38,
    x2: 409.08,
    y2: 193.38
  })), _line394 || (_line394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 53.84,
    x2: 848.23,
    y2: 61.53
  })), _line395 || (_line395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 375.64,
    x2: 409.08,
    y2: 375.64
  })), _line396 || (_line396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 375.64,
    x2: 848.23,
    y2: 367.94
  })), _line397 || (_line397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 848.23,
    y1: 200.87,
    x2: 848.23,
    y2: 367.94
  })), _line398 || (_line398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 848.23,
    y1: 162.64,
    x2: 848.23,
    y2: 61.53
  })), _line399 || (_line399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 170.46,
    x2: 848.23,
    y2: 162.64
  })), _line400 || (_line400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 193.38,
    x2: 848.23,
    y2: 200.87
  })), _line401 || (_line401 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 840.38,
    y1: 398.55,
    x2: 403.48,
    y2: 398.55
  })), _line402 || (_line402 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 848.23,
    y1: 406.25,
    x2: 840.38,
    y2: 398.55
  })), _line403 || (_line403 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 394.06,
    x2: 403.48,
    y2: 439.98
  })), _line404 || (_line404 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 394.48,
    x2: 402.63,
    y2: 438.94
  })), _line405 || (_line405 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 188.89,
    x2: 403.48,
    y2: 375.64
  })), _line406 || (_line406 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 188.89,
    x2: 402.63,
    y2: 375.64
  })), _line407 || (_line407 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 171,
    x2: 826.38,
    y2: 171
  })), _line408 || (_line408 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 376.26,
    x2: 826.38,
    y2: 376.26
  })), _line409 || (_line409 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 192.76,
    x2: 826.38,
    y2: 192.76
  })), _line410 || (_line410 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 376.26,
    x2: 825.31,
    y2: 277.52
  })), _line411 || (_line411 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 263.46,
    x2: 825.31,
    y2: 192.76
  })), _line412 || (_line412 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 376.26,
    x2: 826.38,
    y2: 277.52
  })), _line413 || (_line413 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 263.46,
    x2: 826.38,
    y2: 192.76
  })), _line414 || (_line414 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 263.46,
    x2: 826.38,
    y2: 263.46
  })), _line415 || (_line415 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 277.52,
    x2: 826.38,
    y2: 277.52
  })), _line416 || (_line416 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 439.98,
    x2: 403.48,
    y2: 436.86
  })), _line417 || (_line417 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.5,
    y1: 285.88,
    x2: 835.5,
    y2: 324.19
  })), _line418 || (_line418 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 285.88,
    x2: 835.07,
    y2: 285.88
  })), _line419 || (_line419 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 174.83,
    x2: 403.48,
    y2: 174.83
  })), _line420 || (_line420 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 188.89,
    x2: 403.48,
    y2: 188.89
  })), _line421 || (_line421 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 124.42,
    x2: 835.07,
    y2: 124.42
  })), _line422 || (_line422 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 126.75,
    x2: 835.07,
    y2: 126.75
  })), _line423 || (_line423 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 128.83,
    x2: 835.07,
    y2: 128.83
  })), _line424 || (_line424 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 130.91,
    x2: 835.07,
    y2: 130.91
  })), _line425 || (_line425 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 133.07,
    x2: 835.07,
    y2: 133.07
  })), _line426 || (_line426 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 135.15,
    x2: 835.07,
    y2: 135.15
  })), _line427 || (_line427 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 137.23,
    x2: 835.07,
    y2: 137.23
  })), _line428 || (_line428 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 139.56,
    x2: 835.07,
    y2: 139.56
  })), _line429 || (_line429 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 141.64,
    x2: 835.07,
    y2: 141.64
  })), _line430 || (_line430 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 143.8,
    x2: 835.07,
    y2: 143.8
  })), _line431 || (_line431 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 145.88,
    x2: 835.07,
    y2: 145.88
  })), _line432 || (_line432 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.07,
    y1: 150.46,
    x2: 835.5,
    y2: 150.46
  })), _line433 || (_line433 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 150.46,
    x2: 826.38,
    y2: 150.46
  })), _line434 || (_line434 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.71,
    y1: 150.17,
    x2: 826.38,
    y2: 150.17
  })), _line435 || (_line435 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.71,
    y1: 375.64,
    x2: 826.71,
    y2: 326.89
  })), _line436 || (_line436 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 355.84,
    x2: 827.14,
    y2: 326.68
  })), _line437 || (_line437 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.5,
    y1: 355.84,
    x2: 835.5,
    y2: 324.19
  })), _line438 || (_line438 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.07,
    y1: 355.84,
    x2: 835.07,
    y2: 324.31
  })), _line439 || (_line439 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 831.38,
    y1: 325.56,
    x2: 835.07,
    y2: 325.56
  })), _line440 || (_line440 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 327.64,
    x2: 835.07,
    y2: 327.64
  })), _line441 || (_line441 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 329.72,
    x2: 835.07,
    y2: 329.72
  })), _line442 || (_line442 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 331.88,
    x2: 835.07,
    y2: 331.88
  })), _line443 || (_line443 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 333.96,
    x2: 835.07,
    y2: 333.96
  })), _line444 || (_line444 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 336.25,
    x2: 835.07,
    y2: 336.25
  })), _line445 || (_line445 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 338.37,
    x2: 835.07,
    y2: 338.37
  })), _line446 || (_line446 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 340.45,
    x2: 835.07,
    y2: 340.45
  })), _line447 || (_line447 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 342.61,
    x2: 835.07,
    y2: 342.61
  })), _line448 || (_line448 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 344.69,
    x2: 835.07,
    y2: 344.69
  })), _line449 || (_line449 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 346.77,
    x2: 835.07,
    y2: 346.77
  })), _line450 || (_line450 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 349.06,
    x2: 835.07,
    y2: 349.06
  })), _line451 || (_line451 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 351.18,
    x2: 835.07,
    y2: 351.18
  })), _line452 || (_line452 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.07,
    y1: 355.84,
    x2: 835.5,
    y2: 355.84
  })), _line453 || (_line453 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 355.84,
    x2: 826.38,
    y2: 355.84
  })), _line454 || (_line454 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.71,
    y1: 355.42,
    x2: 826.38,
    y2: 355.42
  })), _line455 || (_line455 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 824.38,
    y1: 327.43,
    x2: 837.96,
    y2: 323.56
  })), _line456 || (_line456 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 193.38,
    x2: 825.31,
    y2: 193.38
  })), _line457 || (_line457 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 375.64,
    x2: 825.31,
    y2: 375.64
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 402.21,
    y: 181.91,
    width: 0.42,
    height: 6.98
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 402.21,
    y: 188.9,
    width: 0.42,
    height: 6.98
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 402.21,
    y: 174.86,
    width: 0.42,
    height: 7.08
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 402.21,
    y: 167.85,
    width: 0.42,
    height: 6.98
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 401.36,
    y: 167.86,
    width: 0.85,
    height: 28.01
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.38,
    y: 263.45,
    width: 0.32,
    height: 7.08
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.38,
    y: 256.48,
    width: 0.32,
    height: 6.98
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.38,
    y: 270.54,
    width: 0.32,
    height: 6.98
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.38,
    y: 277.53,
    width: 0.32,
    height: 6.98
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.71,
    y: 256.49,
    width: 0.74,
    height: 28.01
  })), _line458 || (_line458 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 78.71,
    x2: 403.48,
    y2: 174.83
  })), _line459 || (_line459 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 78.71,
    x2: 402.63,
    y2: 174.83
  })), _line460 || (_line460 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.17,
    y1: 78.71,
    x2: 501.75,
    y2: 78.71
  })), _line461 || (_line461 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.17,
    y1: 77.67,
    x2: 501.75,
    y2: 77.67
  })), _line462 || (_line462 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.99,
    y1: 77.67,
    x2: 781.99,
    y2: 78.71
  })), _line463 || (_line463 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 767.78,
    y1: 77.67,
    x2: 767.78,
    y2: 78.71
  })), _line464 || (_line464 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.75,
    y1: 77.67,
    x2: 582.49,
    y2: 77.67
  })), _line465 || (_line465 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.49,
    y1: 77.67,
    x2: 634.85,
    y2: 77.67
  })), _line466 || (_line466 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 77.67,
    x2: 715.42,
    y2: 77.67
  })), _line467 || (_line467 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715.42,
    y1: 77.67,
    x2: 767.78,
    y2: 77.67
  })), _line468 || (_line468 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.75,
    y1: 78.71,
    x2: 582.49,
    y2: 78.71
  })), _line469 || (_line469 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.49,
    y1: 78.71,
    x2: 634.85,
    y2: 78.71
  })), _line470 || (_line470 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 78.71,
    x2: 715.42,
    y2: 78.71
  })), _line471 || (_line471 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715.42,
    y1: 78.71,
    x2: 767.78,
    y2: 78.71
  })), _line472 || (_line472 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 410.69,
    y1: 77.67,
    x2: 415.44,
    y2: 77.67
  })), _line473 || (_line473 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423.42,
    y1: 77.67,
    x2: 435.17,
    y2: 77.67
  })), _line474 || (_line474 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 78.71,
    x2: 415.44,
    y2: 78.71
  })), _line475 || (_line475 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423.42,
    y1: 78.71,
    x2: 435.17,
    y2: 78.71
  })), _line476 || (_line476 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 171,
    x2: 825.31,
    y2: 78.71
  })), _line477 || (_line477 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 171,
    x2: 826.38,
    y2: 77.67
  })), _line478 || (_line478 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.99,
    y1: 77.67,
    x2: 814.41,
    y2: 77.67
  })), _line479 || (_line479 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 822.47,
    y1: 77.67,
    x2: 826.38,
    y2: 77.67
  })), _line480 || (_line480 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.99,
    y1: 78.71,
    x2: 814.41,
    y2: 78.71
  })), _line481 || (_line481 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 822.47,
    y1: 78.71,
    x2: 825.31,
    y2: 78.71
  })), _line482 || (_line482 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 78.09,
    x2: 835.5,
    y2: 78.09
  })), _line483 || (_line483 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.5,
    y1: 78.09,
    x2: 835.5,
    y2: 119.01
  })), _line484 || (_line484 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.71,
    y1: 150.17,
    x2: 826.71,
    y2: 121.63
  })), _line485 || (_line485 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 150.46,
    x2: 827.14,
    y2: 121.51
  })), _line486 || (_line486 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.5,
    y1: 150.46,
    x2: 835.5,
    y2: 119.01
  })), _line487 || (_line487 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.07,
    y1: 150.46,
    x2: 835.07,
    y2: 119.14
  })), _line488 || (_line488 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 831.38,
    y1: 120.18,
    x2: 835.07,
    y2: 120.18
  })), _line489 || (_line489 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 122.34,
    x2: 835.07,
    y2: 122.34
  })), _line490 || (_line490 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 824.38,
    y1: 122.26,
    x2: 837.96,
    y2: 118.18
  })), _line491 || (_line491 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423,
    y1: 77.67,
    x2: 423,
    y2: 70.68
  })), _polyline210 || (_polyline210 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "423 70.68 419.47 71.72 416.72 74.26 415.78 77.67"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 415.44,
    y: 77.69,
    width: 0.32,
    height: 1.56
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 423,
    y: 77.69,
    width: 0.42,
    height: 1.56
  })), _line492 || (_line492 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 822.05,
    y1: 77.67,
    x2: 822.05,
    y2: 70.68
  })), _polyline211 || (_polyline211 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "822.05 70.68 818.53 71.72 815.77 74.26 814.83 77.67"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 814.41,
    y: 77.69,
    width: 0.42,
    height: 1.56
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 822.05,
    y: 77.69,
    width: 0.42,
    height: 1.56
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 767.78,
    y: 77.36,
    width: 7.1,
    height: 0.31
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 760.57,
    y: 77.36,
    width: 7.21,
    height: 0.31
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 774.87,
    y: 77.36,
    width: 7.1,
    height: 0.31
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 781.99,
    y: 77.36,
    width: 7.1,
    height: 0.31
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 760.57,
    y: 76.65,
    width: 28.51,
    height: 0.73
  })), _line493 || (_line493 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 579.34,
    x2: 825.31,
    y2: 579.34
  })), _line494 || (_line494 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 579.34,
    x2: 825.31,
    y2: 579.03
  })), _line495 || (_line495 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 579.03,
    x2: 826.38,
    y2: 579.03
  })), _line496 || (_line496 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 579.03,
    x2: 826.38,
    y2: 579.34
  })), _line497 || (_line497 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 586.32,
    x2: 825.31,
    y2: 586.32
  })), _line498 || (_line498 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 586.32,
    x2: 825.31,
    y2: 586.84
  })), _line499 || (_line499 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 825.31,
    y1: 586.84,
    x2: 826.38,
    y2: 586.84
  })), _line500 || (_line500 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 586.84,
    x2: 826.38,
    y2: 586.32
  })), _line501 || (_line501 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.33,
    y1: 400.01,
    x2: 402.33,
    y2: 388.45
  })), _line502 || (_line502 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.33,
    y1: 423.97,
    x2: 402.33,
    y2: 438.11
  })), _line503 || (_line503 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.21,
    y1: 419.81,
    x2: 402.21,
    y2: 408.24
  })), _line504 || (_line504 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.21,
    y1: 400.22,
    x2: 402.21,
    y2: 405.96
  })), _line505 || (_line505 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.63,
    y1: 388.24,
    x2: 402.63,
    y2: 395.31
  })), _line506 || (_line506 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 387.07,
    x2: 403.48,
    y2: 395.43
  })), _line507 || (_line507 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.71,
    y1: 419.47,
    x2: 826.71,
    y2: 480.2
  })), _line508 || (_line508 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 419.18,
    x2: 827.14,
    y2: 480.62
  })), _line509 || (_line509 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.5,
    y1: 419.18,
    x2: 835.5,
    y2: 491.64
  })), _line510 || (_line510 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.07,
    y1: 419.18,
    x2: 835.07,
    y2: 491.35
  })), _line511 || (_line511 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 478.12,
    x2: 835.07,
    y2: 478.12
  })), _line512 || (_line512 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 480.62,
    x2: 827.14,
    y2: 480.62
  })), _line513 || (_line513 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 491.35,
    x2: 835.07,
    y2: 491.35
  })), _line514 || (_line514 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 480.2,
    x2: 826.71,
    y2: 480.2
  })), _line515 || (_line515 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 475.83,
    x2: 835.07,
    y2: 475.83
  })), _line516 || (_line516 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 473.84,
    x2: 835.07,
    y2: 473.84
  })), _line517 || (_line517 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 471.76,
    x2: 835.07,
    y2: 471.76
  })), _line518 || (_line518 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 469.47,
    x2: 835.07,
    y2: 469.47
  })), _line519 || (_line519 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 467.39,
    x2: 835.07,
    y2: 467.39
  })), _line520 || (_line520 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 465.31,
    x2: 835.07,
    y2: 465.31
  })), _line521 || (_line521 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 463.1,
    x2: 835.07,
    y2: 463.1
  })), _line522 || (_line522 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 461.03,
    x2: 835.07,
    y2: 461.03
  })), _line523 || (_line523 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 451.67,
    x2: 835.07,
    y2: 451.67
  })), _line524 || (_line524 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 449.59,
    x2: 835.07,
    y2: 449.59
  })), _line525 || (_line525 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 447.3,
    x2: 835.07,
    y2: 447.3
  })), _line526 || (_line526 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 445.22,
    x2: 835.07,
    y2: 445.22
  })), _line527 || (_line527 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 443.14,
    x2: 835.07,
    y2: 443.14
  })), _line528 || (_line528 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 440.94,
    x2: 835.07,
    y2: 440.94
  })), _line529 || (_line529 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 438.86,
    x2: 835.07,
    y2: 438.86
  })), _line530 || (_line530 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 436.65,
    x2: 835.07,
    y2: 436.65
  })), _line531 || (_line531 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 434.57,
    x2: 835.07,
    y2: 434.57
  })), _line532 || (_line532 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 432.49,
    x2: 835.07,
    y2: 432.49
  })), _line533 || (_line533 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 430.21,
    x2: 835.07,
    y2: 430.21
  })), _line534 || (_line534 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 428.13,
    x2: 835.07,
    y2: 428.13
  })), _line535 || (_line535 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 425.92,
    x2: 835.07,
    y2: 425.92
  })), _line536 || (_line536 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 423.84,
    x2: 835.07,
    y2: 423.84
  })), _line537 || (_line537 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 835.07,
    y1: 419.18,
    x2: 835.5,
    y2: 419.18
  })), _line538 || (_line538 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 419.18,
    x2: 826.38,
    y2: 419.18
  })), _line539 || (_line539 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.71,
    y1: 419.47,
    x2: 826.38,
    y2: 419.47
  })), _line540 || (_line540 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 491.64,
    x2: 835.5,
    y2: 491.64
  })), _line541 || (_line541 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 826.38,
    y1: 488.31,
    x2: 833.5,
    y2: 488.31
  })), _polyline212 || (_polyline212 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "833.5 488.31 832.65 484.98 829.9 482.28 826.38 481.32"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 825.31,
    y: 480.91,
    width: 1.06,
    height: 0.42
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 825.31,
    y: 488.33,
    width: 1.06,
    height: 0.52
  })), _line542 || (_line542 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 576.11,
    x2: 835.07,
    y2: 576.11
  })), _line543 || (_line543 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 574.03,
    x2: 835.07,
    y2: 574.03
  })), _line544 || (_line544 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 571.74,
    x2: 835.07,
    y2: 571.74
  })), _line545 || (_line545 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 569.66,
    x2: 835.07,
    y2: 569.66
  })), _line546 || (_line546 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 567.47,
    x2: 835.07,
    y2: 567.47
  })), _line547 || (_line547 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 565.38,
    x2: 835.07,
    y2: 565.38
  })), _line548 || (_line548 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 563.3,
    x2: 835.07,
    y2: 563.3
  })), _line549 || (_line549 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 561.12,
    x2: 835.07,
    y2: 561.12
  })), _line550 || (_line550 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 559.03,
    x2: 835.07,
    y2: 559.03
  })), _line551 || (_line551 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 549.66,
    x2: 835.07,
    y2: 549.66
  })), _line552 || (_line552 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 547.58,
    x2: 835.07,
    y2: 547.58
  })), _line553 || (_line553 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 545.29,
    x2: 835.07,
    y2: 545.29
  })), _line554 || (_line554 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 543.2,
    x2: 835.07,
    y2: 543.2
  })), _line555 || (_line555 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 541.12,
    x2: 835.07,
    y2: 541.12
  })), _line556 || (_line556 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 538.93,
    x2: 835.07,
    y2: 538.93
  })), _line557 || (_line557 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 536.85,
    x2: 835.07,
    y2: 536.85
  })), _line558 || (_line558 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 534.77,
    x2: 835.07,
    y2: 534.77
  })), _line559 || (_line559 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 532.58,
    x2: 835.07,
    y2: 532.58
  })), _line560 || (_line560 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 530.5,
    x2: 835.07,
    y2: 530.5
  })), _line561 || (_line561 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 528.2,
    x2: 835.07,
    y2: 528.2
  })), _line562 || (_line562 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 526.13,
    x2: 835.07,
    y2: 526.13
  })), _line563 || (_line563 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 524.04,
    x2: 835.07,
    y2: 524.04
  })), _line564 || (_line564 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 827.14,
    y1: 521.85,
    x2: 835.07,
    y2: 521.85
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 826.38,
    y: 586.32,
    width: 7.1,
    height: 0.52
  })), _polyline213 || (_polyline213 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "833.5 586.32 832.44 582.99 829.9 580.28 826.38 579.03"
  })), _polyline214 || (_polyline214 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "826.38 589.23 826.38 589.34 835.07 589.34 835.07 517.17 835.5 517.17 835.5 589.65 826.38 589.65"
  })), _polyline215 || (_polyline215 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "826.38 578.19 826.71 578.19 826.71 517.69 826.38 517.69 826.38 517.17 827.14 517.17 827.14 578.61 826.38 578.61"
  })), _line565 || (_line565 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 694.97,
    y1: 491.76,
    x2: 699.21,
    y2: 487.6
  })), _line566 || (_line566 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 694.97,
    y1: 487.6,
    x2: 699.21,
    y2: 491.76
  })), _line567 || (_line567 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 820.01,
    y1: 328.35,
    x2: 820.14,
    y2: 328.35
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 694.84,
    y: 487.28,
    width: 4.66,
    height: 4.69
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 694.97,
    y: 487.6,
    width: 4.24,
    height: 4.17
  })), _line568 || (_line568 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.66,
    y1: 75.72,
    x2: 750.17,
    y2: 75.72
  })), _line569 || (_line569 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 406.58,
    y1: 441.02,
    x2: 406.58,
    y2: 450.42
  })), _line570 || (_line570 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 407,
    y1: 441.02,
    x2: 407,
    y2: 450.42
  })), _line571 || (_line571 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.66,
    y1: 75.72,
    x2: 750.17,
    y2: 75.72
  })), _line572 || (_line572 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 694.97,
    y1: 491.76,
    x2: 699.21,
    y2: 487.6
  })), _line573 || (_line573 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 694.97,
    y1: 487.6,
    x2: 699.21,
    y2: 491.76
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 694.84,
    y: 487.28,
    width: 4.66,
    height: 4.69
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 694.97,
    y: 487.6,
    width: 4.24,
    height: 4.17
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 828.41,
    y: 592.04,
    width: 14.31,
    height: 26.45
  })), _line574 || (_line574 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 406.58,
    y1: 441.02,
    x2: 406.58,
    y2: 450.42
  })), _line575 || (_line575 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 407,
    y1: 441.02,
    x2: 407,
    y2: 450.42
  })), _line576 || (_line576 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 485.81,
    x2: 409.08,
    y2: 493.51
  })), _line577 || (_line577 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.11,
    y1: 75.92,
    x2: 749.24,
    y2: 75.92
  })), _line578 || (_line578 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.66,
    y1: 75.72,
    x2: 750.17,
    y2: 75.72
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "825.02 200.03 823.96 196.21 821.07 193.5 817.17 192.46 813.35 193.5 810.51 196.21 809.45 200.03 810.51 203.9 813.35 206.73 817.17 207.77 821.07 206.73 823.96 203.9 825.02 200.03"
  })), _line579 || (_line579 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 811.65,
    y1: 194.63,
    x2: 822.77,
    y2: 205.57
  })), _line580 || (_line580 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 811.65,
    y1: 205.57,
    x2: 822.77,
    y2: 194.63
  })), _line581 || (_line581 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.75,
    y1: 450.42,
    x2: 441.75,
    y2: 444.89
  })), _line582 || (_line582 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.53,
    y1: 450.42,
    x2: 436.53,
    y2: 444.89
  })), _polyline216 || (_polyline216 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "434.41 450.71 434.32 450.71 434.32 451.04"
  })), _polyline217 || (_polyline217 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "434.32 458.24 434.32 458.32 434.41 458.32"
  })), _polyline218 || (_polyline218 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "442.6 458.32 442.81 458.32 442.81 458.24"
  })), _polyline219 || (_polyline219 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "442.81 451.04 442.81 450.71 442.6 450.71"
  })), _line583 || (_line583 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.6,
    y1: 458.32,
    x2: 434.41,
    y2: 458.32
  })), _line584 || (_line584 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.81,
    y1: 451.04,
    x2: 442.81,
    y2: 458.24
  })), _line585 || (_line585 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.41,
    y1: 450.71,
    x2: 442.6,
    y2: 450.71
  })), _line586 || (_line586 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.41,
    y1: 462.06,
    x2: 441.41,
    y2: 458.45
  })), _line587 || (_line587 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.68,
    y1: 462.06,
    x2: 435.68,
    y2: 458.45
  })), _line588 || (_line588 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.53,
    y1: 450.42,
    x2: 441.75,
    y2: 450.42
  })), _line589 || (_line589 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.53,
    y1: 444.89,
    x2: 441.75,
    y2: 444.89
  })), _line590 || (_line590 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.68,
    y1: 462.06,
    x2: 441.41,
    y2: 462.06
  })), _line591 || (_line591 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.32,
    y1: 458.24,
    x2: 434.32,
    y2: 451.04
  })), _line592 || (_line592 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 433.6,
    y1: 447.59,
    x2: 433.6,
    y2: 462.4
  })), _line593 || (_line593 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.81,
    y1: 462.4,
    x2: 442.81,
    y2: 469.68
  })), _line594 || (_line594 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.81,
    y1: 469.68,
    x2: 420.96,
    y2: 469.68
  })), _line595 || (_line595 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 433.6,
    y1: 447.59,
    x2: 420.96,
    y2: 447.59
  })), _line596 || (_line596 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.96,
    y1: 447.59,
    x2: 420.96,
    y2: 469.68
  })), _line597 || (_line597 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 433.6,
    y1: 462.4,
    x2: 442.81,
    y2: 462.4
  })), _line598 || (_line598 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.96,
    y1: 469.68,
    x2: 420.96,
    y2: 469.18
  })), _line599 || (_line599 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 439.2,
    y1: 436.44,
    x2: 439.2,
    y2: 444.8
  })), _line600 || (_line600 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.75,
    y1: 436.44,
    x2: 437.3,
    y2: 436.44
  })), _line601 || (_line601 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.75,
    y1: 444.8,
    x2: 439.2,
    y2: 444.8
  })), _line602 || (_line602 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.75,
    y1: 436.44,
    x2: 434.75,
    y2: 444.8
  })), _line603 || (_line603 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.36,
    y1: 436.44,
    x2: 439.2,
    y2: 436.44
  })), _line604 || (_line604 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.26,
    y1: 434.07,
    x2: 440.69,
    y2: 434.07
  })), _line605 || (_line605 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.26,
    y1: 434.07,
    x2: 419.26,
    y2: 432.91
  })), _line606 || (_line606 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.57,
    y1: 432.91,
    x2: 419.26,
    y2: 432.91
  })), _line607 || (_line607 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.69,
    y1: 412.7,
    x2: 417.57,
    y2: 412.7
  })), _line608 || (_line608 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.69,
    y1: 434.07,
    x2: 440.69,
    y2: 412.7
  })), _line609 || (_line609 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.57,
    y1: 432.91,
    x2: 417.57,
    y2: 412.7
  })), _line610 || (_line610 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.36,
    y1: 434.07,
    x2: 438.36,
    y2: 436.44
  })), _line611 || (_line611 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.3,
    y1: 434.07,
    x2: 437.3,
    y2: 436.44
  })), _line612 || (_line612 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.69,
    y1: 589.65,
    x2: 785.13,
    y2: 589.65
  })), _line613 || (_line613 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.13,
    y1: 611,
    x2: 808.17,
    y2: 611
  })), _line614 || (_line614 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.13,
    y1: 589.65,
    x2: 785.13,
    y2: 611
  })), _line615 || (_line615 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 590.8,
    x2: 808.17,
    y2: 611
  })), _line616 || (_line616 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 787.59,
    y1: 589.65,
    x2: 787.59,
    y2: 587.15
  })), _line617 || (_line617 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 788.53,
    y1: 589.65,
    x2: 788.53,
    y2: 587.15
  })), _line618 || (_line618 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.51,
    y1: 589.65,
    x2: 752.08,
    y2: 589.65
  })), _line619 || (_line619 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.08,
    y1: 611,
    x2: 775.21,
    y2: 611
  })), _line620 || (_line620 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.08,
    y1: 589.65,
    x2: 752.08,
    y2: 611
  })), _line621 || (_line621 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.21,
    y1: 590.8,
    x2: 775.21,
    y2: 611
  })), _line622 || (_line622 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 754.41,
    y1: 589.65,
    x2: 754.41,
    y2: 587.15
  })), _line623 || (_line623 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 755.48,
    y1: 589.65,
    x2: 755.48,
    y2: 587.15
  })), _line624 || (_line624 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.41,
    y1: 589.65,
    x2: 718.9,
    y2: 589.65
  })), _line625 || (_line625 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.9,
    y1: 611,
    x2: 742.03,
    y2: 611
  })), _line626 || (_line626 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.9,
    y1: 589.65,
    x2: 718.9,
    y2: 611
  })), _line627 || (_line627 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.03,
    y1: 590.8,
    x2: 742.03,
    y2: 611
  })), _line628 || (_line628 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 721.36,
    y1: 589.65,
    x2: 721.36,
    y2: 587.15
  })), _line629 || (_line629 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 722.3,
    y1: 589.65,
    x2: 722.3,
    y2: 587.15
  })), _line630 || (_line630 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.41,
    y1: 589.65,
    x2: 740.41,
    y2: 590.8
  })), _line631 || (_line631 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.03,
    y1: 590.8,
    x2: 740.41,
    y2: 590.8
  })), _line632 || (_line632 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.51,
    y1: 589.65,
    x2: 773.51,
    y2: 590.8
  })), _line633 || (_line633 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.21,
    y1: 590.8,
    x2: 773.51,
    y2: 590.8
  })), _line634 || (_line634 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.69,
    y1: 589.65,
    x2: 806.69,
    y2: 590.8
  })), _line635 || (_line635 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.17,
    y1: 590.8,
    x2: 806.69,
    y2: 590.8
  })), _line636 || (_line636 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.95,
    y1: 450.42,
    x2: 473.95,
    y2: 444.89
  })), _line637 || (_line637 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.86,
    y1: 450.42,
    x2: 468.86,
    y2: 444.89
  })), _polyline220 || (_polyline220 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "466.74 450.71 466.53 450.71 466.53 451.04"
  })), _polyline221 || (_polyline221 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "466.53 458.24 466.53 458.32 466.74 458.32"
  })), _polyline222 || (_polyline222 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "474.93 458.32 475.02 458.32 475.02 458.24"
  })), _polyline223 || (_polyline223 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "475.02 451.04 475.02 450.71 474.93 450.71"
  })), _line638 || (_line638 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.93,
    y1: 458.32,
    x2: 466.74,
    y2: 458.32
  })), _line639 || (_line639 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.02,
    y1: 451.04,
    x2: 475.02,
    y2: 458.24
  })), _line640 || (_line640 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 466.74,
    y1: 450.71,
    x2: 474.93,
    y2: 450.71
  })), _line641 || (_line641 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.74,
    y1: 462.06,
    x2: 473.74,
    y2: 458.45
  })), _line642 || (_line642 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.93,
    y1: 462.06,
    x2: 467.93,
    y2: 458.45
  })), _line643 || (_line643 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.86,
    y1: 450.42,
    x2: 473.95,
    y2: 450.42
  })), _line644 || (_line644 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.86,
    y1: 444.89,
    x2: 473.95,
    y2: 444.89
  })), _line645 || (_line645 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.93,
    y1: 462.06,
    x2: 473.74,
    y2: 462.06
  })), _line646 || (_line646 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 466.53,
    y1: 458.24,
    x2: 466.53,
    y2: 451.04
  })), _line647 || (_line647 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 465.81,
    y1: 447.59,
    x2: 465.81,
    y2: 462.4
  })), _line648 || (_line648 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.02,
    y1: 462.4,
    x2: 475.02,
    y2: 469.68
  })), _line649 || (_line649 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.02,
    y1: 469.68,
    x2: 453.29,
    y2: 469.68
  })), _line650 || (_line650 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 465.81,
    y1: 447.59,
    x2: 453.29,
    y2: 447.59
  })), _line651 || (_line651 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 453.29,
    y1: 447.59,
    x2: 453.29,
    y2: 469.68
  })), _line652 || (_line652 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 465.81,
    y1: 462.4,
    x2: 475.02,
    y2: 462.4
  })), _line653 || (_line653 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 453.29,
    y1: 469.68,
    x2: 453.29,
    y2: 469.18
  })), _line654 || (_line654 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.41,
    y1: 436.44,
    x2: 471.41,
    y2: 444.8
  })), _line655 || (_line655 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.08,
    y1: 436.44,
    x2: 469.63,
    y2: 436.44
  })), _line656 || (_line656 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.08,
    y1: 444.8,
    x2: 471.41,
    y2: 444.8
  })), _line657 || (_line657 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.08,
    y1: 436.44,
    x2: 467.08,
    y2: 444.8
  })), _line658 || (_line658 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 470.69,
    y1: 436.44,
    x2: 471.41,
    y2: 436.44
  })), _line659 || (_line659 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.38,
    y1: 434.07,
    x2: 472.89,
    y2: 434.07
  })), _line660 || (_line660 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.38,
    y1: 434.07,
    x2: 451.38,
    y2: 432.91
  })), _line661 || (_line661 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 449.9,
    y1: 432.91,
    x2: 451.38,
    y2: 432.91
  })), _line662 || (_line662 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 472.89,
    y1: 412.7,
    x2: 449.9,
    y2: 412.7
  })), _line663 || (_line663 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 472.89,
    y1: 434.07,
    x2: 472.89,
    y2: 412.7
  })), _line664 || (_line664 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 449.9,
    y1: 432.91,
    x2: 449.9,
    y2: 412.7
  })), _line665 || (_line665 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 470.69,
    y1: 434.07,
    x2: 470.69,
    y2: 436.44
  })), _line666 || (_line666 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 469.63,
    y1: 434.07,
    x2: 469.63,
    y2: 436.44
  })), _line667 || (_line667 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 510.23,
    y1: 450.42,
    x2: 510.23,
    y2: 444.89
  })), _line668 || (_line668 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.14,
    y1: 450.42,
    x2: 505.14,
    y2: 444.89
  })), _polyline224 || (_polyline224 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "503.02 450.71 502.81 450.71 502.68 451.04"
  })), _polyline225 || (_polyline225 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "502.68 458.24 502.81 458.32 503.02 458.32"
  })), _polyline226 || (_polyline226 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "510.95 458.32 511.17 458.32 511.29 458.24"
  })), _polyline227 || (_polyline227 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "511.29 451.04 511.17 450.71 510.95 450.71"
  })), _line669 || (_line669 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 510.95,
    y1: 458.32,
    x2: 503.02,
    y2: 458.32
  })), _line670 || (_line670 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 511.29,
    y1: 451.04,
    x2: 511.29,
    y2: 458.24
  })), _line671 || (_line671 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.02,
    y1: 450.71,
    x2: 510.95,
    y2: 450.71
  })), _line672 || (_line672 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.89,
    y1: 462.06,
    x2: 509.89,
    y2: 458.45
  })), _line673 || (_line673 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.08,
    y1: 462.06,
    x2: 504.08,
    y2: 458.45
  })), _line674 || (_line674 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.14,
    y1: 450.42,
    x2: 510.23,
    y2: 450.42
  })), _line675 || (_line675 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.93,
    y1: 444.89,
    x2: 510.23,
    y2: 444.89
  })), _line676 || (_line676 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.08,
    y1: 462.06,
    x2: 509.89,
    y2: 462.06
  })), _line677 || (_line677 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 502.68,
    y1: 458.24,
    x2: 502.68,
    y2: 451.04
  })), _line678 || (_line678 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.96,
    y1: 447.59,
    x2: 501.96,
    y2: 462.4
  })), _line679 || (_line679 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 511.29,
    y1: 462.4,
    x2: 511.29,
    y2: 469.68
  })), _line680 || (_line680 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 511.29,
    y1: 469.68,
    x2: 489.44,
    y2: 469.68
  })), _line681 || (_line681 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.96,
    y1: 447.59,
    x2: 489.44,
    y2: 447.59
  })), _line682 || (_line682 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 489.44,
    y1: 447.59,
    x2: 489.44,
    y2: 469.68
  })), _line683 || (_line683 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.96,
    y1: 462.4,
    x2: 511.29,
    y2: 462.4
  })), _line684 || (_line684 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 489.44,
    y1: 469.68,
    x2: 489.44,
    y2: 469.18
  })), _line685 || (_line685 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.47,
    y1: 436.44,
    x2: 507.47,
    y2: 444.8
  })), _line686 || (_line686 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.23,
    y1: 436.44,
    x2: 505.86,
    y2: 436.44
  })), _line687 || (_line687 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.23,
    y1: 444.8,
    x2: 507.47,
    y2: 444.8
  })), _line688 || (_line688 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.23,
    y1: 436.44,
    x2: 503.23,
    y2: 444.8
  })), _line689 || (_line689 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.71,
    y1: 436.44,
    x2: 507.47,
    y2: 436.44
  })), _line690 || (_line690 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 434.07,
    x2: 509.17,
    y2: 434.07
  })), _line691 || (_line691 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 434.07,
    x2: 487.66,
    y2: 432.91
  })), _line692 || (_line692 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.17,
    y1: 432.91,
    x2: 487.66,
    y2: 432.91
  })), _line693 || (_line693 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 412.7,
    x2: 486.17,
    y2: 412.7
  })), _line694 || (_line694 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 434.07,
    x2: 509.17,
    y2: 412.7
  })), _line695 || (_line695 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.17,
    y1: 432.91,
    x2: 486.17,
    y2: 412.7
  })), _line696 || (_line696 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.71,
    y1: 434.07,
    x2: 506.71,
    y2: 436.44
  })), _line697 || (_line697 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.86,
    y1: 434.07,
    x2: 505.86,
    y2: 436.44
  })), _line698 || (_line698 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.31,
    y1: 450.42,
    x2: 542.31,
    y2: 444.89
  })), _line699 || (_line699 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.34,
    y1: 450.42,
    x2: 537.34,
    y2: 444.89
  })), _polyline228 || (_polyline228 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "535.22 450.71 535.14 450.71 534.93 451.04"
  })), _polyline229 || (_polyline229 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "534.93 458.24 535.14 458.32 535.22 458.32"
  })), _polyline230 || (_polyline230 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.28 458.32 543.37 458.32 543.58 458.24"
  })), _polyline231 || (_polyline231 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "543.58 451.04 543.37 450.71 543.28 450.71"
  })), _line700 || (_line700 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 543.28,
    y1: 458.32,
    x2: 535.22,
    y2: 458.32
  })), _line701 || (_line701 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 543.58,
    y1: 451.04,
    x2: 543.58,
    y2: 458.24
  })), _line702 || (_line702 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.22,
    y1: 450.71,
    x2: 543.28,
    y2: 450.71
  })), _line703 || (_line703 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 462.06,
    x2: 542.22,
    y2: 458.45
  })), _line704 || (_line704 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 536.28,
    y1: 462.06,
    x2: 536.28,
    y2: 458.45
  })), _line705 || (_line705 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.34,
    y1: 450.42,
    x2: 542.31,
    y2: 450.42
  })), _line706 || (_line706 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.26,
    y1: 444.89,
    x2: 542.31,
    y2: 444.89
  })), _line707 || (_line707 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 536.28,
    y1: 462.06,
    x2: 542.22,
    y2: 462.06
  })), _line708 || (_line708 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 534.93,
    y1: 458.24,
    x2: 534.93,
    y2: 451.04
  })), _line709 || (_line709 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 534.16,
    y1: 447.59,
    x2: 534.16,
    y2: 462.4
  })), _line710 || (_line710 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 543.58,
    y1: 462.4,
    x2: 543.58,
    y2: 469.68
  })), _line711 || (_line711 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 543.58,
    y1: 469.68,
    x2: 521.77,
    y2: 469.68
  })), _line712 || (_line712 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 534.16,
    y1: 447.59,
    x2: 521.77,
    y2: 447.59
  })), _line713 || (_line713 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.77,
    y1: 447.59,
    x2: 521.77,
    y2: 469.68
  })), _line714 || (_line714 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 534.16,
    y1: 462.4,
    x2: 543.58,
    y2: 462.4
  })), _line715 || (_line715 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.77,
    y1: 469.68,
    x2: 521.77,
    y2: 469.18
  })), _line716 || (_line716 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.81,
    y1: 436.44,
    x2: 539.81,
    y2: 444.8
  })), _line717 || (_line717 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.56,
    y1: 436.44,
    x2: 537.98,
    y2: 436.44
  })), _line718 || (_line718 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.56,
    y1: 444.8,
    x2: 539.81,
    y2: 444.8
  })), _line719 || (_line719 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.56,
    y1: 436.44,
    x2: 535.56,
    y2: 444.8
  })), _line720 || (_line720 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.04,
    y1: 436.44,
    x2: 539.81,
    y2: 436.44
  })), _line721 || (_line721 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.95,
    y1: 434.07,
    x2: 541.5,
    y2: 434.07
  })), _line722 || (_line722 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.95,
    y1: 434.07,
    x2: 519.95,
    y2: 432.91
  })), _line723 || (_line723 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.38,
    y1: 432.91,
    x2: 519.95,
    y2: 432.91
  })), _line724 || (_line724 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.5,
    y1: 412.7,
    x2: 518.38,
    y2: 412.7
  })), _line725 || (_line725 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.5,
    y1: 434.07,
    x2: 541.5,
    y2: 412.7
  })), _line726 || (_line726 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.38,
    y1: 432.91,
    x2: 518.38,
    y2: 412.7
  })), _line727 || (_line727 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.04,
    y1: 434.07,
    x2: 539.04,
    y2: 436.44
  })), _line728 || (_line728 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.98,
    y1: 434.07,
    x2: 537.98,
    y2: 436.44
  })), _line729 || (_line729 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.64,
    y1: 450.42,
    x2: 574.64,
    y2: 444.89
  })), _line730 || (_line730 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 569.46,
    y1: 450.42,
    x2: 569.46,
    y2: 444.89
  })), _polyline232 || (_polyline232 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "567.55 450.71 567.26 450.71 567.26 451.04"
  })), _polyline233 || (_polyline233 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "567.26 458.24 567.26 458.32 567.55 458.32"
  })), _polyline234 || (_polyline234 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "575.49 458.32 575.7 458.32 575.83 458.24"
  })), _polyline235 || (_polyline235 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "575.83 451.04 575.7 450.71 575.49 450.71"
  })), _line731 || (_line731 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.49,
    y1: 458.32,
    x2: 567.55,
    y2: 458.32
  })), _line732 || (_line732 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.83,
    y1: 451.04,
    x2: 575.83,
    y2: 458.24
  })), _line733 || (_line733 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.55,
    y1: 450.71,
    x2: 575.49,
    y2: 450.71
  })), _line734 || (_line734 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.43,
    y1: 462.06,
    x2: 574.43,
    y2: 458.45
  })), _line735 || (_line735 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.61,
    y1: 462.06,
    x2: 568.61,
    y2: 458.45
  })), _line736 || (_line736 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 569.46,
    y1: 450.42,
    x2: 574.64,
    y2: 450.42
  })), _line737 || (_line737 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 569.46,
    y1: 444.89,
    x2: 574.64,
    y2: 444.89
  })), _line738 || (_line738 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.61,
    y1: 462.06,
    x2: 574.43,
    y2: 462.06
  })), _line739 || (_line739 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.26,
    y1: 458.24,
    x2: 567.26,
    y2: 451.04
  })), _line740 || (_line740 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 566.49,
    y1: 447.59,
    x2: 566.49,
    y2: 462.4
  })), _line741 || (_line741 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.83,
    y1: 462.4,
    x2: 575.83,
    y2: 469.68
  })), _line742 || (_line742 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.83,
    y1: 469.68,
    x2: 553.98,
    y2: 469.68
  })), _line743 || (_line743 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 566.49,
    y1: 447.59,
    x2: 553.98,
    y2: 447.59
  })), _line744 || (_line744 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.98,
    y1: 447.59,
    x2: 553.98,
    y2: 469.68
  })), _line745 || (_line745 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 566.49,
    y1: 462.4,
    x2: 575.83,
    y2: 462.4
  })), _line746 || (_line746 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.98,
    y1: 469.68,
    x2: 553.98,
    y2: 469.18
  })), _line747 || (_line747 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.09,
    y1: 436.44,
    x2: 572.09,
    y2: 444.8
  })), _line748 || (_line748 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.89,
    y1: 436.44,
    x2: 570.18,
    y2: 436.44
  })), _line749 || (_line749 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.89,
    y1: 444.8,
    x2: 572.09,
    y2: 444.8
  })), _line750 || (_line750 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.89,
    y1: 436.44,
    x2: 567.89,
    y2: 444.8
  })), _line751 || (_line751 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.25,
    y1: 436.44,
    x2: 572.09,
    y2: 436.44
  })), _line752 || (_line752 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.19,
    y1: 434.07,
    x2: 573.71,
    y2: 434.07
  })), _line753 || (_line753 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.19,
    y1: 434.07,
    x2: 552.19,
    y2: 432.91
  })), _line754 || (_line754 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 550.58,
    y1: 432.91,
    x2: 552.19,
    y2: 432.91
  })), _line755 || (_line755 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 573.71,
    y1: 412.7,
    x2: 550.58,
    y2: 412.7
  })), _line756 || (_line756 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 573.71,
    y1: 434.07,
    x2: 573.71,
    y2: 412.7
  })), _line757 || (_line757 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 550.58,
    y1: 432.91,
    x2: 550.58,
    y2: 412.7
  })), _line758 || (_line758 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.25,
    y1: 434.07,
    x2: 571.25,
    y2: 436.44
  })), _line759 || (_line759 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 570.18,
    y1: 434.07,
    x2: 570.18,
    y2: 436.44
  })), _line760 || (_line760 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.89,
    y1: 450.42,
    x2: 606.89,
    y2: 444.89
  })), _line761 || (_line761 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.79,
    y1: 450.42,
    x2: 601.79,
    y2: 444.89
  })), _polyline236 || (_polyline236 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "599.67 450.71 599.46 450.71 599.46 451.04"
  })), _polyline237 || (_polyline237 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "599.46 458.24 599.46 458.32 599.67 458.32"
  })), _polyline238 || (_polyline238 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "607.82 458.32 607.95 458.32 607.95 458.24"
  })), _polyline239 || (_polyline239 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "607.95 451.04 607.95 450.71 607.82 450.71"
  })), _line762 || (_line762 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.82,
    y1: 458.32,
    x2: 599.67,
    y2: 458.32
  })), _line763 || (_line763 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.95,
    y1: 451.04,
    x2: 607.95,
    y2: 458.24
  })), _line764 || (_line764 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 599.67,
    y1: 450.71,
    x2: 607.82,
    y2: 450.71
  })), _line765 || (_line765 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.67,
    y1: 462.06,
    x2: 606.67,
    y2: 458.45
  })), _line766 || (_line766 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 600.82,
    y1: 462.06,
    x2: 600.82,
    y2: 458.45
  })), _line767 || (_line767 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.79,
    y1: 450.42,
    x2: 606.89,
    y2: 450.42
  })), _line768 || (_line768 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.79,
    y1: 444.89,
    x2: 606.89,
    y2: 444.89
  })), _line769 || (_line769 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 600.82,
    y1: 462.06,
    x2: 606.67,
    y2: 462.06
  })), _line770 || (_line770 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 599.46,
    y1: 458.24,
    x2: 599.46,
    y2: 451.04
  })), _line771 || (_line771 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 598.7,
    y1: 447.59,
    x2: 598.7,
    y2: 462.4
  })), _line772 || (_line772 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.95,
    y1: 462.4,
    x2: 607.95,
    y2: 469.68
  })), _line773 || (_line773 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.95,
    y1: 469.68,
    x2: 586.22,
    y2: 469.68
  })), _line774 || (_line774 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 598.7,
    y1: 447.59,
    x2: 586.22,
    y2: 447.59
  })), _line775 || (_line775 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.22,
    y1: 447.59,
    x2: 586.22,
    y2: 469.68
  })), _line776 || (_line776 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 598.7,
    y1: 462.4,
    x2: 607.95,
    y2: 462.4
  })), _line777 || (_line777 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.22,
    y1: 469.68,
    x2: 586.22,
    y2: 469.18
  })), _line778 || (_line778 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.34,
    y1: 436.44,
    x2: 604.34,
    y2: 444.8
  })), _line779 || (_line779 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 599.97,
    y1: 436.44,
    x2: 602.52,
    y2: 436.44
  })), _line780 || (_line780 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 599.97,
    y1: 444.8,
    x2: 604.34,
    y2: 444.8
  })), _line781 || (_line781 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 599.97,
    y1: 436.44,
    x2: 599.97,
    y2: 444.8
  })), _line782 || (_line782 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 603.58,
    y1: 436.44,
    x2: 604.34,
    y2: 436.44
  })), _line783 || (_line783 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.53,
    y1: 434.07,
    x2: 606.04,
    y2: 434.07
  })), _line784 || (_line784 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.53,
    y1: 434.07,
    x2: 584.53,
    y2: 432.91
  })), _line785 || (_line785 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.83,
    y1: 432.91,
    x2: 584.53,
    y2: 432.91
  })), _line786 || (_line786 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.04,
    y1: 412.7,
    x2: 582.83,
    y2: 412.7
  })), _line787 || (_line787 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.04,
    y1: 434.07,
    x2: 606.04,
    y2: 412.7
  })), _line788 || (_line788 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.83,
    y1: 432.91,
    x2: 582.83,
    y2: 412.7
  })), _line789 || (_line789 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 603.58,
    y1: 434.07,
    x2: 603.58,
    y2: 436.44
  })), _line790 || (_line790 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 602.52,
    y1: 434.07,
    x2: 602.52,
    y2: 436.44
  })), _line791 || (_line791 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 639.22,
    y1: 450.42,
    x2: 639.22,
    y2: 444.89
  })), _line792 || (_line792 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634,
    y1: 450.42,
    x2: 634,
    y2: 444.89
  })), _polyline240 || (_polyline240 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "631.88 450.71 631.79 450.71 631.79 451.04"
  })), _polyline241 || (_polyline241 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "631.79 458.24 631.79 458.32 631.88 458.32"
  })), _polyline242 || (_polyline242 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "640.15 458.32 640.28 458.32 640.28 458.24"
  })), _polyline243 || (_polyline243 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "640.28 451.04 640.28 450.71 640.15 450.71"
  })), _line793 || (_line793 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 640.15,
    y1: 458.32,
    x2: 631.88,
    y2: 458.32
  })), _line794 || (_line794 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 640.28,
    y1: 451.04,
    x2: 640.28,
    y2: 458.24
  })), _line795 || (_line795 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.88,
    y1: 450.71,
    x2: 640.15,
    y2: 450.71
  })), _line796 || (_line796 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.88,
    y1: 462.06,
    x2: 638.88,
    y2: 458.45
  })), _line797 || (_line797 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 633.15,
    y1: 462.06,
    x2: 633.15,
    y2: 458.45
  })), _line798 || (_line798 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634,
    y1: 450.42,
    x2: 639.22,
    y2: 450.42
  })), _line799 || (_line799 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634,
    y1: 444.89,
    x2: 639.22,
    y2: 444.89
  })), _line800 || (_line800 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 633.15,
    y1: 462.06,
    x2: 638.88,
    y2: 462.06
  })), _line801 || (_line801 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.79,
    y1: 458.24,
    x2: 631.79,
    y2: 451.04
  })), _line802 || (_line802 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.03,
    y1: 447.59,
    x2: 631.03,
    y2: 462.4
  })), _line803 || (_line803 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 640.28,
    y1: 462.4,
    x2: 640.28,
    y2: 469.68
  })), _line804 || (_line804 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 640.28,
    y1: 469.68,
    x2: 618.43,
    y2: 469.68
  })), _line805 || (_line805 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.03,
    y1: 447.59,
    x2: 618.43,
    y2: 447.59
  })), _line806 || (_line806 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.43,
    y1: 447.59,
    x2: 618.43,
    y2: 469.68
  })), _line807 || (_line807 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.03,
    y1: 462.4,
    x2: 640.28,
    y2: 462.4
  })), _line808 || (_line808 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.43,
    y1: 469.68,
    x2: 618.43,
    y2: 469.18
  })), _line809 || (_line809 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 636.67,
    y1: 436.44,
    x2: 636.67,
    y2: 444.8
  })), _line810 || (_line810 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 632.22,
    y1: 436.44,
    x2: 634.85,
    y2: 436.44
  })), _line811 || (_line811 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 632.22,
    y1: 444.8,
    x2: 636.67,
    y2: 444.8
  })), _line812 || (_line812 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 632.22,
    y1: 436.44,
    x2: 632.22,
    y2: 444.8
  })), _line813 || (_line813 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 635.91,
    y1: 436.44,
    x2: 636.67,
    y2: 436.44
  })), _line814 || (_line814 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 616.65,
    y1: 434.07,
    x2: 638.16,
    y2: 434.07
  })), _line815 || (_line815 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 616.65,
    y1: 434.07,
    x2: 616.65,
    y2: 432.91
  })), _line816 || (_line816 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.16,
    y1: 432.91,
    x2: 616.65,
    y2: 432.91
  })), _line817 || (_line817 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.16,
    y1: 412.7,
    x2: 615.16,
    y2: 412.7
  })), _line818 || (_line818 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.16,
    y1: 434.07,
    x2: 638.16,
    y2: 412.7
  })), _line819 || (_line819 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.16,
    y1: 432.91,
    x2: 615.16,
    y2: 412.7
  })), _line820 || (_line820 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 635.91,
    y1: 434.07,
    x2: 635.91,
    y2: 436.44
  })), _line821 || (_line821 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 434.07,
    x2: 634.85,
    y2: 436.44
  })), _line822 || (_line822 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 672.4,
    y1: 450.42,
    x2: 672.4,
    y2: 444.89
  })), _line823 || (_line823 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.31,
    y1: 450.42,
    x2: 667.31,
    y2: 444.89
  })), _polyline244 || (_polyline244 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "665.18 450.71 664.97 450.71 664.85 451.04"
  })), _polyline245 || (_polyline245 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "664.85 458.24 664.97 458.32 665.18 458.32"
  })), _polyline246 || (_polyline246 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "673.12 458.32 673.33 458.32 673.46 458.24"
  })), _polyline247 || (_polyline247 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "673.46 451.04 673.33 450.71 673.12 450.71"
  })), _line824 || (_line824 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.12,
    y1: 458.32,
    x2: 665.18,
    y2: 458.32
  })), _line825 || (_line825 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.46,
    y1: 451.04,
    x2: 673.46,
    y2: 458.24
  })), _line826 || (_line826 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 665.18,
    y1: 450.71,
    x2: 673.12,
    y2: 450.71
  })), _line827 || (_line827 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 672.06,
    y1: 462.06,
    x2: 672.06,
    y2: 458.45
  })), _line828 || (_line828 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 666.25,
    y1: 462.06,
    x2: 666.25,
    y2: 458.45
  })), _line829 || (_line829 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.31,
    y1: 450.42,
    x2: 672.4,
    y2: 450.42
  })), _line830 || (_line830 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.09,
    y1: 444.89,
    x2: 672.4,
    y2: 444.89
  })), _line831 || (_line831 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 666.25,
    y1: 462.06,
    x2: 672.06,
    y2: 462.06
  })), _line832 || (_line832 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.85,
    y1: 458.24,
    x2: 664.85,
    y2: 451.04
  })), _line833 || (_line833 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.12,
    y1: 447.59,
    x2: 664.12,
    y2: 462.4
  })), _line834 || (_line834 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.46,
    y1: 462.4,
    x2: 673.46,
    y2: 469.68
  })), _line835 || (_line835 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.46,
    y1: 469.68,
    x2: 651.61,
    y2: 469.68
  })), _line836 || (_line836 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.12,
    y1: 447.59,
    x2: 651.61,
    y2: 447.59
  })), _line837 || (_line837 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.61,
    y1: 447.59,
    x2: 651.61,
    y2: 469.68
  })), _line838 || (_line838 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.12,
    y1: 462.4,
    x2: 673.46,
    y2: 462.4
  })), _line839 || (_line839 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.61,
    y1: 469.68,
    x2: 651.61,
    y2: 469.18
  })), _line840 || (_line840 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 669.64,
    y1: 436.44,
    x2: 669.64,
    y2: 444.8
  })), _line841 || (_line841 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 665.4,
    y1: 436.44,
    x2: 668.03,
    y2: 436.44
  })), _line842 || (_line842 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 665.4,
    y1: 444.8,
    x2: 669.64,
    y2: 444.8
  })), _line843 || (_line843 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 665.4,
    y1: 436.44,
    x2: 665.4,
    y2: 444.8
  })), _line844 || (_line844 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.88,
    y1: 436.44,
    x2: 669.64,
    y2: 436.44
  })), _line845 || (_line845 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 649.78,
    y1: 434.07,
    x2: 671.34,
    y2: 434.07
  })), _line846 || (_line846 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 649.78,
    y1: 434.07,
    x2: 649.78,
    y2: 432.91
  })), _line847 || (_line847 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.34,
    y1: 432.91,
    x2: 649.78,
    y2: 432.91
  })), _line848 || (_line848 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 412.7,
    x2: 648.34,
    y2: 412.7
  })), _line849 || (_line849 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 434.07,
    x2: 671.34,
    y2: 412.7
  })), _line850 || (_line850 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.34,
    y1: 432.91,
    x2: 648.34,
    y2: 412.7
  })), _line851 || (_line851 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.88,
    y1: 434.07,
    x2: 668.88,
    y2: 436.44
  })), _line852 || (_line852 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.03,
    y1: 434.07,
    x2: 668.03,
    y2: 436.44
  })), _line853 || (_line853 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.54,
    y1: 573.3,
    x2: 420.54,
    y2: 578.82
  })), _line854 || (_line854 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 425.63,
    y1: 573.3,
    x2: 425.63,
    y2: 578.82
  })), _polyline248 || (_polyline248 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "427.75 572.99 427.96 572.99 428.09 572.68"
  })), _polyline249 || (_polyline249 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "428.09 565.49 427.96 565.38 427.75 565.38"
  })), _polyline250 || (_polyline250 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "419.69 565.38 419.6 565.38 419.47 565.49"
  })), _polyline251 || (_polyline251 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "419.47 572.68 419.6 572.99 419.69 572.99"
  })), _line855 || (_line855 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.69,
    y1: 565.38,
    x2: 427.75,
    y2: 565.38
  })), _line856 || (_line856 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.47,
    y1: 572.68,
    x2: 419.47,
    y2: 565.49
  })), _line857 || (_line857 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 427.75,
    y1: 572.99,
    x2: 419.69,
    y2: 572.99
  })), _line858 || (_line858 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.87,
    y1: 561.64,
    x2: 420.87,
    y2: 565.28
  })), _line859 || (_line859 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 426.69,
    y1: 561.64,
    x2: 426.69,
    y2: 565.28
  })), _line860 || (_line860 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 425.63,
    y1: 573.3,
    x2: 420.54,
    y2: 573.3
  })), _line861 || (_line861 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 425.84,
    y1: 578.82,
    x2: 420.54,
    y2: 578.82
  })), _line862 || (_line862 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 426.69,
    y1: 561.64,
    x2: 420.87,
    y2: 561.64
  })), _line863 || (_line863 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 428.09,
    y1: 565.49,
    x2: 428.09,
    y2: 572.68
  })), _line864 || (_line864 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 428.81,
    y1: 576.11,
    x2: 428.81,
    y2: 561.43
  })), _line865 || (_line865 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.47,
    y1: 561.43,
    x2: 419.47,
    y2: 554.14
  })), _line866 || (_line866 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.47,
    y1: 554.14,
    x2: 441.33,
    y2: 554.14
  })), _line867 || (_line867 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 428.81,
    y1: 576.11,
    x2: 441.33,
    y2: 576.11
  })), _line868 || (_line868 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.33,
    y1: 576.11,
    x2: 441.33,
    y2: 554.14
  })), _line869 || (_line869 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 428.81,
    y1: 561.43,
    x2: 419.47,
    y2: 561.43
  })), _line870 || (_line870 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.33,
    y1: 554.14,
    x2: 441.33,
    y2: 554.55
  })), _line871 || (_line871 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423.21,
    y1: 587.26,
    x2: 423.21,
    y2: 578.93
  })), _line872 || (_line872 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 427.45,
    y1: 587.26,
    x2: 424.91,
    y2: 587.26
  })), _line873 || (_line873 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 427.45,
    y1: 578.93,
    x2: 423.21,
    y2: 578.93
  })), _line874 || (_line874 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 427.45,
    y1: 587.26,
    x2: 427.45,
    y2: 578.93
  })), _line875 || (_line875 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.06,
    y1: 587.26,
    x2: 423.21,
    y2: 587.26
  })), _line876 || (_line876 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.11,
    y1: 589.65,
    x2: 421.6,
    y2: 589.65
  })), _line877 || (_line877 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.11,
    y1: 589.65,
    x2: 443.11,
    y2: 590.8
  })), _line878 || (_line878 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 444.59,
    y1: 590.8,
    x2: 443.11,
    y2: 590.8
  })), _line879 || (_line879 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.6,
    y1: 611,
    x2: 444.59,
    y2: 611
  })), _line880 || (_line880 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.6,
    y1: 589.65,
    x2: 421.6,
    y2: 611
  })), _line881 || (_line881 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 444.59,
    y1: 590.8,
    x2: 444.59,
    y2: 611
  })), _line882 || (_line882 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.06,
    y1: 589.65,
    x2: 424.06,
    y2: 587.26
  })), _line883 || (_line883 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.91,
    y1: 589.65,
    x2: 424.91,
    y2: 587.26
  })), _line884 || (_line884 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.78,
    y1: 573.3,
    x2: 452.78,
    y2: 578.82
  })), _line885 || (_line885 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 457.96,
    y1: 573.3,
    x2: 457.96,
    y2: 578.82
  })), _polyline252 || (_polyline252 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "460.08 572.99 460.21 572.99 460.42 572.68"
  })), _polyline253 || (_polyline253 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "460.42 565.49 460.21 565.38 460.08 565.38"
  })), _polyline254 || (_polyline254 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "452.02 565.38 451.72 565.38 451.72 565.49"
  })), _polyline255 || (_polyline255 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "451.72 572.68 451.72 572.99 452.02 572.99"
  })), _line886 || (_line886 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.02,
    y1: 565.38,
    x2: 460.08,
    y2: 565.38
  })), _line887 || (_line887 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 572.68,
    x2: 451.72,
    y2: 565.49
  })), _line888 || (_line888 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 460.08,
    y1: 572.99,
    x2: 452.02,
    y2: 572.99
  })), _line889 || (_line889 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 453.08,
    y1: 561.64,
    x2: 453.08,
    y2: 565.28
  })), _line890 || (_line890 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 459.02,
    y1: 561.64,
    x2: 459.02,
    y2: 565.28
  })), _line891 || (_line891 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 457.96,
    y1: 573.3,
    x2: 452.78,
    y2: 573.3
  })), _line892 || (_line892 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 458.09,
    y1: 578.82,
    x2: 452.78,
    y2: 578.82
  })), _line893 || (_line893 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 459.02,
    y1: 561.64,
    x2: 453.08,
    y2: 561.64
  })), _line894 || (_line894 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 460.42,
    y1: 565.49,
    x2: 460.42,
    y2: 572.68
  })), _line895 || (_line895 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 461.14,
    y1: 576.11,
    x2: 461.14,
    y2: 561.43
  })), _line896 || (_line896 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 561.43,
    x2: 451.72,
    y2: 554.14
  })), _line897 || (_line897 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 554.14,
    x2: 473.53,
    y2: 554.14
  })), _line898 || (_line898 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 461.14,
    y1: 576.11,
    x2: 473.53,
    y2: 576.11
  })), _line899 || (_line899 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.53,
    y1: 576.11,
    x2: 473.53,
    y2: 554.14
  })), _line900 || (_line900 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 461.14,
    y1: 561.43,
    x2: 451.72,
    y2: 561.43
  })), _line901 || (_line901 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.53,
    y1: 554.14,
    x2: 473.53,
    y2: 554.55
  })), _line902 || (_line902 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 455.54,
    y1: 587.26,
    x2: 455.54,
    y2: 578.93
  })), _line903 || (_line903 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 459.78,
    y1: 587.26,
    x2: 457.24,
    y2: 587.26
  })), _line904 || (_line904 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 459.78,
    y1: 578.93,
    x2: 455.54,
    y2: 578.93
  })), _line905 || (_line905 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 459.78,
    y1: 587.26,
    x2: 459.78,
    y2: 578.93
  })), _line906 || (_line906 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 456.26,
    y1: 587.26,
    x2: 455.54,
    y2: 587.26
  })), _line907 || (_line907 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.35,
    y1: 589.65,
    x2: 453.84,
    y2: 589.65
  })), _line908 || (_line908 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.35,
    y1: 589.65,
    x2: 475.35,
    y2: 590.8
  })), _line909 || (_line909 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.92,
    y1: 590.8,
    x2: 475.35,
    y2: 590.8
  })), _line910 || (_line910 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 453.84,
    y1: 611,
    x2: 476.92,
    y2: 611
  })), _line911 || (_line911 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 453.84,
    y1: 589.65,
    x2: 453.84,
    y2: 611
  })), _line912 || (_line912 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 476.92,
    y1: 590.8,
    x2: 476.92,
    y2: 611
  })), _line913 || (_line913 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 456.26,
    y1: 589.65,
    x2: 456.26,
    y2: 587.26
  })), _line914 || (_line914 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 457.24,
    y1: 589.65,
    x2: 457.24,
    y2: 587.26
  })), _line915 || (_line915 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.11,
    y1: 573.3,
    x2: 485.11,
    y2: 578.82
  })), _line916 || (_line916 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 490.16,
    y1: 573.3,
    x2: 490.16,
    y2: 578.82
  })), _polyline256 || (_polyline256 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "492.28 572.99 492.5 572.99 492.5 572.68"
  })), _polyline257 || (_polyline257 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "492.5 565.49 492.5 565.38 492.28 565.38"
  })), _polyline258 || (_polyline258 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "484.14 565.38 484.05 565.38 484.05 565.49"
  })), _polyline259 || (_polyline259 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "484.05 572.68 484.05 572.99 484.14 572.99"
  })), _line917 || (_line917 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.14,
    y1: 565.38,
    x2: 492.28,
    y2: 565.38
  })), _line918 || (_line918 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.05,
    y1: 572.68,
    x2: 484.05,
    y2: 565.49
  })), _line919 || (_line919 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 492.28,
    y1: 572.99,
    x2: 484.14,
    y2: 572.99
  })), _line920 || (_line920 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.41,
    y1: 561.64,
    x2: 485.41,
    y2: 565.28
  })), _line921 || (_line921 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 491.14,
    y1: 561.64,
    x2: 491.14,
    y2: 565.28
  })), _line922 || (_line922 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 490.16,
    y1: 573.3,
    x2: 485.11,
    y2: 573.3
  })), _line923 || (_line923 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 490.16,
    y1: 578.82,
    x2: 485.11,
    y2: 578.82
  })), _line924 || (_line924 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 491.14,
    y1: 561.64,
    x2: 485.41,
    y2: 561.64
  })), _line925 || (_line925 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 492.5,
    y1: 565.49,
    x2: 492.5,
    y2: 572.68
  })), _line926 || (_line926 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 493.34,
    y1: 576.11,
    x2: 493.34,
    y2: 561.43
  })), _line927 || (_line927 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.05,
    y1: 561.43,
    x2: 484.05,
    y2: 554.14
  })), _line928 || (_line928 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.05,
    y1: 554.14,
    x2: 505.86,
    y2: 554.14
  })), _line929 || (_line929 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 493.34,
    y1: 576.11,
    x2: 505.86,
    y2: 576.11
  })), _line930 || (_line930 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.86,
    y1: 576.11,
    x2: 505.86,
    y2: 554.14
  })), _line931 || (_line931 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 493.34,
    y1: 561.43,
    x2: 484.05,
    y2: 561.43
  })), _line932 || (_line932 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.86,
    y1: 554.14,
    x2: 505.86,
    y2: 554.55
  })), _line933 || (_line933 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.87,
    y1: 587.26,
    x2: 487.87,
    y2: 578.93
  })), _line934 || (_line934 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 492.07,
    y1: 587.26,
    x2: 489.44,
    y2: 587.26
  })), _line935 || (_line935 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 492.07,
    y1: 578.93,
    x2: 487.87,
    y2: 578.93
  })), _line936 || (_line936 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 492.07,
    y1: 587.26,
    x2: 492.07,
    y2: 578.93
  })), _line937 || (_line937 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 488.38,
    y1: 587.26,
    x2: 487.87,
    y2: 587.26
  })), _line938 || (_line938 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.69,
    y1: 589.65,
    x2: 486.17,
    y2: 589.65
  })), _line939 || (_line939 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.69,
    y1: 589.65,
    x2: 507.69,
    y2: 590.8
  })), _line940 || (_line940 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 590.8,
    x2: 507.69,
    y2: 590.8
  })), _line941 || (_line941 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.17,
    y1: 611,
    x2: 509.17,
    y2: 611
  })), _line942 || (_line942 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.17,
    y1: 589.65,
    x2: 486.17,
    y2: 611
  })), _line943 || (_line943 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 590.8,
    x2: 509.17,
    y2: 611
  })), _line944 || (_line944 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 488.38,
    y1: 589.65,
    x2: 488.38,
    y2: 587.26
  })), _line945 || (_line945 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 489.44,
    y1: 589.65,
    x2: 489.44,
    y2: 587.26
  })), _line946 || (_line946 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 517.32,
    y1: 573.3,
    x2: 517.32,
    y2: 578.82
  })), _line947 || (_line947 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 522.49,
    y1: 573.3,
    x2: 522.49,
    y2: 578.82
  })), _polyline260 || (_polyline260 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "524.62 572.99 524.74 572.99 524.74 572.68"
  })), _polyline261 || (_polyline261 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "524.74 565.49 524.74 565.38 524.62 565.38"
  })), _polyline262 || (_polyline262 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "516.47 565.38 516.26 565.38 516.26 565.49"
  })), _polyline263 || (_polyline263 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "516.26 572.68 516.26 572.99 516.47 572.99"
  })), _line948 || (_line948 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.47,
    y1: 565.38,
    x2: 524.62,
    y2: 565.38
  })), _line949 || (_line949 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.26,
    y1: 572.68,
    x2: 516.26,
    y2: 565.49
  })), _line950 || (_line950 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 524.62,
    y1: 572.99,
    x2: 516.47,
    y2: 572.99
  })), _line951 || (_line951 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 517.61,
    y1: 561.64,
    x2: 517.61,
    y2: 565.28
  })), _line952 || (_line952 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 523.47,
    y1: 561.64,
    x2: 523.47,
    y2: 565.28
  })), _line953 || (_line953 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 522.49,
    y1: 573.3,
    x2: 517.32,
    y2: 573.3
  })), _line954 || (_line954 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 522.49,
    y1: 578.82,
    x2: 517.32,
    y2: 578.82
  })), _line955 || (_line955 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 523.47,
    y1: 561.64,
    x2: 517.61,
    y2: 561.64
  })), _line956 || (_line956 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 524.74,
    y1: 565.49,
    x2: 524.74,
    y2: 572.68
  })), _line957 || (_line957 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.59,
    y1: 576.11,
    x2: 525.59,
    y2: 561.43
  })), _line958 || (_line958 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.26,
    y1: 561.43,
    x2: 516.26,
    y2: 554.14
  })), _line959 || (_line959 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.26,
    y1: 554.14,
    x2: 538.11,
    y2: 554.14
  })), _line960 || (_line960 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.59,
    y1: 576.11,
    x2: 538.11,
    y2: 576.11
  })), _line961 || (_line961 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.11,
    y1: 576.11,
    x2: 538.11,
    y2: 554.14
  })), _line962 || (_line962 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.59,
    y1: 561.43,
    x2: 516.26,
    y2: 561.43
  })), _line963 || (_line963 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.11,
    y1: 554.14,
    x2: 538.11,
    y2: 554.55
  })), _line964 || (_line964 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.95,
    y1: 587.26,
    x2: 519.95,
    y2: 578.93
  })), _line965 || (_line965 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 524.32,
    y1: 587.26,
    x2: 521.77,
    y2: 587.26
  })), _line966 || (_line966 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 524.32,
    y1: 578.93,
    x2: 519.95,
    y2: 578.93
  })), _line967 || (_line967 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 524.32,
    y1: 587.26,
    x2: 524.32,
    y2: 578.93
  })), _line968 || (_line968 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.71,
    y1: 587.26,
    x2: 519.95,
    y2: 587.26
  })), _line969 || (_line969 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.89,
    y1: 589.65,
    x2: 518.38,
    y2: 589.65
  })), _line970 || (_line970 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.89,
    y1: 589.65,
    x2: 539.89,
    y2: 590.8
  })), _line971 || (_line971 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.5,
    y1: 590.8,
    x2: 539.89,
    y2: 590.8
  })), _line972 || (_line972 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.38,
    y1: 611,
    x2: 541.5,
    y2: 611
  })), _line973 || (_line973 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.38,
    y1: 589.65,
    x2: 518.38,
    y2: 611
  })), _line974 || (_line974 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.5,
    y1: 590.8,
    x2: 541.5,
    y2: 611
  })), _line975 || (_line975 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.71,
    y1: 589.65,
    x2: 520.71,
    y2: 587.26
  })), _line976 || (_line976 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.77,
    y1: 589.65,
    x2: 521.77,
    y2: 587.26
  })), _line977 || (_line977 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 549.65,
    y1: 573.3,
    x2: 549.65,
    y2: 578.82
  })), _line978 || (_line978 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.83,
    y1: 573.3,
    x2: 554.83,
    y2: 578.82
  })), _polyline264 || (_polyline264 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "556.95 572.99 557.07 572.99 557.07 572.68"
  })), _polyline265 || (_polyline265 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "557.07 565.49 557.07 565.38 556.95 565.38"
  })), _polyline266 || (_polyline266 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "548.67 565.38 548.59 565.38 548.59 565.49"
  })), _polyline267 || (_polyline267 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "548.59 572.68 548.59 572.99 548.67 572.99"
  })), _line979 || (_line979 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.67,
    y1: 565.38,
    x2: 556.95,
    y2: 565.38
  })), _line980 || (_line980 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.59,
    y1: 572.68,
    x2: 548.59,
    y2: 565.49
  })), _line981 || (_line981 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 556.95,
    y1: 572.99,
    x2: 548.67,
    y2: 572.99
  })), _line982 || (_line982 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 549.95,
    y1: 561.64,
    x2: 549.95,
    y2: 565.28
  })), _line983 || (_line983 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.67,
    y1: 561.64,
    x2: 555.67,
    y2: 565.28
  })), _line984 || (_line984 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.83,
    y1: 573.3,
    x2: 549.65,
    y2: 573.3
  })), _line985 || (_line985 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.83,
    y1: 578.82,
    x2: 549.65,
    y2: 578.82
  })), _line986 || (_line986 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 555.67,
    y1: 561.64,
    x2: 549.95,
    y2: 561.64
  })), _line987 || (_line987 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 557.07,
    y1: 565.49,
    x2: 557.07,
    y2: 572.68
  })), _line988 || (_line988 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 557.8,
    y1: 576.11,
    x2: 557.8,
    y2: 561.43
  })), _line989 || (_line989 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.59,
    y1: 561.43,
    x2: 548.59,
    y2: 554.14
  })), _line990 || (_line990 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.59,
    y1: 554.14,
    x2: 570.4,
    y2: 554.14
  })), _line991 || (_line991 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 557.8,
    y1: 576.11,
    x2: 570.4,
    y2: 576.11
  })), _line992 || (_line992 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 570.4,
    y1: 576.11,
    x2: 570.4,
    y2: 554.14
  })), _line993 || (_line993 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 557.8,
    y1: 561.43,
    x2: 548.59,
    y2: 561.43
  })), _line994 || (_line994 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 570.4,
    y1: 554.14,
    x2: 570.4,
    y2: 554.55
  })), _line995 || (_line995 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.19,
    y1: 587.26,
    x2: 552.19,
    y2: 578.93
  })), _line996 || (_line996 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 556.65,
    y1: 587.26,
    x2: 553.98,
    y2: 587.26
  })), _line997 || (_line997 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 556.65,
    y1: 578.93,
    x2: 552.19,
    y2: 578.93
  })), _line998 || (_line998 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 556.65,
    y1: 587.26,
    x2: 556.65,
    y2: 578.93
  })), _line999 || (_line999 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.92,
    y1: 587.26,
    x2: 552.19,
    y2: 587.26
  })), _line1000 || (_line1000 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.09,
    y1: 589.65,
    x2: 550.58,
    y2: 589.65
  })), _line1001 || (_line1001 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.09,
    y1: 589.65,
    x2: 572.09,
    y2: 590.8
  })), _line1002 || (_line1002 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 573.71,
    y1: 590.8,
    x2: 572.09,
    y2: 590.8
  })), _line1003 || (_line1003 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 550.58,
    y1: 611,
    x2: 573.71,
    y2: 611
  })), _line1004 || (_line1004 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 550.58,
    y1: 589.65,
    x2: 550.58,
    y2: 611
  })), _line1005 || (_line1005 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 573.71,
    y1: 590.8,
    x2: 573.71,
    y2: 611
  })), _line1006 || (_line1006 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.92,
    y1: 589.65,
    x2: 552.92,
    y2: 587.26
  })), _line1007 || (_line1007 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.98,
    y1: 589.65,
    x2: 553.98,
    y2: 587.26
  })), _line1008 || (_line1008 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.98,
    y1: 573.3,
    x2: 581.98,
    y2: 578.82
  })), _line1009 || (_line1009 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.07,
    y1: 573.3,
    x2: 587.07,
    y2: 578.82
  })), _polyline268 || (_polyline268 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "589.07 572.99 589.41 572.99 589.41 572.68"
  })), _polyline269 || (_polyline269 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "589.41 565.49 589.41 565.38 589.07 565.38"
  })), _polyline270 || (_polyline270 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "581 565.38 580.92 565.38 580.71 565.49"
  })), _polyline271 || (_polyline271 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "580.71 572.68 580.92 572.99 581 572.99"
  })), _line1010 || (_line1010 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581,
    y1: 565.38,
    x2: 589.07,
    y2: 565.38
  })), _line1011 || (_line1011 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.71,
    y1: 572.68,
    x2: 580.71,
    y2: 565.49
  })), _line1012 || (_line1012 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 589.07,
    y1: 572.99,
    x2: 581,
    y2: 572.99
  })), _line1013 || (_line1013 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.07,
    y1: 561.64,
    x2: 582.07,
    y2: 565.28
  })), _line1014 || (_line1014 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 588.01,
    y1: 561.64,
    x2: 588.01,
    y2: 565.28
  })), _line1015 || (_line1015 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.07,
    y1: 573.3,
    x2: 581.98,
    y2: 573.3
  })), _line1016 || (_line1016 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.07,
    y1: 578.82,
    x2: 581.98,
    y2: 578.82
  })), _line1017 || (_line1017 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 588.01,
    y1: 561.64,
    x2: 582.07,
    y2: 561.64
  })), _line1018 || (_line1018 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 589.41,
    y1: 565.49,
    x2: 589.41,
    y2: 572.68
  })), _line1019 || (_line1019 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.13,
    y1: 576.11,
    x2: 590.13,
    y2: 561.43
  })), _line1020 || (_line1020 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.71,
    y1: 561.43,
    x2: 580.71,
    y2: 554.14
  })), _line1021 || (_line1021 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.71,
    y1: 554.14,
    x2: 602.52,
    y2: 554.14
  })), _line1022 || (_line1022 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.13,
    y1: 576.11,
    x2: 602.52,
    y2: 576.11
  })), _line1023 || (_line1023 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 602.52,
    y1: 576.11,
    x2: 602.52,
    y2: 554.14
  })), _line1024 || (_line1024 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.13,
    y1: 561.43,
    x2: 580.71,
    y2: 561.43
  })), _line1025 || (_line1025 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 602.52,
    y1: 554.14,
    x2: 602.52,
    y2: 554.55
  })), _line1026 || (_line1026 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.53,
    y1: 587.26,
    x2: 584.53,
    y2: 578.93
  })), _line1027 || (_line1027 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 588.77,
    y1: 587.26,
    x2: 586.31,
    y2: 587.26
  })), _line1028 || (_line1028 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 588.77,
    y1: 578.93,
    x2: 584.53,
    y2: 578.93
  })), _line1029 || (_line1029 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 588.77,
    y1: 587.26,
    x2: 588.77,
    y2: 578.93
  })), _line1030 || (_line1030 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 585.25,
    y1: 587.26,
    x2: 584.53,
    y2: 587.26
  })), _line1031 || (_line1031 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.34,
    y1: 589.65,
    x2: 582.83,
    y2: 589.65
  })), _line1032 || (_line1032 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.34,
    y1: 589.65,
    x2: 604.34,
    y2: 590.8
  })), _line1033 || (_line1033 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.04,
    y1: 590.8,
    x2: 604.34,
    y2: 590.8
  })), _line1034 || (_line1034 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.83,
    y1: 611,
    x2: 606.04,
    y2: 611
  })), _line1035 || (_line1035 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.83,
    y1: 589.65,
    x2: 582.83,
    y2: 611
  })), _line1036 || (_line1036 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.04,
    y1: 590.8,
    x2: 606.04,
    y2: 611
  })), _line1037 || (_line1037 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 585.25,
    y1: 589.65,
    x2: 585.25,
    y2: 587.26
  })), _line1038 || (_line1038 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.31,
    y1: 589.65,
    x2: 586.31,
    y2: 587.26
  })), _line1039 || (_line1039 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.18,
    y1: 573.3,
    x2: 614.18,
    y2: 578.82
  })), _line1040 || (_line1040 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.19,
    y1: 573.3,
    x2: 619.19,
    y2: 578.82
  })), _polyline272 || (_polyline272 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "621.31 572.99 621.52 572.99 621.61 572.68"
  })), _polyline273 || (_polyline273 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "621.61 565.49 621.52 565.38 621.31 565.38"
  })), _polyline274 || (_polyline274 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "613.34 565.38 613.12 565.38 613.04 565.49"
  })), _polyline275 || (_polyline275 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "613.04 572.68 613.12 572.99 613.34 572.99"
  })), _line1041 || (_line1041 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.34,
    y1: 565.38,
    x2: 621.31,
    y2: 565.38
  })), _line1042 || (_line1042 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.04,
    y1: 572.68,
    x2: 613.04,
    y2: 565.49
  })), _line1043 || (_line1043 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 621.31,
    y1: 572.99,
    x2: 613.34,
    y2: 572.99
  })), _line1044 || (_line1044 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.4,
    y1: 561.64,
    x2: 614.4,
    y2: 565.28
  })), _line1045 || (_line1045 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.25,
    y1: 561.64,
    x2: 620.25,
    y2: 565.28
  })), _line1046 || (_line1046 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.19,
    y1: 573.3,
    x2: 614.18,
    y2: 573.3
  })), _line1047 || (_line1047 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.4,
    y1: 578.82,
    x2: 614.18,
    y2: 578.82
  })), _line1048 || (_line1048 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.25,
    y1: 561.64,
    x2: 614.4,
    y2: 561.64
  })), _line1049 || (_line1049 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 621.61,
    y1: 565.49,
    x2: 621.61,
    y2: 572.68
  })), _line1050 || (_line1050 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 622.37,
    y1: 576.11,
    x2: 622.37,
    y2: 561.43
  })), _line1051 || (_line1051 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.04,
    y1: 561.43,
    x2: 613.04,
    y2: 554.14
  })), _line1052 || (_line1052 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.04,
    y1: 554.14,
    x2: 634.85,
    y2: 554.14
  })), _line1053 || (_line1053 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 622.37,
    y1: 576.11,
    x2: 634.85,
    y2: 576.11
  })), _line1054 || (_line1054 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 576.11,
    x2: 634.85,
    y2: 554.14
  })), _line1055 || (_line1055 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 622.37,
    y1: 561.43,
    x2: 613.04,
    y2: 561.43
  })), _line1056 || (_line1056 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 554.14,
    x2: 634.85,
    y2: 554.55
  })), _line1057 || (_line1057 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 616.73,
    y1: 587.26,
    x2: 616.73,
    y2: 578.93
  })), _line1058 || (_line1058 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.97,
    y1: 587.26,
    x2: 618.64,
    y2: 587.26
  })), _line1059 || (_line1059 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.97,
    y1: 578.93,
    x2: 616.73,
    y2: 578.93
  })), _line1060 || (_line1060 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.97,
    y1: 587.26,
    x2: 620.97,
    y2: 578.93
  })), _line1061 || (_line1061 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 617.58,
    y1: 587.26,
    x2: 616.73,
    y2: 587.26
  })), _line1062 || (_line1062 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 636.67,
    y1: 589.65,
    x2: 615.16,
    y2: 589.65
  })), _line1063 || (_line1063 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 636.67,
    y1: 589.65,
    x2: 636.67,
    y2: 590.8
  })), _line1064 || (_line1064 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.16,
    y1: 590.8,
    x2: 636.67,
    y2: 590.8
  })), _line1065 || (_line1065 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.16,
    y1: 611,
    x2: 638.16,
    y2: 611
  })), _line1066 || (_line1066 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.16,
    y1: 589.65,
    x2: 615.16,
    y2: 611
  })), _line1067 || (_line1067 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.16,
    y1: 590.8,
    x2: 638.16,
    y2: 611
  })), _line1068 || (_line1068 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 617.58,
    y1: 589.65,
    x2: 617.58,
    y2: 587.26
  })), _line1069 || (_line1069 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.64,
    y1: 589.65,
    x2: 618.64,
    y2: 587.26
  })), _line1070 || (_line1070 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.28,
    y1: 573.3,
    x2: 647.28,
    y2: 578.82
  })), _line1071 || (_line1071 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.33,
    y1: 573.3,
    x2: 652.33,
    y2: 578.82
  })), _polyline276 || (_polyline276 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "654.45 572.99 654.66 572.99 654.66 572.68"
  })), _polyline277 || (_polyline277 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "654.66 565.49 654.66 565.38 654.45 565.38"
  })), _polyline278 || (_polyline278 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "646.3 565.38 646.22 565.38 646.22 565.49"
  })), _polyline279 || (_polyline279 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "646.22 572.68 646.22 572.99 646.3 572.99"
  })), _line1072 || (_line1072 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.3,
    y1: 565.38,
    x2: 654.45,
    y2: 565.38
  })), _line1073 || (_line1073 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.22,
    y1: 572.68,
    x2: 646.22,
    y2: 565.49
  })), _line1074 || (_line1074 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.45,
    y1: 572.99,
    x2: 646.3,
    y2: 572.99
  })), _line1075 || (_line1075 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.58,
    y1: 561.64,
    x2: 647.58,
    y2: 565.28
  })), _line1076 || (_line1076 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.3,
    y1: 561.64,
    x2: 653.3,
    y2: 565.28
  })), _line1077 || (_line1077 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.33,
    y1: 573.3,
    x2: 647.28,
    y2: 573.3
  })), _line1078 || (_line1078 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.33,
    y1: 578.82,
    x2: 647.28,
    y2: 578.82
  })), _line1079 || (_line1079 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.3,
    y1: 561.64,
    x2: 647.58,
    y2: 561.64
  })), _line1080 || (_line1080 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.66,
    y1: 565.49,
    x2: 654.66,
    y2: 572.68
  })), _line1081 || (_line1081 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 655.51,
    y1: 576.11,
    x2: 655.51,
    y2: 561.43
  })), _line1082 || (_line1082 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.22,
    y1: 561.43,
    x2: 646.22,
    y2: 554.14
  })), _line1083 || (_line1083 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.22,
    y1: 554.14,
    x2: 668.03,
    y2: 554.14
  })), _line1084 || (_line1084 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 655.51,
    y1: 576.11,
    x2: 668.03,
    y2: 576.11
  })), _line1085 || (_line1085 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.03,
    y1: 576.11,
    x2: 668.03,
    y2: 554.14
  })), _line1086 || (_line1086 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 655.51,
    y1: 561.43,
    x2: 646.22,
    y2: 561.43
  })), _line1087 || (_line1087 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.03,
    y1: 554.14,
    x2: 668.03,
    y2: 554.55
  })), _line1088 || (_line1088 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 650,
    y1: 587.26,
    x2: 650,
    y2: 578.93
  })), _line1089 || (_line1089 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.24,
    y1: 587.26,
    x2: 651.61,
    y2: 587.26
  })), _line1090 || (_line1090 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.24,
    y1: 578.93,
    x2: 650,
    y2: 578.93
  })), _line1091 || (_line1091 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.24,
    y1: 587.26,
    x2: 654.24,
    y2: 578.93
  })), _line1092 || (_line1092 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 650.55,
    y1: 587.26,
    x2: 650,
    y2: 587.26
  })), _line1093 || (_line1093 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 669.85,
    y1: 589.65,
    x2: 648.34,
    y2: 589.65
  })), _line1094 || (_line1094 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 669.85,
    y1: 589.65,
    x2: 669.85,
    y2: 590.8
  })), _line1095 || (_line1095 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 590.8,
    x2: 669.85,
    y2: 590.8
  })), _line1096 || (_line1096 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.34,
    y1: 611,
    x2: 671.34,
    y2: 611
  })), _line1097 || (_line1097 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.34,
    y1: 589.65,
    x2: 648.34,
    y2: 611
  })), _line1098 || (_line1098 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 590.8,
    x2: 671.34,
    y2: 611
  })), _line1099 || (_line1099 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 650.55,
    y1: 589.65,
    x2: 650.55,
    y2: 587.26
  })), _line1100 || (_line1100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.61,
    y1: 589.65,
    x2: 651.61,
    y2: 587.26
  })), _line1101 || (_line1101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.79,
    y1: 573.3,
    x2: 684.79,
    y2: 578.82
  })), _line1102 || (_line1102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.96,
    y1: 573.3,
    x2: 689.96,
    y2: 578.82
  })), _polyline280 || (_polyline280 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "692.09 572.99 692.3 572.99 692.3 572.68"
  })), _polyline281 || (_polyline281 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "692.3 565.49 692.3 565.38 692.09 565.38"
  })), _polyline282 || (_polyline282 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "683.94 565.38 683.73 565.38 683.73 565.49"
  })), _polyline283 || (_polyline283 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "683.73 572.68 683.73 572.99 683.94 572.99"
  })), _line1103 || (_line1103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.94,
    y1: 565.38,
    x2: 692.09,
    y2: 565.38
  })), _line1104 || (_line1104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.73,
    y1: 572.68,
    x2: 683.73,
    y2: 565.49
  })), _line1105 || (_line1105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 692.09,
    y1: 572.99,
    x2: 683.94,
    y2: 572.99
  })), _line1106 || (_line1106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.08,
    y1: 561.64,
    x2: 685.08,
    y2: 565.28
  })), _line1107 || (_line1107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 690.94,
    y1: 561.64,
    x2: 690.94,
    y2: 565.28
  })), _line1108 || (_line1108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.96,
    y1: 573.3,
    x2: 684.79,
    y2: 573.3
  })), _line1109 || (_line1109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.96,
    y1: 578.82,
    x2: 684.79,
    y2: 578.82
  })), _line1110 || (_line1110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 690.94,
    y1: 561.64,
    x2: 685.08,
    y2: 561.64
  })), _line1111 || (_line1111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 692.3,
    y1: 565.49,
    x2: 692.3,
    y2: 572.68
  })), _line1112 || (_line1112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 693.06,
    y1: 576.11,
    x2: 693.06,
    y2: 561.43
  })), _line1113 || (_line1113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.73,
    y1: 561.43,
    x2: 683.73,
    y2: 554.14
  })), _line1114 || (_line1114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.73,
    y1: 554.14,
    x2: 705.54,
    y2: 554.14
  })), _line1115 || (_line1115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 693.06,
    y1: 576.11,
    x2: 705.54,
    y2: 576.11
  })), _line1116 || (_line1116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.54,
    y1: 576.11,
    x2: 705.54,
    y2: 554.14
  })), _line1117 || (_line1117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 693.06,
    y1: 561.43,
    x2: 683.73,
    y2: 561.43
  })), _line1118 || (_line1118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.54,
    y1: 554.14,
    x2: 705.54,
    y2: 554.55
  })), _line1119 || (_line1119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.42,
    y1: 587.26,
    x2: 687.42,
    y2: 578.93
  })), _line1120 || (_line1120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 691.79,
    y1: 587.26,
    x2: 689.24,
    y2: 587.26
  })), _line1121 || (_line1121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 691.79,
    y1: 578.93,
    x2: 687.42,
    y2: 578.93
  })), _line1122 || (_line1122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 691.79,
    y1: 587.26,
    x2: 691.79,
    y2: 578.93
  })), _line1123 || (_line1123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 688.18,
    y1: 587.26,
    x2: 687.42,
    y2: 587.26
  })), _line1124 || (_line1124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 707.23,
    y1: 589.65,
    x2: 685.72,
    y2: 589.65
  })), _line1125 || (_line1125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 707.23,
    y1: 589.65,
    x2: 707.23,
    y2: 590.8
  })), _line1126 || (_line1126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708.93,
    y1: 590.8,
    x2: 707.23,
    y2: 590.8
  })), _line1127 || (_line1127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.72,
    y1: 611,
    x2: 708.93,
    y2: 611
  })), _line1128 || (_line1128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.72,
    y1: 589.65,
    x2: 685.72,
    y2: 611
  })), _line1129 || (_line1129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708.93,
    y1: 590.8,
    x2: 708.93,
    y2: 611
  })), _line1130 || (_line1130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 688.18,
    y1: 589.65,
    x2: 688.18,
    y2: 587.26
  })), _line1131 || (_line1131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.24,
    y1: 589.65,
    x2: 689.24,
    y2: 587.26
  })), _line1132 || (_line1132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.84,
    y1: 573.3,
    x2: 717.84,
    y2: 578.82
  })), _line1133 || (_line1133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.06,
    y1: 573.3,
    x2: 723.06,
    y2: 578.82
  })), _polyline284 || (_polyline284 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "725.18 572.99 725.27 572.99 725.48 572.68"
  })), _polyline285 || (_polyline285 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "725.48 565.49 725.27 565.38 725.18 565.38"
  })), _polyline286 || (_polyline286 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "717.12 565.38 716.99 565.38 716.78 565.49"
  })), _polyline287 || (_polyline287 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "716.78 572.68 716.99 572.99 717.12 572.99"
  })), _line1134 || (_line1134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.12,
    y1: 565.38,
    x2: 725.18,
    y2: 565.38
  })), _line1135 || (_line1135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.78,
    y1: 572.68,
    x2: 716.78,
    y2: 565.49
  })), _line1136 || (_line1136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 725.18,
    y1: 572.99,
    x2: 717.12,
    y2: 572.99
  })), _line1137 || (_line1137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.18,
    y1: 561.64,
    x2: 718.18,
    y2: 565.28
  })), _line1138 || (_line1138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 724.12,
    y1: 561.64,
    x2: 724.12,
    y2: 565.28
  })), _line1139 || (_line1139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.06,
    y1: 573.3,
    x2: 717.84,
    y2: 573.3
  })), _line1140 || (_line1140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.14,
    y1: 578.82,
    x2: 717.84,
    y2: 578.82
  })), _line1141 || (_line1141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 724.12,
    y1: 561.64,
    x2: 718.18,
    y2: 561.64
  })), _line1142 || (_line1142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 725.48,
    y1: 565.49,
    x2: 725.48,
    y2: 572.68
  })), _line1143 || (_line1143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 726.24,
    y1: 576.11,
    x2: 726.24,
    y2: 561.43
  })), _line1144 || (_line1144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.78,
    y1: 561.43,
    x2: 716.78,
    y2: 554.14
  })), _line1145 || (_line1145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.78,
    y1: 554.14,
    x2: 738.63,
    y2: 554.14
  })), _line1146 || (_line1146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 726.24,
    y1: 576.11,
    x2: 738.63,
    y2: 576.11
  })), _line1147 || (_line1147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.63,
    y1: 576.11,
    x2: 738.63,
    y2: 554.14
  })), _line1148 || (_line1148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 726.24,
    y1: 561.43,
    x2: 716.78,
    y2: 561.43
  })), _line1149 || (_line1149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.63,
    y1: 554.14,
    x2: 738.63,
    y2: 554.55
  })), _line1150 || (_line1150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.6,
    y1: 587.26,
    x2: 720.6,
    y2: 578.93
  })), _line1151 || (_line1151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 724.84,
    y1: 587.26,
    x2: 722.3,
    y2: 587.26
  })), _line1152 || (_line1152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 724.84,
    y1: 578.93,
    x2: 720.6,
    y2: 578.93
  })), _line1153 || (_line1153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 724.84,
    y1: 587.26,
    x2: 724.84,
    y2: 578.93
  })), _line1154 || (_line1154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 721.36,
    y1: 587.26,
    x2: 720.6,
    y2: 587.26
  })), _line1155 || (_line1155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 573.3,
    x2: 751.02,
    y2: 578.82
  })), _line1156 || (_line1156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 756.24,
    y1: 573.3,
    x2: 756.24,
    y2: 578.82
  })), _polyline288 || (_polyline288 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "758.32 572.99 758.45 572.99 758.45 572.68"
  })), _polyline289 || (_polyline289 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "758.45 565.49 758.45 565.38 758.32 565.38"
  })), _polyline290 || (_polyline290 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "750.17 565.38 749.96 565.38 749.96 565.49"
  })), _polyline291 || (_polyline291 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "749.96 572.68 749.96 572.99 750.17 572.99"
  })), _line1157 || (_line1157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 750.17,
    y1: 565.38,
    x2: 758.32,
    y2: 565.38
  })), _line1158 || (_line1158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.96,
    y1: 572.68,
    x2: 749.96,
    y2: 565.49
  })), _line1159 || (_line1159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 758.32,
    y1: 572.99,
    x2: 750.17,
    y2: 572.99
  })), _line1160 || (_line1160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.36,
    y1: 561.64,
    x2: 751.36,
    y2: 565.28
  })), _line1161 || (_line1161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 757.17,
    y1: 561.64,
    x2: 757.17,
    y2: 565.28
  })), _line1162 || (_line1162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 756.24,
    y1: 573.3,
    x2: 751.02,
    y2: 573.3
  })), _line1163 || (_line1163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 756.24,
    y1: 578.82,
    x2: 751.02,
    y2: 578.82
  })), _line1164 || (_line1164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 757.17,
    y1: 561.64,
    x2: 751.36,
    y2: 561.64
  })), _line1165 || (_line1165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 758.45,
    y1: 565.49,
    x2: 758.45,
    y2: 572.68
  })), _line1166 || (_line1166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 759.29,
    y1: 576.11,
    x2: 759.29,
    y2: 561.43
  })), _line1167 || (_line1167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.96,
    y1: 561.43,
    x2: 749.96,
    y2: 554.14
  })), _line1168 || (_line1168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.96,
    y1: 554.14,
    x2: 771.81,
    y2: 554.14
  })), _line1169 || (_line1169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 759.29,
    y1: 576.11,
    x2: 771.81,
    y2: 576.11
  })), _line1170 || (_line1170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.81,
    y1: 576.11,
    x2: 771.81,
    y2: 554.14
  })), _line1171 || (_line1171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 759.29,
    y1: 561.43,
    x2: 749.96,
    y2: 561.43
  })), _line1172 || (_line1172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.81,
    y1: 554.14,
    x2: 771.81,
    y2: 554.55
  })), _line1173 || (_line1173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.69,
    y1: 587.26,
    x2: 753.69,
    y2: 578.93
  })), _line1174 || (_line1174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 758.02,
    y1: 587.26,
    x2: 755.48,
    y2: 587.26
  })), _line1175 || (_line1175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 758.02,
    y1: 578.93,
    x2: 753.69,
    y2: 578.93
  })), _line1176 || (_line1176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 758.02,
    y1: 587.26,
    x2: 758.02,
    y2: 578.93
  })), _line1177 || (_line1177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 754.41,
    y1: 587.26,
    x2: 753.69,
    y2: 587.26
  })), _line1178 || (_line1178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.12,
    y1: 573.3,
    x2: 784.12,
    y2: 578.82
  })), _line1179 || (_line1179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 789.29,
    y1: 573.3,
    x2: 789.29,
    y2: 578.82
  })), _polyline292 || (_polyline292 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "791.41 572.99 791.5 572.99 791.71 572.68"
  })), _polyline293 || (_polyline293 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "791.71 565.49 791.5 565.38 791.41 565.38"
  })), _polyline294 || (_polyline294 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "783.35 565.38 783.27 565.38 783.05 565.49"
  })), _polyline295 || (_polyline295 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "783.05 572.68 783.27 572.99 783.35 572.99"
  })), _line1180 || (_line1180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.35,
    y1: 565.38,
    x2: 791.41,
    y2: 565.38
  })), _line1181 || (_line1181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.05,
    y1: 572.68,
    x2: 783.05,
    y2: 565.49
  })), _line1182 || (_line1182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 791.41,
    y1: 572.99,
    x2: 783.35,
    y2: 572.99
  })), _line1183 || (_line1183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.41,
    y1: 561.64,
    x2: 784.41,
    y2: 565.28
  })), _line1184 || (_line1184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 790.35,
    y1: 561.64,
    x2: 790.35,
    y2: 565.28
  })), _line1185 || (_line1185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 789.29,
    y1: 573.3,
    x2: 784.12,
    y2: 573.3
  })), _line1186 || (_line1186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 789.38,
    y1: 578.82,
    x2: 784.12,
    y2: 578.82
  })), _line1187 || (_line1187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 790.35,
    y1: 561.64,
    x2: 784.41,
    y2: 561.64
  })), _line1188 || (_line1188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 791.71,
    y1: 565.49,
    x2: 791.71,
    y2: 572.68
  })), _line1189 || (_line1189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 792.47,
    y1: 576.11,
    x2: 792.47,
    y2: 561.43
  })), _line1190 || (_line1190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.05,
    y1: 561.43,
    x2: 783.05,
    y2: 554.14
  })), _line1191 || (_line1191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.05,
    y1: 554.14,
    x2: 804.86,
    y2: 554.14
  })), _line1192 || (_line1192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 792.47,
    y1: 576.11,
    x2: 804.86,
    y2: 576.11
  })), _line1193 || (_line1193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.86,
    y1: 576.11,
    x2: 804.86,
    y2: 554.14
  })), _line1194 || (_line1194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 792.47,
    y1: 561.43,
    x2: 783.05,
    y2: 561.43
  })), _line1195 || (_line1195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.86,
    y1: 554.14,
    x2: 804.86,
    y2: 554.55
  })), _line1196 || (_line1196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.83,
    y1: 587.26,
    x2: 786.83,
    y2: 578.93
  })), _line1197 || (_line1197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 791.07,
    y1: 587.26,
    x2: 788.53,
    y2: 587.26
  })), _line1198 || (_line1198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 791.07,
    y1: 578.93,
    x2: 786.83,
    y2: 578.93
  })), _line1199 || (_line1199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 791.07,
    y1: 587.26,
    x2: 791.07,
    y2: 578.93
  })), _line1200 || (_line1200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 787.59,
    y1: 587.26,
    x2: 786.83,
    y2: 587.26
  })), _line1201 || (_line1201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.51,
    y1: 232.02,
    x2: 476.71,
    y2: 232.02
  })), _line1202 || (_line1202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.65,
    y1: 232.02,
    x2: 475.65,
    y2: 234.43
  })), _line1203 || (_line1203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.51,
    y1: 234.43,
    x2: 476.71,
    y2: 234.43
  })), _line1204 || (_line1204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.95,
    y1: 232.02,
    x2: 543.28,
    y2: 232.02
  })), _line1205 || (_line1205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.01,
    y1: 232.02,
    x2: 542.01,
    y2: 234.43
  })), _line1206 || (_line1206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.95,
    y1: 234.43,
    x2: 543.28,
    y2: 234.43
  })), _line1207 || (_line1207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.59,
    y1: 211.8,
    x2: 437.59,
    y2: 207.65
  })), _line1208 || (_line1208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.05,
    y1: 230.77,
    x2: 440.05,
    y2: 239.3
  })), _line1209 || (_line1209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.99,
    y1: 230.77,
    x2: 438.99,
    y2: 241.79
  })), _line1210 || (_line1210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.6,
    y1: 230.77,
    x2: 442.6,
    y2: 222.74
  })), _line1211 || (_line1211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.6,
    y1: 222.74,
    x2: 438.65,
    y2: 219.21
  })), _line1212 || (_line1212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.59,
    y1: 241.79,
    x2: 437.59,
    y2: 230.77
  })), _line1213 || (_line1213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.65,
    y1: 219.21,
    x2: 438.65,
    y2: 211.8
  })), _line1214 || (_line1214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 433.69,
    y1: 210.56,
    x2: 433.69,
    y2: 207.65
  })), _line1215 || (_line1215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.74,
    y1: 207.15,
    x2: 436.74,
    y2: 207.65
  })), _line1216 || (_line1216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.05,
    y1: 207.15,
    x2: 436.74,
    y2: 207.15
  })), _line1217 || (_line1217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 433.69,
    y1: 207.65,
    x2: 437.59,
    y2: 207.65
  })), _line1218 || (_line1218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.75,
    y1: 242.21,
    x2: 441.33,
    y2: 242.21
  })), _line1219 || (_line1219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 439.42,
    y1: 239.3,
    x2: 441.75,
    y2: 239.3
  })), _line1220 || (_line1220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.75,
    y1: 239.3,
    x2: 441.75,
    y2: 242.21
  })), _line1221 || (_line1221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.33,
    y1: 247.12,
    x2: 441.33,
    y2: 241.79
  })), _line1222 || (_line1222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.39,
    y1: 247.12,
    x2: 441.33,
    y2: 247.12
  })), _line1223 || (_line1223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.33,
    y1: 241.79,
    x2: 435.39,
    y2: 241.79
  })), _line1224 || (_line1224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.11,
    y1: 241.17,
    x2: 416.5,
    y2: 241.17
  })), _line1225 || (_line1225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.11,
    y1: 241.17,
    x2: 434.11,
    y2: 259.51
  })), _line1226 || (_line1226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.99,
    y1: 251.07,
    x2: 435.68,
    y2: 251.07
  })), _line1227 || (_line1227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.39,
    y1: 241.79,
    x2: 435.39,
    y2: 247.12
  })), _line1228 || (_line1228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.59,
    y1: 210.56,
    x2: 433.69,
    y2: 210.56
  })), _line1229 || (_line1229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.6,
    y1: 211.18,
    x2: 442.6,
    y2: 207.15
  })), _line1230 || (_line1230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.6,
    y1: 207.15,
    x2: 440.05,
    y2: 207.15
  })), _line1231 || (_line1231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.59,
    y1: 211.18,
    x2: 442.6,
    y2: 211.18
  })), _line1232 || (_line1232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.68,
    y1: 247.45,
    x2: 435.68,
    y2: 251.07
  })), _line1233 || (_line1233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.99,
    y1: 247.45,
    x2: 440.99,
    y2: 251.07
  })), _line1234 || (_line1234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.99,
    y1: 247.45,
    x2: 435.68,
    y2: 247.45
  })), _line1235 || (_line1235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.65,
    y1: 211.8,
    x2: 414.6,
    y2: 211.8
  })), _line1236 || (_line1236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 442.6,
    y1: 230.77,
    x2: 414.6,
    y2: 230.77
  })), _line1237 || (_line1237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 414.6,
    y1: 230.77,
    x2: 414.6,
    y2: 211.8
  })), _line1238 || (_line1238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 416.5,
    y1: 259.51,
    x2: 416.5,
    y2: 241.17
  })), _line1239 || (_line1239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 434.11,
    y1: 259.51,
    x2: 416.5,
    y2: 259.51
  })), _line1240 || (_line1240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.74,
    y1: 241.79,
    x2: 436.74,
    y2: 230.77
  })), _line1241 || (_line1241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.65,
    y1: 327.02,
    x2: 420.87,
    y2: 327.02
  })), _line1242 || (_line1242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423.21,
    y1: 361.37,
    x2: 415.78,
    y2: 361.37
  })), _line1243 || (_line1243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 412.6,
    y1: 346.77,
    x2: 415.78,
    y2: 349.89
  })), _line1244 || (_line1244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.78,
    y1: 357.21,
    x2: 415.78,
    y2: 349.89
  })), _line1245 || (_line1245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.69,
    y1: 357.21,
    x2: 415.78,
    y2: 357.21
  })), _line1246 || (_line1246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 412.6,
    y1: 338.04,
    x2: 440.69,
    y2: 338.04
  })), _line1247 || (_line1247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 412.6,
    y1: 346.77,
    x2: 412.6,
    y2: 338.04
  })), _line1248 || (_line1248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 440.69,
    y1: 338.04,
    x2: 440.69,
    y2: 357.21
  })), _line1249 || (_line1249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.6,
    y1: 328.26,
    x2: 413.32,
    y2: 328.26
  })), _polyline296 || (_polyline296 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "413.24 328.05 413.24 328.26 413.32 328.26"
  })), _line1250 || (_line1250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.24,
    y1: 323.15,
    x2: 412.05,
    y2: 323.15
  })), _polyline297 || (_polyline297 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "419.6 328.26 419.69 328.26 419.69 328.05"
  })), _polyline298 || (_polyline298 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "413.32 321.77 413.24 321.98 413.24 322.11"
  })), _line1251 || (_line1251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.32,
    y1: 321.77,
    x2: 419.6,
    y2: 321.77
  })), _line1252 || (_line1252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.69,
    y1: 317.53,
    x2: 412.05,
    y2: 317.53
  })), _line1253 || (_line1253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.69,
    y1: 321.98,
    x2: 419.6,
    y2: 321.77
  })), _line1254 || (_line1254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.69,
    y1: 317.53,
    x2: 419.69,
    y2: 328.05
  })), _line1255 || (_line1255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.87,
    y1: 327.02,
    x2: 420.87,
    y2: 313.66
  })), _line1256 || (_line1256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 412.05,
    y1: 323.15,
    x2: 412.05,
    y2: 317.53
  })), _line1257 || (_line1257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.24,
    y1: 328.05,
    x2: 413.24,
    y2: 321.98
  })), _line1258 || (_line1258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.65,
    y1: 327.02,
    x2: 438.65,
    y2: 313.66
  })), _line1259 || (_line1259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.54,
    y1: 324.81,
    x2: 431.27,
    y2: 324.81
  })), _line1260 || (_line1260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.54,
    y1: 314.7,
    x2: 431.27,
    y2: 314.7
  })), _line1261 || (_line1261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 420.87,
    y1: 313.66,
    x2: 438.65,
    y2: 313.66
  })), _line1262 || (_line1262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 431.27,
    y1: 324.81,
    x2: 431.27,
    y2: 314.7
  })), _line1263 || (_line1263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.54,
    y1: 324.81,
    x2: 441.54,
    y2: 314.7
  })), _line1264 || (_line1264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.44,
    y1: 328.26,
    x2: 415.44,
    y2: 338.04
  })), _line1265 || (_line1265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.06,
    y1: 328.26,
    x2: 417.06,
    y2: 338.04
  })), _line1266 || (_line1266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.78,
    y1: 361.37,
    x2: 415.78,
    y2: 357.21
  })), _line1267 || (_line1267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423.21,
    y1: 357.21,
    x2: 423.21,
    y2: 361.37
  })), _line1268 || (_line1268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 470.77,
    y1: 211.8,
    x2: 470.77,
    y2: 207.65
  })), _line1269 || (_line1269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.23,
    y1: 230.77,
    x2: 473.23,
    y2: 239.3
  })), _line1270 || (_line1270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 472.17,
    y1: 230.77,
    x2: 472.17,
    y2: 241.79
  })), _line1271 || (_line1271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.86,
    y1: 230.77,
    x2: 475.86,
    y2: 222.74
  })), _line1272 || (_line1272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.86,
    y1: 222.74,
    x2: 471.83,
    y2: 219.21
  })), _line1273 || (_line1273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 470.77,
    y1: 241.79,
    x2: 470.77,
    y2: 230.77
  })), _line1274 || (_line1274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.83,
    y1: 219.21,
    x2: 471.83,
    y2: 211.8
  })), _line1275 || (_line1275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 466.87,
    y1: 210.56,
    x2: 466.87,
    y2: 207.65
  })), _line1276 || (_line1276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 469.92,
    y1: 207.15,
    x2: 469.92,
    y2: 207.65
  })), _line1277 || (_line1277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.23,
    y1: 207.15,
    x2: 469.92,
    y2: 207.15
  })), _line1278 || (_line1278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 466.87,
    y1: 207.65,
    x2: 470.77,
    y2: 207.65
  })), _line1279 || (_line1279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 472.68,
    y1: 239.3,
    x2: 472.68,
    y2: 241.79
  })), _line1280 || (_line1280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.93,
    y1: 242.21,
    x2: 474.51,
    y2: 242.21
  })), _line1281 || (_line1281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 472.68,
    y1: 239.3,
    x2: 474.93,
    y2: 239.3
  })), _line1282 || (_line1282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.93,
    y1: 239.3,
    x2: 474.93,
    y2: 242.21
  })), _line1283 || (_line1283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.51,
    y1: 247.12,
    x2: 474.51,
    y2: 241.79
  })), _line1284 || (_line1284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.57,
    y1: 247.12,
    x2: 474.51,
    y2: 247.12
  })), _line1285 || (_line1285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.51,
    y1: 241.79,
    x2: 468.57,
    y2: 241.79
  })), _line1286 || (_line1286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.29,
    y1: 241.17,
    x2: 449.81,
    y2: 241.17
  })), _line1287 || (_line1287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.29,
    y1: 241.17,
    x2: 467.29,
    y2: 259.51
  })), _line1288 || (_line1288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.17,
    y1: 251.07,
    x2: 468.86,
    y2: 251.07
  })), _line1289 || (_line1289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.57,
    y1: 241.79,
    x2: 468.57,
    y2: 247.12
  })), _line1290 || (_line1290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 470.77,
    y1: 210.56,
    x2: 466.87,
    y2: 210.56
  })), _line1291 || (_line1291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.86,
    y1: 211.18,
    x2: 475.86,
    y2: 207.15
  })), _line1292 || (_line1292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.86,
    y1: 207.15,
    x2: 473.23,
    y2: 207.15
  })), _line1293 || (_line1293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 470.77,
    y1: 211.18,
    x2: 475.86,
    y2: 211.18
  })), _line1294 || (_line1294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.86,
    y1: 247.45,
    x2: 468.86,
    y2: 251.07
  })), _line1295 || (_line1295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.17,
    y1: 247.45,
    x2: 474.17,
    y2: 251.07
  })), _line1296 || (_line1296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.17,
    y1: 247.45,
    x2: 468.86,
    y2: 247.45
  })), _line1297 || (_line1297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.83,
    y1: 211.8,
    x2: 447.78,
    y2: 211.8
  })), _line1298 || (_line1298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 475.86,
    y1: 230.77,
    x2: 447.78,
    y2: 230.77
  })), _line1299 || (_line1299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 447.78,
    y1: 230.77,
    x2: 447.78,
    y2: 211.8
  })), _line1300 || (_line1300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 449.81,
    y1: 259.51,
    x2: 449.81,
    y2: 241.17
  })), _line1301 || (_line1301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 467.29,
    y1: 259.51,
    x2: 449.81,
    y2: 259.51
  })), _line1302 || (_line1302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 469.92,
    y1: 241.79,
    x2: 469.92,
    y2: 230.77
  })), _line1303 || (_line1303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.16,
    y1: 211.8,
    x2: 504.16,
    y2: 207.65
  })), _line1304 || (_line1304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.41,
    y1: 230.77,
    x2: 506.41,
    y2: 239.3
  })), _line1305 || (_line1305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.56,
    y1: 230.77,
    x2: 505.56,
    y2: 241.79
  })), _line1306 || (_line1306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 230.77,
    x2: 509.17,
    y2: 222.74
  })), _line1307 || (_line1307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 222.74,
    x2: 505.23,
    y2: 219.21
  })), _line1308 || (_line1308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.16,
    y1: 241.79,
    x2: 504.16,
    y2: 230.77
  })), _line1309 || (_line1309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.23,
    y1: 219.21,
    x2: 505.23,
    y2: 211.8
  })), _line1310 || (_line1310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 500.26,
    y1: 210.56,
    x2: 500.26,
    y2: 207.65
  })), _line1311 || (_line1311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.1,
    y1: 207.15,
    x2: 503.1,
    y2: 207.65
  })), _line1312 || (_line1312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.41,
    y1: 207.15,
    x2: 503.1,
    y2: 207.15
  })), _line1313 || (_line1313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 500.26,
    y1: 207.65,
    x2: 504.16,
    y2: 207.65
  })), _line1314 || (_line1314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.86,
    y1: 239.3,
    x2: 505.86,
    y2: 241.79
  })), _line1315 || (_line1315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 508.32,
    y1: 242.21,
    x2: 507.77,
    y2: 242.21
  })), _line1316 || (_line1316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.86,
    y1: 239.3,
    x2: 508.32,
    y2: 239.3
  })), _line1317 || (_line1317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 508.32,
    y1: 239.3,
    x2: 508.32,
    y2: 242.21
  })), _line1318 || (_line1318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.77,
    y1: 247.12,
    x2: 507.77,
    y2: 241.79
  })), _line1319 || (_line1319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.96,
    y1: 247.12,
    x2: 507.77,
    y2: 247.12
  })), _line1320 || (_line1320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.77,
    y1: 241.79,
    x2: 501.96,
    y2: 241.79
  })), _line1321 || (_line1321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 500.69,
    y1: 241.17,
    x2: 482.99,
    y2: 241.17
  })), _line1322 || (_line1322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 500.69,
    y1: 241.17,
    x2: 500.69,
    y2: 259.51
  })), _line1323 || (_line1323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.47,
    y1: 251.07,
    x2: 502.17,
    y2: 251.07
  })), _line1324 || (_line1324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.47,
    y1: 247.45,
    x2: 507.47,
    y2: 251.07
  })), _line1325 || (_line1325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.96,
    y1: 241.79,
    x2: 501.96,
    y2: 247.12
  })), _line1326 || (_line1326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.16,
    y1: 210.56,
    x2: 500.26,
    y2: 210.56
  })), _line1327 || (_line1327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 211.18,
    x2: 509.17,
    y2: 207.15
  })), _line1328 || (_line1328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 207.15,
    x2: 506.41,
    y2: 207.15
  })), _line1329 || (_line1329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.16,
    y1: 211.18,
    x2: 509.17,
    y2: 211.18
  })), _line1330 || (_line1330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 502.17,
    y1: 247.45,
    x2: 502.17,
    y2: 251.07
  })), _line1331 || (_line1331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.47,
    y1: 247.45,
    x2: 502.17,
    y2: 247.45
  })), _line1332 || (_line1332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.23,
    y1: 211.8,
    x2: 480.96,
    y2: 211.8
  })), _line1333 || (_line1333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 509.17,
    y1: 230.77,
    x2: 480.96,
    y2: 230.77
  })), _line1334 || (_line1334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 480.96,
    y1: 230.77,
    x2: 480.96,
    y2: 211.8
  })), _line1335 || (_line1335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 482.99,
    y1: 259.51,
    x2: 482.99,
    y2: 241.17
  })), _line1336 || (_line1336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 500.69,
    y1: 259.51,
    x2: 482.99,
    y2: 259.51
  })), _line1337 || (_line1337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.1,
    y1: 241.79,
    x2: 503.1,
    y2: 230.77
  })), _line1338 || (_line1338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.68,
    y1: 230.77,
    x2: 539.68,
    y2: 239.3
  })), _line1339 || (_line1339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.74,
    y1: 230.77,
    x2: 538.74,
    y2: 241.79
  })), _line1340 || (_line1340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 230.77,
    x2: 542.22,
    y2: 222.74
  })), _line1341 || (_line1341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 222.74,
    x2: 538.32,
    y2: 219.21
  })), _line1342 || (_line1342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.26,
    y1: 241.79,
    x2: 537.26,
    y2: 230.77
  })), _line1343 || (_line1343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.32,
    y1: 219.21,
    x2: 538.32,
    y2: 211.8
  })), _line1344 || (_line1344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 533.44,
    y1: 210.56,
    x2: 533.44,
    y2: 207.44
  })), _line1345 || (_line1345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 536.28,
    y1: 207.15,
    x2: 536.28,
    y2: 207.44
  })), _line1346 || (_line1346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.68,
    y1: 207.15,
    x2: 536.28,
    y2: 207.15
  })), _line1347 || (_line1347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 533.44,
    y1: 207.44,
    x2: 537.26,
    y2: 207.44
  })), _line1348 || (_line1348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.04,
    y1: 239.3,
    x2: 539.04,
    y2: 241.79
  })), _line1349 || (_line1349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.29,
    y1: 242.21,
    x2: 540.87,
    y2: 242.21
  })), _line1350 || (_line1350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 539.04,
    y1: 239.3,
    x2: 541.29,
    y2: 239.3
  })), _line1351 || (_line1351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.29,
    y1: 239.3,
    x2: 541.29,
    y2: 242.21
  })), _line1352 || (_line1352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.87,
    y1: 247.12,
    x2: 540.87,
    y2: 241.79
  })), _line1353 || (_line1353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.14,
    y1: 247.12,
    x2: 540.87,
    y2: 247.12
  })), _line1354 || (_line1354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.87,
    y1: 241.79,
    x2: 535.14,
    y2: 241.79
  })), _line1355 || (_line1355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 533.74,
    y1: 241.17,
    x2: 516.13,
    y2: 241.17
  })), _line1356 || (_line1356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 533.74,
    y1: 241.17,
    x2: 533.74,
    y2: 259.51
  })), _line1357 || (_line1357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.53,
    y1: 251.07,
    x2: 535.43,
    y2: 251.07
  })), _line1358 || (_line1358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.53,
    y1: 247.45,
    x2: 540.53,
    y2: 251.07
  })), _line1359 || (_line1359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.14,
    y1: 241.79,
    x2: 535.14,
    y2: 247.12
  })), _line1360 || (_line1360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.26,
    y1: 210.56,
    x2: 533.44,
    y2: 210.56
  })), _line1361 || (_line1361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 211.18,
    x2: 542.22,
    y2: 207.15
  })), _line1362 || (_line1362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 207.15,
    x2: 539.68,
    y2: 207.15
  })), _line1363 || (_line1363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.26,
    y1: 211.18,
    x2: 542.22,
    y2: 211.18
  })), _line1364 || (_line1364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 535.43,
    y1: 247.45,
    x2: 535.43,
    y2: 251.07
  })), _line1365 || (_line1365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.53,
    y1: 247.45,
    x2: 535.43,
    y2: 247.45
  })), _line1366 || (_line1366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.32,
    y1: 211.8,
    x2: 514.14,
    y2: 211.8
  })), _line1367 || (_line1367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 542.22,
    y1: 230.77,
    x2: 514.14,
    y2: 230.77
  })), _line1368 || (_line1368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 514.14,
    y1: 230.77,
    x2: 514.14,
    y2: 211.8
  })), _line1369 || (_line1369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.13,
    y1: 259.51,
    x2: 516.13,
    y2: 241.17
  })), _line1370 || (_line1370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 533.74,
    y1: 259.51,
    x2: 516.13,
    y2: 259.51
  })), _line1371 || (_line1371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 536.28,
    y1: 241.79,
    x2: 536.28,
    y2: 230.77
  })), _line1372 || (_line1372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 439.42,
    y1: 239.3,
    x2: 439.42,
    y2: 241.79
  })), _line1373 || (_line1373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.83,
    y1: 327.02,
    x2: 454.05,
    y2: 327.02
  })), _line1374 || (_line1374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 456.47,
    y1: 361.37,
    x2: 448.84,
    y2: 361.37
  })), _line1375 || (_line1375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.78,
    y1: 346.77,
    x2: 448.84,
    y2: 349.89
  })), _line1376 || (_line1376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.84,
    y1: 357.21,
    x2: 448.84,
    y2: 349.89
  })), _line1377 || (_line1377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.87,
    y1: 357.21,
    x2: 448.84,
    y2: 357.21
  })), _line1378 || (_line1378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.78,
    y1: 338.04,
    x2: 473.87,
    y2: 338.04
  })), _line1379 || (_line1379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.78,
    y1: 346.77,
    x2: 445.78,
    y2: 338.04
  })), _line1380 || (_line1380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 473.87,
    y1: 338.04,
    x2: 473.87,
    y2: 357.21
  })), _line1381 || (_line1381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.78,
    y1: 328.26,
    x2: 446.63,
    y2: 328.26
  })), _polyline299 || (_polyline299 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "446.42 328.05 446.42 328.26 446.63 328.26"
  })), _line1382 || (_line1382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.42,
    y1: 323.15,
    x2: 445.02,
    y2: 323.15
  })), _polyline300 || (_polyline300 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "452.78 328.26 452.99 328.26 452.99 328.05"
  })), _polyline301 || (_polyline301 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "446.63 321.77 446.42 321.98 446.42 322.11"
  })), _line1383 || (_line1383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.63,
    y1: 321.77,
    x2: 452.78,
    y2: 321.77
  })), _line1384 || (_line1384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.99,
    y1: 317.53,
    x2: 445.02,
    y2: 317.53
  })), _line1385 || (_line1385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.99,
    y1: 321.98,
    x2: 452.78,
    y2: 321.77
  })), _line1386 || (_line1386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.99,
    y1: 317.53,
    x2: 452.99,
    y2: 328.05
  })), _line1387 || (_line1387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.05,
    y1: 327.02,
    x2: 454.05,
    y2: 313.66
  })), _line1388 || (_line1388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.02,
    y1: 323.15,
    x2: 445.02,
    y2: 317.53
  })), _line1389 || (_line1389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.42,
    y1: 328.05,
    x2: 446.42,
    y2: 321.98
  })), _line1390 || (_line1390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.83,
    y1: 327.02,
    x2: 471.83,
    y2: 313.66
  })), _line1391 || (_line1391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.59,
    y1: 324.81,
    x2: 464.32,
    y2: 324.81
  })), _line1392 || (_line1392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.59,
    y1: 314.7,
    x2: 464.32,
    y2: 314.7
  })), _line1393 || (_line1393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.05,
    y1: 313.66,
    x2: 471.83,
    y2: 313.66
  })), _line1394 || (_line1394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 464.32,
    y1: 324.81,
    x2: 464.32,
    y2: 314.7
  })), _line1395 || (_line1395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 474.59,
    y1: 324.81,
    x2: 474.59,
    y2: 314.7
  })), _line1396 || (_line1396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.75,
    y1: 328.26,
    x2: 448.75,
    y2: 338.04
  })), _line1397 || (_line1397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 450.24,
    y1: 328.26,
    x2: 450.24,
    y2: 338.04
  })), _line1398 || (_line1398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.84,
    y1: 361.37,
    x2: 448.84,
    y2: 357.21
  })), _line1399 || (_line1399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 456.47,
    y1: 357.21,
    x2: 456.47,
    y2: 361.37
  })), _line1400 || (_line1400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.23,
    y1: 327.02,
    x2: 487.32,
    y2: 327.02
  })), _line1401 || (_line1401 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 489.74,
    y1: 361.37,
    x2: 482.36,
    y2: 361.37
  })), _line1402 || (_line1402 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.17,
    y1: 346.98,
    x2: 482.23,
    y2: 349.89
  })), _line1403 || (_line1403 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 482.23,
    y1: 357.21,
    x2: 482.23,
    y2: 349.89
  })), _line1404 || (_line1404 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.26,
    y1: 357.21,
    x2: 482.23,
    y2: 357.21
  })), _line1405 || (_line1405 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.17,
    y1: 338.04,
    x2: 507.26,
    y2: 338.04
  })), _line1406 || (_line1406 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.17,
    y1: 346.98,
    x2: 479.17,
    y2: 338.04
  })), _line1407 || (_line1407 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.26,
    y1: 338.04,
    x2: 507.26,
    y2: 357.21
  })), _line1408 || (_line1408 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.17,
    y1: 328.35,
    x2: 479.89,
    y2: 328.35
  })), _polyline302 || (_polyline302 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "479.81 328.05 479.81 328.26 479.89 328.35"
  })), _line1409 || (_line1409 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.81,
    y1: 323.15,
    x2: 478.54,
    y2: 323.15
  })), _polyline303 || (_polyline303 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "486.17 328.35 486.26 328.26 486.26 328.05"
  })), _polyline304 || (_polyline304 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "479.89 321.98 479.81 321.98 479.81 322.11"
  })), _line1410 || (_line1410 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.89,
    y1: 321.98,
    x2: 486.17,
    y2: 321.98
  })), _line1411 || (_line1411 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.26,
    y1: 317.53,
    x2: 478.54,
    y2: 317.53
  })), _polyline305 || (_polyline305 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "486.26 322.11 486.26 321.98 486.17 321.98"
  })), _line1412 || (_line1412 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.26,
    y1: 317.53,
    x2: 486.26,
    y2: 328.05
  })), _line1413 || (_line1413 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.32,
    y1: 327.02,
    x2: 487.32,
    y2: 313.66
  })), _line1414 || (_line1414 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 478.54,
    y1: 323.15,
    x2: 478.54,
    y2: 317.53
  })), _line1415 || (_line1415 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.81,
    y1: 328.05,
    x2: 479.81,
    y2: 322.11
  })), _line1416 || (_line1416 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.23,
    y1: 327.02,
    x2: 505.23,
    y2: 313.66
  })), _line1417 || (_line1417 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 508.11,
    y1: 324.81,
    x2: 497.8,
    y2: 324.81
  })), _line1418 || (_line1418 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 508.11,
    y1: 314.7,
    x2: 497.8,
    y2: 314.7
  })), _line1419 || (_line1419 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.32,
    y1: 313.66,
    x2: 505.23,
    y2: 313.66
  })), _line1420 || (_line1420 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 497.8,
    y1: 324.81,
    x2: 497.8,
    y2: 314.7
  })), _line1421 || (_line1421 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 508.11,
    y1: 324.81,
    x2: 508.11,
    y2: 314.7
  })), _line1422 || (_line1422 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 482.02,
    y1: 328.35,
    x2: 482.02,
    y2: 338.04
  })), _line1423 || (_line1423 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 483.63,
    y1: 328.35,
    x2: 483.63,
    y2: 338.04
  })), _line1424 || (_line1424 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 482.36,
    y1: 361.37,
    x2: 482.36,
    y2: 357.21
  })), _line1425 || (_line1425 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 489.74,
    y1: 357.21,
    x2: 489.74,
    y2: 361.37
  })), _line1426 || (_line1426 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.4,
    y1: 327.02,
    x2: 520.37,
    y2: 327.02
  })), _line1427 || (_line1427 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 522.83,
    y1: 361.37,
    x2: 515.41,
    y2: 361.37
  })), _line1428 || (_line1428 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.23,
    y1: 346.98,
    x2: 515.41,
    y2: 349.89
  })), _line1429 || (_line1429 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 515.41,
    y1: 357.21,
    x2: 515.41,
    y2: 349.89
  })), _line1430 || (_line1430 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.23,
    y1: 357.21,
    x2: 515.41,
    y2: 357.21
  })), _line1431 || (_line1431 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.23,
    y1: 338.04,
    x2: 540.23,
    y2: 338.04
  })), _line1432 || (_line1432 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.23,
    y1: 346.98,
    x2: 512.23,
    y2: 338.04
  })), _line1433 || (_line1433 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 540.23,
    y1: 338.04,
    x2: 540.23,
    y2: 357.21
  })), _line1434 || (_line1434 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.31,
    y1: 328.35,
    x2: 513.07,
    y2: 328.35
  })), _polyline306 || (_polyline306 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "512.99 328.05 512.99 328.26 513.07 328.35"
  })), _line1435 || (_line1435 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.99,
    y1: 323.15,
    x2: 511.59,
    y2: 323.15
  })), _polyline307 || (_polyline307 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "519.31 328.35 519.31 328.26 519.44 328.05"
  })), _polyline308 || (_polyline308 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "513.07 321.98 512.99 321.98 512.99 322.11"
  })), _line1436 || (_line1436 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 513.07,
    y1: 321.98,
    x2: 519.31,
    y2: 321.98
  })), _line1437 || (_line1437 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.44,
    y1: 317.53,
    x2: 511.59,
    y2: 317.53
  })), _line1438 || (_line1438 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.44,
    y1: 322.11,
    x2: 519.31,
    y2: 321.98
  })), _line1439 || (_line1439 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.44,
    y1: 317.53,
    x2: 519.44,
    y2: 328.05
  })), _line1440 || (_line1440 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.37,
    y1: 327.02,
    x2: 520.37,
    y2: 313.66
  })), _line1441 || (_line1441 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 511.59,
    y1: 323.15,
    x2: 511.59,
    y2: 317.53
  })), _line1442 || (_line1442 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.99,
    y1: 328.05,
    x2: 512.99,
    y2: 322.11
  })), _line1443 || (_line1443 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.4,
    y1: 327.02,
    x2: 538.4,
    y2: 313.66
  })), _line1444 || (_line1444 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.16,
    y1: 324.81,
    x2: 530.89,
    y2: 324.81
  })), _line1445 || (_line1445 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.16,
    y1: 314.7,
    x2: 530.89,
    y2: 314.7
  })), _line1446 || (_line1446 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.37,
    y1: 313.66,
    x2: 538.4,
    y2: 313.66
  })), _line1447 || (_line1447 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 530.89,
    y1: 324.81,
    x2: 530.89,
    y2: 314.7
  })), _line1448 || (_line1448 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 541.16,
    y1: 324.81,
    x2: 541.16,
    y2: 314.7
  })), _line1449 || (_line1449 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 515.07,
    y1: 328.35,
    x2: 515.07,
    y2: 338.04
  })), _line1450 || (_line1450 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.77,
    y1: 328.35,
    x2: 516.77,
    y2: 338.04
  })), _line1451 || (_line1451 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 515.41,
    y1: 361.37,
    x2: 515.41,
    y2: 357.21
  })), _line1452 || (_line1452 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 522.83,
    y1: 357.21,
    x2: 522.83,
    y2: 361.37
  })), _line1453 || (_line1453 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.8,
    y1: 327.02,
    x2: 553.89,
    y2: 327.02
  })), _line1454 || (_line1454 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 556.31,
    y1: 361.37,
    x2: 548.67,
    y2: 361.37
  })), _line1455 || (_line1455 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 545.7,
    y1: 346.98,
    x2: 548.67,
    y2: 349.89
  })), _line1456 || (_line1456 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.67,
    y1: 357.21,
    x2: 548.67,
    y2: 349.89
  })), _line1457 || (_line1457 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 573.71,
    y1: 357.21,
    x2: 548.67,
    y2: 357.21
  })), _line1458 || (_line1458 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 545.7,
    y1: 338.04,
    x2: 573.71,
    y2: 338.04
  })), _line1459 || (_line1459 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 545.7,
    y1: 346.98,
    x2: 545.7,
    y2: 338.04
  })), _line1460 || (_line1460 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 573.71,
    y1: 338.04,
    x2: 573.71,
    y2: 357.21
  })), _line1461 || (_line1461 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.7,
    y1: 328.35,
    x2: 546.47,
    y2: 328.35
  })), _polyline309 || (_polyline309 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "546.25 328.05 546.25 328.26 546.47 328.35"
  })), _line1462 || (_line1462 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.25,
    y1: 323.15,
    x2: 545.07,
    y2: 323.15
  })), _polyline310 || (_polyline310 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "552.7 328.35 552.83 328.26 552.83 328.05"
  })), _polyline311 || (_polyline311 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "546.47 321.98 546.25 321.98 546.25 322.11"
  })), _line1463 || (_line1463 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.47,
    y1: 321.98,
    x2: 552.7,
    y2: 321.98
  })), _line1464 || (_line1464 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.83,
    y1: 317.53,
    x2: 545.07,
    y2: 317.53
  })), _polyline312 || (_polyline312 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "552.83 322.11 552.83 321.98 552.7 321.98"
  })), _line1465 || (_line1465 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.83,
    y1: 317.53,
    x2: 552.83,
    y2: 328.05
  })), _line1466 || (_line1466 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.89,
    y1: 327.02,
    x2: 553.89,
    y2: 313.66
  })), _line1467 || (_line1467 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 545.07,
    y1: 323.15,
    x2: 545.07,
    y2: 317.53
  })), _line1468 || (_line1468 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.25,
    y1: 328.05,
    x2: 546.25,
    y2: 322.11
  })), _line1469 || (_line1469 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.8,
    y1: 327.02,
    x2: 571.8,
    y2: 313.66
  })), _line1470 || (_line1470 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.43,
    y1: 324.81,
    x2: 564.37,
    y2: 324.81
  })), _line1471 || (_line1471 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.43,
    y1: 314.7,
    x2: 564.37,
    y2: 314.7
  })), _line1472 || (_line1472 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.89,
    y1: 313.66,
    x2: 571.8,
    y2: 313.66
  })), _line1473 || (_line1473 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 564.37,
    y1: 324.81,
    x2: 564.37,
    y2: 314.7
  })), _line1474 || (_line1474 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.43,
    y1: 324.81,
    x2: 574.43,
    y2: 314.7
  })), _line1475 || (_line1475 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.59,
    y1: 328.35,
    x2: 548.59,
    y2: 338.04
  })), _line1476 || (_line1476 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 550.07,
    y1: 328.35,
    x2: 550.07,
    y2: 338.04
  })), _line1477 || (_line1477 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.67,
    y1: 361.37,
    x2: 548.67,
    y2: 357.21
  })), _line1478 || (_line1478 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 556.31,
    y1: 357.21,
    x2: 556.31,
    y2: 361.37
  })), _line1479 || (_line1479 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.76,
    y1: 327.02,
    x2: 586.94,
    y2: 327.02
  })), _line1480 || (_line1480 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 589.41,
    y1: 361.37,
    x2: 581.98,
    y2: 361.37
  })), _line1481 || (_line1481 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 578.8,
    y1: 346.98,
    x2: 581.98,
    y2: 349.89
  })), _line1482 || (_line1482 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.98,
    y1: 357.21,
    x2: 581.98,
    y2: 349.89
  })), _line1483 || (_line1483 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.76,
    y1: 357.21,
    x2: 581.98,
    y2: 357.21
  })), _line1484 || (_line1484 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 578.8,
    y1: 338.04,
    x2: 606.76,
    y2: 338.04
  })), _line1485 || (_line1485 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 578.8,
    y1: 346.98,
    x2: 578.8,
    y2: 338.04
  })), _line1486 || (_line1486 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.76,
    y1: 338.04,
    x2: 606.76,
    y2: 357.21
  })), _line1487 || (_line1487 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 585.67,
    y1: 328.35,
    x2: 579.52,
    y2: 328.35
  })), _polyline313 || (_polyline313 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "579.31 328.05 579.52 328.26 579.52 328.35"
  })), _line1488 || (_line1488 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.31,
    y1: 323.15,
    x2: 578.16,
    y2: 323.15
  })), _polyline314 || (_polyline314 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "585.67 328.35 585.88 328.26 586.01 328.05"
  })), _line1489 || (_line1489 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.52,
    y1: 321.98,
    x2: 579.31,
    y2: 322.11
  })), _line1490 || (_line1490 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.52,
    y1: 321.98,
    x2: 585.67,
    y2: 321.98
  })), _line1491 || (_line1491 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.01,
    y1: 317.53,
    x2: 578.16,
    y2: 317.53
  })), _polyline315 || (_polyline315 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "586.01 322.11 585.88 321.98 585.67 321.98"
  })), _line1492 || (_line1492 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.01,
    y1: 317.53,
    x2: 586.01,
    y2: 328.05
  })), _line1493 || (_line1493 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.94,
    y1: 327.02,
    x2: 586.94,
    y2: 313.66
  })), _line1494 || (_line1494 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 578.16,
    y1: 323.15,
    x2: 578.16,
    y2: 317.53
  })), _line1495 || (_line1495 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.31,
    y1: 328.05,
    x2: 579.31,
    y2: 322.11
  })), _line1496 || (_line1496 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.76,
    y1: 327.02,
    x2: 604.76,
    y2: 313.66
  })), _line1497 || (_line1497 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.74,
    y1: 324.81,
    x2: 597.34,
    y2: 324.81
  })), _line1498 || (_line1498 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.74,
    y1: 314.7,
    x2: 597.34,
    y2: 314.7
  })), _line1499 || (_line1499 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.94,
    y1: 313.66,
    x2: 604.76,
    y2: 313.66
  })), _line1500 || (_line1500 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 597.34,
    y1: 324.81,
    x2: 597.34,
    y2: 314.7
  })), _line1501 || (_line1501 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.74,
    y1: 324.81,
    x2: 607.74,
    y2: 314.7
  })), _line1502 || (_line1502 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.64,
    y1: 328.35,
    x2: 581.64,
    y2: 338.04
  })), _line1503 || (_line1503 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 583.25,
    y1: 328.35,
    x2: 583.25,
    y2: 338.04
  })), _line1504 || (_line1504 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.98,
    y1: 361.37,
    x2: 581.98,
    y2: 357.21
  })), _line1505 || (_line1505 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 589.41,
    y1: 357.21,
    x2: 589.41,
    y2: 361.37
  })), _line1506 || (_line1506 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.24,
    y1: 327.02,
    x2: 620.25,
    y2: 327.02
  })), _line1507 || (_line1507 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 622.67,
    y1: 361.37,
    x2: 615.25,
    y2: 361.37
  })), _line1508 || (_line1508 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.06,
    y1: 346.98,
    x2: 615.25,
    y2: 349.89
  })), _line1509 || (_line1509 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.25,
    y1: 357.21,
    x2: 615.25,
    y2: 349.89
  })), _line1510 || (_line1510 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 640.28,
    y1: 357.21,
    x2: 615.25,
    y2: 357.21
  })), _line1511 || (_line1511 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.06,
    y1: 338.04,
    x2: 640.28,
    y2: 338.04
  })), _line1512 || (_line1512 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.06,
    y1: 346.98,
    x2: 612.06,
    y2: 338.04
  })), _line1513 || (_line1513 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 640.28,
    y1: 338.04,
    x2: 640.28,
    y2: 357.21
  })), _line1514 || (_line1514 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.19,
    y1: 328.35,
    x2: 613.04,
    y2: 328.35
  })), _line1515 || (_line1515 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.83,
    y1: 328.26,
    x2: 613.04,
    y2: 328.35
  })), _line1516 || (_line1516 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.83,
    y1: 323.15,
    x2: 611.43,
    y2: 323.15
  })), _polyline316 || (_polyline316 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "619.19 328.35 619.19 328.26 619.4 328.26"
  })), _polyline317 || (_polyline317 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "613.04 321.98 612.83 321.98 612.83 322.11"
  })), _line1517 || (_line1517 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.04,
    y1: 321.98,
    x2: 619.19,
    y2: 321.98
  })), _line1518 || (_line1518 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.4,
    y1: 317.62,
    x2: 611.43,
    y2: 317.62
  })), _line1519 || (_line1519 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.4,
    y1: 322.11,
    x2: 619.19,
    y2: 321.98
  })), _line1520 || (_line1520 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.4,
    y1: 317.62,
    x2: 619.4,
    y2: 328.26
  })), _line1521 || (_line1521 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.25,
    y1: 327.02,
    x2: 620.25,
    y2: 313.66
  })), _line1522 || (_line1522 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 611.43,
    y1: 323.15,
    x2: 611.43,
    y2: 317.62
  })), _line1523 || (_line1523 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.83,
    y1: 328.26,
    x2: 612.83,
    y2: 322.11
  })), _line1524 || (_line1524 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.24,
    y1: 327.02,
    x2: 638.24,
    y2: 313.66
  })), _line1525 || (_line1525 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641,
    y1: 324.81,
    x2: 630.73,
    y2: 324.81
  })), _line1526 || (_line1526 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641,
    y1: 314.7,
    x2: 630.73,
    y2: 314.7
  })), _line1527 || (_line1527 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.25,
    y1: 313.66,
    x2: 638.24,
    y2: 313.66
  })), _line1528 || (_line1528 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 630.73,
    y1: 324.81,
    x2: 630.73,
    y2: 314.7
  })), _line1529 || (_line1529 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641,
    y1: 324.81,
    x2: 641,
    y2: 314.7
  })), _line1530 || (_line1530 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.95,
    y1: 328.35,
    x2: 614.95,
    y2: 338.04
  })), _line1531 || (_line1531 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 616.65,
    y1: 328.35,
    x2: 616.65,
    y2: 338.04
  })), _line1532 || (_line1532 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.25,
    y1: 361.37,
    x2: 615.25,
    y2: 357.21
  })), _line1533 || (_line1533 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 622.67,
    y1: 357.21,
    x2: 622.67,
    y2: 361.37
  })), _line1534 || (_line1534 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 327.02,
    x2: 653.39,
    y2: 327.02
  })), _line1535 || (_line1535 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 655.85,
    y1: 361.37,
    x2: 648.43,
    y2: 361.37
  })), _line1536 || (_line1536 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.24,
    y1: 346.98,
    x2: 648.43,
    y2: 349.89
  })), _line1537 || (_line1537 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.43,
    y1: 357.21,
    x2: 648.43,
    y2: 349.89
  })), _line1538 || (_line1538 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.33,
    y1: 357.21,
    x2: 648.43,
    y2: 357.21
  })), _line1539 || (_line1539 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.24,
    y1: 338.04,
    x2: 673.33,
    y2: 338.04
  })), _line1540 || (_line1540 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.24,
    y1: 346.98,
    x2: 645.24,
    y2: 338.04
  })), _line1541 || (_line1541 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.33,
    y1: 338.04,
    x2: 673.33,
    y2: 357.21
  })), _line1542 || (_line1542 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.24,
    y1: 328.35,
    x2: 646.01,
    y2: 328.35
  })), _line1543 || (_line1543 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.88,
    y1: 328.26,
    x2: 646.01,
    y2: 328.35
  })), _line1544 || (_line1544 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.88,
    y1: 323.15,
    x2: 644.73,
    y2: 323.15
  })), _line1545 || (_line1545 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.24,
    y1: 328.35,
    x2: 652.33,
    y2: 328.26
  })), _polyline318 || (_polyline318 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "646.01 321.98 645.88 321.98 645.88 322.11"
  })), _line1546 || (_line1546 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.01,
    y1: 321.98,
    x2: 652.24,
    y2: 321.98
  })), _line1547 || (_line1547 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.33,
    y1: 317.62,
    x2: 644.73,
    y2: 317.62
  })), _polyline319 || (_polyline319 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "652.33 322.11 652.33 321.98 652.24 321.98"
  })), _line1548 || (_line1548 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.33,
    y1: 317.62,
    x2: 652.33,
    y2: 328.26
  })), _line1549 || (_line1549 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.39,
    y1: 327.02,
    x2: 653.39,
    y2: 313.66
  })), _line1550 || (_line1550 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 644.73,
    y1: 323.15,
    x2: 644.73,
    y2: 317.62
  })), _line1551 || (_line1551 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.88,
    y1: 328.26,
    x2: 645.88,
    y2: 322.11
  })), _line1552 || (_line1552 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 327.02,
    x2: 671.34,
    y2: 313.66
  })), _line1553 || (_line1553 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 324.81,
    x2: 663.91,
    y2: 324.81
  })), _line1554 || (_line1554 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 314.7,
    x2: 663.91,
    y2: 314.7
  })), _line1555 || (_line1555 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.39,
    y1: 313.66,
    x2: 671.34,
    y2: 313.66
  })), _line1556 || (_line1556 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 663.91,
    y1: 324.81,
    x2: 663.91,
    y2: 314.7
  })), _line1557 || (_line1557 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.18,
    y1: 324.81,
    x2: 674.18,
    y2: 314.7
  })), _line1558 || (_line1558 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.13,
    y1: 328.35,
    x2: 648.13,
    y2: 338.04
  })), _line1559 || (_line1559 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 649.7,
    y1: 328.35,
    x2: 649.7,
    y2: 338.04
  })), _line1560 || (_line1560 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.43,
    y1: 361.37,
    x2: 648.43,
    y2: 357.21
  })), _line1561 || (_line1561 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 655.85,
    y1: 357.21,
    x2: 655.85,
    y2: 361.37
  })), _line1562 || (_line1562 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.69,
    y1: 327.02,
    x2: 686.78,
    y2: 327.02
  })), _line1563 || (_line1563 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.24,
    y1: 361.37,
    x2: 681.82,
    y2: 361.37
  })), _line1564 || (_line1564 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.64,
    y1: 346.98,
    x2: 681.82,
    y2: 349.89
  })), _line1565 || (_line1565 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.82,
    y1: 357.21,
    x2: 681.82,
    y2: 349.89
  })), _line1566 || (_line1566 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 706.6,
    y1: 357.21,
    x2: 681.82,
    y2: 357.21
  })), _line1567 || (_line1567 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.64,
    y1: 338.04,
    x2: 706.6,
    y2: 338.04
  })), _line1568 || (_line1568 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.64,
    y1: 346.98,
    x2: 678.64,
    y2: 338.04
  })), _line1569 || (_line1569 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 706.6,
    y1: 338.04,
    x2: 706.6,
    y2: 357.21
  })), _line1570 || (_line1570 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.72,
    y1: 328.35,
    x2: 679.36,
    y2: 328.35
  })), _polyline320 || (_polyline320 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "679.27 328.26 679.36 328.26 679.36 328.35"
  })), _line1571 || (_line1571 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.27,
    y1: 323.15,
    x2: 678,
    y2: 323.15
  })), _polyline321 || (_polyline321 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "685.72 328.35 685.72 328.26 685.85 328.26"
  })), _line1572 || (_line1572 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.36,
    y1: 321.98,
    x2: 679.27,
    y2: 322.11
  })), _line1573 || (_line1573 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.36,
    y1: 321.98,
    x2: 685.72,
    y2: 321.98
  })), _line1574 || (_line1574 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.85,
    y1: 317.62,
    x2: 678,
    y2: 317.62
  })), _line1575 || (_line1575 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.85,
    y1: 322.11,
    x2: 685.72,
    y2: 321.98
  })), _line1576 || (_line1576 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.85,
    y1: 317.62,
    x2: 685.85,
    y2: 328.26
  })), _line1577 || (_line1577 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 686.78,
    y1: 327.02,
    x2: 686.78,
    y2: 313.66
  })), _line1578 || (_line1578 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678,
    y1: 323.15,
    x2: 678,
    y2: 317.62
  })), _line1579 || (_line1579 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.27,
    y1: 328.26,
    x2: 679.27,
    y2: 322.11
  })), _line1580 || (_line1580 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.69,
    y1: 327.02,
    x2: 704.69,
    y2: 313.66
  })), _line1581 || (_line1581 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 707.57,
    y1: 324.81,
    x2: 697.3,
    y2: 324.81
  })), _line1582 || (_line1582 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 707.57,
    y1: 314.7,
    x2: 697.3,
    y2: 314.7
  })), _line1583 || (_line1583 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 686.78,
    y1: 313.66,
    x2: 704.69,
    y2: 313.66
  })), _line1584 || (_line1584 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 697.3,
    y1: 324.81,
    x2: 697.3,
    y2: 314.7
  })), _line1585 || (_line1585 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 707.57,
    y1: 324.81,
    x2: 707.57,
    y2: 314.7
  })), _line1586 || (_line1586 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.48,
    y1: 328.35,
    x2: 681.48,
    y2: 338.04
  })), _line1587 || (_line1587 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.18,
    y1: 328.35,
    x2: 683.18,
    y2: 338.04
  })), _line1588 || (_line1588 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.82,
    y1: 361.37,
    x2: 681.82,
    y2: 357.21
  })), _line1589 || (_line1589 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.24,
    y1: 357.21,
    x2: 689.24,
    y2: 361.37
  })), _line1590 || (_line1590 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.87,
    y1: 327.02,
    x2: 719.96,
    y2: 327.02
  })), _line1591 || (_line1591 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 722.42,
    y1: 361.37,
    x2: 715,
    y2: 361.37
  })), _line1592 || (_line1592 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 711.82,
    y1: 346.98,
    x2: 714.87,
    y2: 349.89
  })), _line1593 || (_line1593 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.87,
    y1: 357.21,
    x2: 714.87,
    y2: 349.89
  })), _line1594 || (_line1594 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 739.9,
    y1: 357.21,
    x2: 714.87,
    y2: 357.21
  })), _line1595 || (_line1595 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 711.82,
    y1: 338.04,
    x2: 739.9,
    y2: 338.04
  })), _line1596 || (_line1596 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 711.82,
    y1: 346.98,
    x2: 711.82,
    y2: 338.04
  })), _line1597 || (_line1597 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 739.9,
    y1: 338.04,
    x2: 739.9,
    y2: 357.21
  })), _line1598 || (_line1598 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.82,
    y1: 328.35,
    x2: 712.54,
    y2: 328.35
  })), _line1599 || (_line1599 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.45,
    y1: 328.26,
    x2: 712.54,
    y2: 328.35
  })), _line1600 || (_line1600 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.45,
    y1: 323.15,
    x2: 711.18,
    y2: 323.15
  })), _line1601 || (_line1601 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.82,
    y1: 328.35,
    x2: 718.9,
    y2: 328.26
  })), _polyline322 || (_polyline322 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "712.54 321.98 712.45 321.98 712.45 322.11"
  })), _line1602 || (_line1602 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.54,
    y1: 321.98,
    x2: 718.82,
    y2: 321.98
  })), _line1603 || (_line1603 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.9,
    y1: 317.62,
    x2: 711.18,
    y2: 317.62
  })), _polyline323 || (_polyline323 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "718.9 322.11 718.9 321.98 718.82 321.98"
  })), _line1604 || (_line1604 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.9,
    y1: 317.62,
    x2: 718.9,
    y2: 328.26
  })), _line1605 || (_line1605 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 719.96,
    y1: 327.02,
    x2: 719.96,
    y2: 313.66
  })), _line1606 || (_line1606 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 711.18,
    y1: 323.15,
    x2: 711.18,
    y2: 317.62
  })), _line1607 || (_line1607 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.45,
    y1: 328.26,
    x2: 712.45,
    y2: 322.11
  })), _line1608 || (_line1608 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.87,
    y1: 327.02,
    x2: 737.87,
    y2: 313.66
  })), _line1609 || (_line1609 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 324.81,
    x2: 730.44,
    y2: 324.81
  })), _line1610 || (_line1610 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 314.7,
    x2: 730.44,
    y2: 314.7
  })), _line1611 || (_line1611 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 719.96,
    y1: 313.66,
    x2: 737.87,
    y2: 313.66
  })), _line1612 || (_line1612 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 730.44,
    y1: 324.81,
    x2: 730.44,
    y2: 314.7
  })), _line1613 || (_line1613 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 740.75,
    y1: 324.81,
    x2: 740.75,
    y2: 314.7
  })), _line1614 || (_line1614 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.66,
    y1: 328.35,
    x2: 714.66,
    y2: 338.04
  })), _line1615 || (_line1615 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.14,
    y1: 328.35,
    x2: 716.14,
    y2: 338.04
  })), _line1616 || (_line1616 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715,
    y1: 361.37,
    x2: 715,
    y2: 357.21
  })), _line1617 || (_line1617 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 722.42,
    y1: 357.21,
    x2: 722.42,
    y2: 361.37
  })), _line1618 || (_line1618 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.26,
    y1: 327.02,
    x2: 753.35,
    y2: 327.02
  })), _line1619 || (_line1619 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 755.81,
    y1: 361.37,
    x2: 748.39,
    y2: 361.37
  })), _line1620 || (_line1620 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.21,
    y1: 346.98,
    x2: 748.39,
    y2: 349.89
  })), _line1621 || (_line1621 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.39,
    y1: 357.21,
    x2: 748.39,
    y2: 349.89
  })), _line1622 || (_line1622 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.17,
    y1: 357.21,
    x2: 748.39,
    y2: 357.21
  })), _line1623 || (_line1623 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.21,
    y1: 338.04,
    x2: 773.17,
    y2: 338.04
  })), _line1624 || (_line1624 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.21,
    y1: 346.98,
    x2: 745.21,
    y2: 338.04
  })), _line1625 || (_line1625 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.17,
    y1: 338.04,
    x2: 773.17,
    y2: 357.21
  })), _line1626 || (_line1626 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.08,
    y1: 328.35,
    x2: 745.93,
    y2: 328.35
  })), _line1627 || (_line1627 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.72,
    y1: 328.26,
    x2: 745.93,
    y2: 328.35
  })), _line1628 || (_line1628 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.72,
    y1: 323.15,
    x2: 744.57,
    y2: 323.15
  })), _line1629 || (_line1629 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.08,
    y1: 328.35,
    x2: 752.29,
    y2: 328.26
  })), _polyline324 || (_polyline324 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "745.93 321.98 745.72 321.98 745.72 322.11"
  })), _line1630 || (_line1630 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.93,
    y1: 321.98,
    x2: 752.08,
    y2: 321.98
  })), _line1631 || (_line1631 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.29,
    y1: 317.62,
    x2: 744.57,
    y2: 317.62
  })), _polyline325 || (_polyline325 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "752.29 322.11 752.29 321.98 752.08 321.98"
  })), _line1632 || (_line1632 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.29,
    y1: 317.62,
    x2: 752.29,
    y2: 328.26
  })), _line1633 || (_line1633 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.35,
    y1: 327.02,
    x2: 753.35,
    y2: 313.66
  })), _line1634 || (_line1634 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 744.57,
    y1: 323.15,
    x2: 744.57,
    y2: 317.62
  })), _line1635 || (_line1635 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.72,
    y1: 328.26,
    x2: 745.72,
    y2: 322.11
  })), _line1636 || (_line1636 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.26,
    y1: 327.02,
    x2: 771.26,
    y2: 313.66
  })), _line1637 || (_line1637 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.14,
    y1: 324.81,
    x2: 763.75,
    y2: 324.81
  })), _line1638 || (_line1638 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.14,
    y1: 314.7,
    x2: 763.75,
    y2: 314.7
  })), _line1639 || (_line1639 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.35,
    y1: 313.66,
    x2: 771.26,
    y2: 313.66
  })), _line1640 || (_line1640 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 763.75,
    y1: 324.81,
    x2: 763.75,
    y2: 314.7
  })), _line1641 || (_line1641 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.14,
    y1: 324.81,
    x2: 774.14,
    y2: 314.7
  })), _line1642 || (_line1642 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.05,
    y1: 328.35,
    x2: 748.05,
    y2: 338.04
  })), _line1643 || (_line1643 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.54,
    y1: 328.35,
    x2: 749.54,
    y2: 338.04
  })), _line1644 || (_line1644 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.39,
    y1: 361.37,
    x2: 748.39,
    y2: 357.21
  })), _line1645 || (_line1645 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 755.81,
    y1: 357.21,
    x2: 755.81,
    y2: 361.37
  })), _line1646 || (_line1646 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.44,
    y1: 327.02,
    x2: 786.53,
    y2: 327.02
  })), _line1647 || (_line1647 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 788.95,
    y1: 361.37,
    x2: 781.36,
    y2: 361.37
  })), _line1648 || (_line1648 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.39,
    y1: 346.98,
    x2: 781.36,
    y2: 349.89
  })), _line1649 || (_line1649 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.36,
    y1: 357.21,
    x2: 781.36,
    y2: 349.89
  })), _line1650 || (_line1650 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.35,
    y1: 357.21,
    x2: 781.36,
    y2: 357.21
  })), _line1651 || (_line1651 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.39,
    y1: 338.04,
    x2: 806.35,
    y2: 338.04
  })), _line1652 || (_line1652 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.39,
    y1: 346.98,
    x2: 778.39,
    y2: 338.04
  })), _line1653 || (_line1653 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.35,
    y1: 338.04,
    x2: 806.35,
    y2: 357.21
  })), _line1654 || (_line1654 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.35,
    y1: 328.35,
    x2: 779.11,
    y2: 328.35
  })), _line1655 || (_line1655 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.9,
    y1: 328.26,
    x2: 779.11,
    y2: 328.35
  })), _line1656 || (_line1656 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.9,
    y1: 323.15,
    x2: 777.75,
    y2: 323.15
  })), _line1657 || (_line1657 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.35,
    y1: 328.35,
    x2: 785.47,
    y2: 328.26
  })), _polyline326 || (_polyline326 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "779.11 321.98 778.9 321.98 778.9 322.11"
  })), _line1658 || (_line1658 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.11,
    y1: 321.98,
    x2: 785.35,
    y2: 321.98
  })), _line1659 || (_line1659 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.47,
    y1: 317.62,
    x2: 777.75,
    y2: 317.62
  })), _polyline327 || (_polyline327 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "785.47 322.11 785.47 321.98 785.35 321.98"
  })), _line1660 || (_line1660 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.47,
    y1: 317.62,
    x2: 785.47,
    y2: 328.26
  })), _line1661 || (_line1661 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.53,
    y1: 327.02,
    x2: 786.53,
    y2: 313.66
  })), _line1662 || (_line1662 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 777.75,
    y1: 323.15,
    x2: 777.75,
    y2: 317.62
  })), _line1663 || (_line1663 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.9,
    y1: 328.26,
    x2: 778.9,
    y2: 322.11
  })), _line1664 || (_line1664 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.44,
    y1: 327.02,
    x2: 804.44,
    y2: 313.66
  })), _line1665 || (_line1665 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.11,
    y1: 324.81,
    x2: 797.01,
    y2: 324.81
  })), _line1666 || (_line1666 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.11,
    y1: 314.7,
    x2: 797.01,
    y2: 314.7
  })), _line1667 || (_line1667 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.53,
    y1: 313.66,
    x2: 804.44,
    y2: 313.66
  })), _line1668 || (_line1668 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.01,
    y1: 324.81,
    x2: 797.01,
    y2: 314.7
  })), _line1669 || (_line1669 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.11,
    y1: 324.81,
    x2: 807.11,
    y2: 314.7
  })), _line1670 || (_line1670 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.23,
    y1: 328.35,
    x2: 781.23,
    y2: 338.04
  })), _line1671 || (_line1671 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.72,
    y1: 328.35,
    x2: 782.72,
    y2: 338.04
  })), _line1672 || (_line1672 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.36,
    y1: 361.37,
    x2: 781.36,
    y2: 357.21
  })), _line1673 || (_line1673 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 788.95,
    y1: 357.21,
    x2: 788.95,
    y2: 361.37
  })), _line1674 || (_line1674 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 549.52,
    y1: 241.92,
    x2: 567.55,
    y2: 241.92
  })), _line1675 || (_line1675 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 565.14,
    y1: 207.65,
    x2: 572.52,
    y2: 207.65
  })), _line1676 || (_line1676 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.7,
    y1: 222.04,
    x2: 572.52,
    y2: 219.13
  })), _line1677 || (_line1677 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.52,
    y1: 211.8,
    x2: 572.52,
    y2: 219.13
  })), _line1678 || (_line1678 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.53,
    y1: 211.8,
    x2: 572.52,
    y2: 211.8
  })), _line1679 || (_line1679 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.7,
    y1: 230.77,
    x2: 547.53,
    y2: 230.77
  })), _line1680 || (_line1680 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 575.7,
    y1: 222.04,
    x2: 575.7,
    y2: 230.77
  })), _line1681 || (_line1681 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.53,
    y1: 230.77,
    x2: 547.53,
    y2: 211.8
  })), _line1682 || (_line1682 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.61,
    y1: 240.67,
    x2: 574.77,
    y2: 240.67
  })), _line1683 || (_line1683 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.98,
    y1: 240.75,
    x2: 574.77,
    y2: 240.67
  })), _line1684 || (_line1684 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.98,
    y1: 245.87,
    x2: 576.34,
    y2: 245.87
  })), _polyline328 || (_polyline328 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "568.61 240.67 568.61 240.75 568.4 240.75"
  })), _polyline329 || (_polyline329 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "574.77 247.03 574.98 247.03 574.98 246.91"
  })), _line1685 || (_line1685 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.77,
    y1: 247.03,
    x2: 568.61,
    y2: 247.03
  })), _line1686 || (_line1686 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.4,
    y1: 251.28,
    x2: 576.34,
    y2: 251.28
  })), _line1687 || (_line1687 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.4,
    y1: 246.91,
    x2: 568.61,
    y2: 247.03
  })), _line1688 || (_line1688 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.4,
    y1: 251.28,
    x2: 568.4,
    y2: 240.75
  })), _line1689 || (_line1689 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.55,
    y1: 241.92,
    x2: 567.55,
    y2: 255.35
  })), _line1690 || (_line1690 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 576.34,
    y1: 245.87,
    x2: 576.34,
    y2: 251.28
  })), _line1691 || (_line1691 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 574.98,
    y1: 240.75,
    x2: 574.98,
    y2: 246.91
  })), _line1692 || (_line1692 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 549.52,
    y1: 241.92,
    x2: 549.52,
    y2: 255.35
  })), _line1693 || (_line1693 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.76,
    y1: 244.21,
    x2: 557.07,
    y2: 244.21
  })), _line1694 || (_line1694 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.76,
    y1: 254.31,
    x2: 557.07,
    y2: 254.31
  })), _line1695 || (_line1695 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 567.55,
    y1: 255.35,
    x2: 549.52,
    y2: 255.35
  })), _line1696 || (_line1696 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 557.07,
    y1: 244.21,
    x2: 557.07,
    y2: 254.31
  })), _line1697 || (_line1697 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.76,
    y1: 244.21,
    x2: 546.76,
    y2: 254.31
  })), _line1698 || (_line1698 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.86,
    y1: 240.67,
    x2: 572.86,
    y2: 230.77
  })), _line1699 || (_line1699 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.16,
    y1: 240.67,
    x2: 571.16,
    y2: 230.77
  })), _line1700 || (_line1700 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 572.52,
    y1: 207.65,
    x2: 572.52,
    y2: 211.8
  })), _line1701 || (_line1701 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 565.14,
    y1: 211.8,
    x2: 565.14,
    y2: 207.65
  })), _line1702 || (_line1702 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.7,
    y1: 241.92,
    x2: 600.52,
    y2: 241.92
  })), _line1703 || (_line1703 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 598.19,
    y1: 207.65,
    x2: 605.61,
    y2: 207.65
  })), _line1704 || (_line1704 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 222.04,
    x2: 605.7,
    y2: 219.13
  })), _line1705 || (_line1705 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 605.7,
    y1: 211.8,
    x2: 605.7,
    y2: 219.13
  })), _line1706 || (_line1706 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.71,
    y1: 211.8,
    x2: 605.7,
    y2: 211.8
  })), _line1707 || (_line1707 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 230.77,
    x2: 580.71,
    y2: 230.77
  })), _line1708 || (_line1708 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.8,
    y1: 222.04,
    x2: 608.8,
    y2: 230.77
  })), _line1709 || (_line1709 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.71,
    y1: 230.77,
    x2: 580.71,
    y2: 211.8
  })), _line1710 || (_line1710 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.79,
    y1: 240.67,
    x2: 607.95,
    y2: 240.67
  })), _line1711 || (_line1711 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.16,
    y1: 240.75,
    x2: 607.95,
    y2: 240.67
  })), _line1712 || (_line1712 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.16,
    y1: 245.87,
    x2: 609.3,
    y2: 245.87
  })), _line1713 || (_line1713 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.79,
    y1: 240.67,
    x2: 601.58,
    y2: 240.75
  })), _polyline330 || (_polyline330 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "607.95 247.03 608.16 247.03 608.16 246.91"
  })), _line1714 || (_line1714 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 607.95,
    y1: 247.03,
    x2: 601.79,
    y2: 247.03
  })), _line1715 || (_line1715 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.58,
    y1: 251.28,
    x2: 609.3,
    y2: 251.28
  })), _polyline331 || (_polyline331 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "601.58 246.91 601.58 247.03 601.79 247.03"
  })), _line1716 || (_line1716 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.58,
    y1: 251.28,
    x2: 601.58,
    y2: 240.75
  })), _line1717 || (_line1717 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 600.52,
    y1: 241.92,
    x2: 600.52,
    y2: 255.35
  })), _line1718 || (_line1718 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 609.3,
    y1: 245.87,
    x2: 609.3,
    y2: 251.28
  })), _line1719 || (_line1719 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 608.16,
    y1: 240.75,
    x2: 608.16,
    y2: 246.91
  })), _line1720 || (_line1720 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.7,
    y1: 241.92,
    x2: 582.7,
    y2: 255.35
  })), _line1721 || (_line1721 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.86,
    y1: 244.21,
    x2: 590.13,
    y2: 244.21
  })), _line1722 || (_line1722 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.86,
    y1: 254.31,
    x2: 590.13,
    y2: 254.31
  })), _line1723 || (_line1723 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 600.52,
    y1: 255.35,
    x2: 582.7,
    y2: 255.35
  })), _line1724 || (_line1724 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.13,
    y1: 244.21,
    x2: 590.13,
    y2: 254.31
  })), _line1725 || (_line1725 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.86,
    y1: 244.21,
    x2: 579.86,
    y2: 254.31
  })), _line1726 || (_line1726 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 605.83,
    y1: 240.67,
    x2: 605.83,
    y2: 230.77
  })), _line1727 || (_line1727 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.34,
    y1: 240.67,
    x2: 604.34,
    y2: 230.77
  })), _line1728 || (_line1728 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 605.61,
    y1: 207.65,
    x2: 605.61,
    y2: 211.8
  })), _line1729 || (_line1729 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 598.19,
    y1: 211.8,
    x2: 598.19,
    y2: 207.65
  })), _line1730 || (_line1730 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 616.01,
    y1: 241.92,
    x2: 633.91,
    y2: 241.92
  })), _line1731 || (_line1731 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.45,
    y1: 207.65,
    x2: 639.09,
    y2: 207.65
  })), _line1732 || (_line1732 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.06,
    y1: 222.04,
    x2: 639.09,
    y2: 219.13
  })), _line1733 || (_line1733 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 639.09,
    y1: 211.8,
    x2: 639.09,
    y2: 219.13
  })), _line1734 || (_line1734 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.1,
    y1: 211.8,
    x2: 639.09,
    y2: 211.8
  })), _line1735 || (_line1735 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.06,
    y1: 230.77,
    x2: 614.1,
    y2: 230.77
  })), _line1736 || (_line1736 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.06,
    y1: 222.04,
    x2: 642.06,
    y2: 230.77
  })), _line1737 || (_line1737 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.1,
    y1: 230.77,
    x2: 614.1,
    y2: 211.8
  })), _line1738 || (_line1738 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 635.06,
    y1: 240.67,
    x2: 641.34,
    y2: 240.67
  })), _line1739 || (_line1739 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641.55,
    y1: 240.75,
    x2: 641.34,
    y2: 240.67
  })), _line1740 || (_line1740 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641.55,
    y1: 245.87,
    x2: 642.7,
    y2: 245.87
  })), _line1741 || (_line1741 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 635.06,
    y1: 240.67,
    x2: 634.98,
    y2: 240.75
  })), _polyline332 || (_polyline332 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "641.34 247.03 641.55 247.03 641.55 246.91"
  })), _line1742 || (_line1742 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641.34,
    y1: 247.03,
    x2: 635.06,
    y2: 247.03
  })), _line1743 || (_line1743 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.98,
    y1: 251.28,
    x2: 642.7,
    y2: 251.28
  })), _polyline333 || (_polyline333 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "634.98 246.91 634.98 247.03 635.06 247.03"
  })), _line1744 || (_line1744 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.98,
    y1: 251.28,
    x2: 634.98,
    y2: 240.75
  })), _line1745 || (_line1745 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 633.91,
    y1: 241.92,
    x2: 633.91,
    y2: 255.35
  })), _line1746 || (_line1746 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.7,
    y1: 245.87,
    x2: 642.7,
    y2: 251.28
  })), _line1747 || (_line1747 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 641.55,
    y1: 240.75,
    x2: 641.55,
    y2: 246.91
  })), _line1748 || (_line1748 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 616.01,
    y1: 241.92,
    x2: 616.01,
    y2: 255.35
  })), _line1749 || (_line1749 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.34,
    y1: 244.21,
    x2: 623.39,
    y2: 244.21
  })), _line1750 || (_line1750 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.34,
    y1: 254.31,
    x2: 623.39,
    y2: 254.31
  })), _line1751 || (_line1751 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 633.91,
    y1: 255.35,
    x2: 616.01,
    y2: 255.35
  })), _line1752 || (_line1752 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 623.39,
    y1: 244.21,
    x2: 623.39,
    y2: 254.31
  })), _line1753 || (_line1753 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.34,
    y1: 244.21,
    x2: 613.34,
    y2: 254.31
  })), _line1754 || (_line1754 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 639.22,
    y1: 240.67,
    x2: 639.22,
    y2: 230.77
  })), _line1755 || (_line1755 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 637.73,
    y1: 240.67,
    x2: 637.73,
    y2: 230.77
  })), _line1756 || (_line1756 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 639.09,
    y1: 207.65,
    x2: 639.09,
    y2: 211.8
  })), _line1757 || (_line1757 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 631.45,
    y1: 211.8,
    x2: 631.45,
    y2: 207.65
  })), _line1758 || (_line1758 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 649.19,
    y1: 241.92,
    x2: 667.09,
    y2: 241.92
  })), _line1759 || (_line1759 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.63,
    y1: 207.65,
    x2: 672.06,
    y2: 207.65
  })), _line1760 || (_line1760 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 222.04,
    x2: 672.06,
    y2: 219.13
  })), _line1761 || (_line1761 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 672.06,
    y1: 211.8,
    x2: 672.06,
    y2: 219.13
  })), _line1762 || (_line1762 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.28,
    y1: 211.8,
    x2: 672.06,
    y2: 211.8
  })), _line1763 || (_line1763 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 230.77,
    x2: 647.28,
    y2: 230.77
  })), _line1764 || (_line1764 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.24,
    y1: 222.04,
    x2: 675.24,
    y2: 230.77
  })), _line1765 || (_line1765 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.28,
    y1: 230.77,
    x2: 647.28,
    y2: 211.8
  })), _line1766 || (_line1766 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.37,
    y1: 240.67,
    x2: 674.52,
    y2: 240.67
  })), _line1767 || (_line1767 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.73,
    y1: 240.75,
    x2: 674.52,
    y2: 240.67
  })), _line1768 || (_line1768 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.73,
    y1: 245.87,
    x2: 675.88,
    y2: 245.87
  })), _line1769 || (_line1769 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.37,
    y1: 240.67,
    x2: 668.15,
    y2: 240.75
  })), _polyline334 || (_polyline334 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "674.52 247.03 674.73 247.03 674.73 246.91"
  })), _line1770 || (_line1770 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.52,
    y1: 247.03,
    x2: 668.37,
    y2: 247.03
  })), _line1771 || (_line1771 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.15,
    y1: 251.28,
    x2: 675.88,
    y2: 251.28
  })), _polyline335 || (_polyline335 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "668.15 246.91 668.15 247.03 668.37 247.03"
  })), _line1772 || (_line1772 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 668.15,
    y1: 251.28,
    x2: 668.15,
    y2: 240.75
  })), _line1773 || (_line1773 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.09,
    y1: 241.92,
    x2: 667.09,
    y2: 255.35
  })), _line1774 || (_line1774 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 675.88,
    y1: 245.87,
    x2: 675.88,
    y2: 251.28
  })), _line1775 || (_line1775 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 674.73,
    y1: 240.75,
    x2: 674.73,
    y2: 246.91
  })), _line1776 || (_line1776 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 649.19,
    y1: 241.92,
    x2: 649.19,
    y2: 255.35
  })), _line1777 || (_line1777 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.3,
    y1: 244.21,
    x2: 656.57,
    y2: 244.21
  })), _line1778 || (_line1778 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.3,
    y1: 254.31,
    x2: 656.57,
    y2: 254.31
  })), _line1779 || (_line1779 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.09,
    y1: 255.35,
    x2: 649.19,
    y2: 255.35
  })), _line1780 || (_line1780 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 656.57,
    y1: 244.21,
    x2: 656.57,
    y2: 254.31
  })), _line1781 || (_line1781 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.3,
    y1: 244.21,
    x2: 646.3,
    y2: 254.31
  })), _line1782 || (_line1782 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 672.4,
    y1: 240.67,
    x2: 672.4,
    y2: 230.77
  })), _line1783 || (_line1783 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 670.91,
    y1: 240.67,
    x2: 670.91,
    y2: 230.77
  })), _line1784 || (_line1784 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 672.06,
    y1: 207.65,
    x2: 672.06,
    y2: 211.8
  })), _line1785 || (_line1785 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.63,
    y1: 211.8,
    x2: 664.63,
    y2: 207.65
  })), _line1786 || (_line1786 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 682.54,
    y1: 241.92,
    x2: 700.49,
    y2: 241.92
  })), _line1787 || (_line1787 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.03,
    y1: 207.65,
    x2: 705.45,
    y2: 207.65
  })), _line1788 || (_line1788 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708.63,
    y1: 222.04,
    x2: 705.54,
    y2: 219.13
  })), _line1789 || (_line1789 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.54,
    y1: 211.8,
    x2: 705.54,
    y2: 219.13
  })), _line1790 || (_line1790 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 680.54,
    y1: 211.8,
    x2: 705.54,
    y2: 211.8
  })), _line1791 || (_line1791 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708.63,
    y1: 230.77,
    x2: 680.54,
    y2: 230.77
  })), _line1792 || (_line1792 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708.63,
    y1: 222.04,
    x2: 708.63,
    y2: 230.77
  })), _line1793 || (_line1793 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 680.54,
    y1: 230.77,
    x2: 680.54,
    y2: 211.8
  })), _line1794 || (_line1794 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.63,
    y1: 240.67,
    x2: 707.87,
    y2: 240.67
  })), _line1795 || (_line1795 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708,
    y1: 240.75,
    x2: 707.87,
    y2: 240.67
  })), _line1796 || (_line1796 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708,
    y1: 245.87,
    x2: 709.27,
    y2: 245.87
  })), _line1797 || (_line1797 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.63,
    y1: 240.67,
    x2: 701.55,
    y2: 240.75
  })), _polyline336 || (_polyline336 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "707.87 247.03 708 247.03 708 246.91"
  })), _line1798 || (_line1798 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 707.87,
    y1: 247.03,
    x2: 701.63,
    y2: 247.03
  })), _line1799 || (_line1799 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.55,
    y1: 251.28,
    x2: 709.27,
    y2: 251.28
  })), _polyline337 || (_polyline337 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "701.55 246.91 701.55 247.03 701.63 247.03"
  })), _line1800 || (_line1800 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.55,
    y1: 251.28,
    x2: 701.55,
    y2: 240.75
  })), _line1801 || (_line1801 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 700.49,
    y1: 241.92,
    x2: 700.49,
    y2: 255.35
  })), _line1802 || (_line1802 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 709.27,
    y1: 245.87,
    x2: 709.27,
    y2: 251.28
  })), _line1803 || (_line1803 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 708,
    y1: 240.75,
    x2: 708,
    y2: 246.91
  })), _line1804 || (_line1804 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 682.54,
    y1: 241.92,
    x2: 682.54,
    y2: 255.35
  })), _line1805 || (_line1805 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.7,
    y1: 244.21,
    x2: 689.96,
    y2: 244.21
  })), _line1806 || (_line1806 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.7,
    y1: 254.31,
    x2: 689.96,
    y2: 254.31
  })), _line1807 || (_line1807 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 700.49,
    y1: 255.35,
    x2: 682.54,
    y2: 255.35
  })), _line1808 || (_line1808 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 689.96,
    y1: 244.21,
    x2: 689.96,
    y2: 254.31
  })), _line1809 || (_line1809 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.7,
    y1: 244.21,
    x2: 679.7,
    y2: 254.31
  })), _line1810 || (_line1810 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.75,
    y1: 240.67,
    x2: 705.75,
    y2: 230.77
  })), _line1811 || (_line1811 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.26,
    y1: 240.67,
    x2: 704.26,
    y2: 230.77
  })), _line1812 || (_line1812 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.45,
    y1: 207.65,
    x2: 705.45,
    y2: 211.8
  })), _line1813 || (_line1813 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.03,
    y1: 211.8,
    x2: 698.03,
    y2: 207.65
  })), _line1814 || (_line1814 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715.72,
    y1: 241.92,
    x2: 733.62,
    y2: 241.92
  })), _line1815 || (_line1815 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.21,
    y1: 207.65,
    x2: 738.63,
    y2: 207.65
  })), _line1816 || (_line1816 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 222.04,
    x2: 738.63,
    y2: 219.13
  })), _line1817 || (_line1817 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.63,
    y1: 211.8,
    x2: 738.63,
    y2: 219.13
  })), _line1818 || (_line1818 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 713.81,
    y1: 211.8,
    x2: 738.63,
    y2: 211.8
  })), _line1819 || (_line1819 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 230.77,
    x2: 713.81,
    y2: 230.77
  })), _line1820 || (_line1820 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.81,
    y1: 222.04,
    x2: 741.81,
    y2: 230.77
  })), _line1821 || (_line1821 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 713.81,
    y1: 230.77,
    x2: 713.81,
    y2: 211.8
  })), _line1822 || (_line1822 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.68,
    y1: 240.67,
    x2: 741.05,
    y2: 240.67
  })), _polyline338 || (_polyline338 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "741.18 240.75 741.05 240.75 741.05 240.67"
  })), _line1823 || (_line1823 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.18,
    y1: 245.87,
    x2: 742.45,
    y2: 245.87
  })), _polyline339 || (_polyline339 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "734.68 240.67 734.68 240.75 734.47 240.75"
  })), _line1824 || (_line1824 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.05,
    y1: 247.03,
    x2: 741.18,
    y2: 246.91
  })), _line1825 || (_line1825 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.05,
    y1: 247.03,
    x2: 734.68,
    y2: 247.03
  })), _line1826 || (_line1826 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.47,
    y1: 251.28,
    x2: 742.45,
    y2: 251.28
  })), _line1827 || (_line1827 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.47,
    y1: 246.91,
    x2: 734.68,
    y2: 247.03
  })), _line1828 || (_line1828 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.47,
    y1: 251.28,
    x2: 734.47,
    y2: 240.75
  })), _line1829 || (_line1829 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 733.62,
    y1: 241.92,
    x2: 733.62,
    y2: 255.35
  })), _line1830 || (_line1830 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 742.45,
    y1: 245.87,
    x2: 742.45,
    y2: 251.28
  })), _line1831 || (_line1831 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 741.18,
    y1: 240.75,
    x2: 741.18,
    y2: 246.91
  })), _line1832 || (_line1832 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715.72,
    y1: 241.92,
    x2: 715.72,
    y2: 255.35
  })), _line1833 || (_line1833 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.88,
    y1: 244.21,
    x2: 723.14,
    y2: 244.21
  })), _line1834 || (_line1834 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.88,
    y1: 254.31,
    x2: 723.14,
    y2: 254.31
  })), _line1835 || (_line1835 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 733.62,
    y1: 255.35,
    x2: 715.72,
    y2: 255.35
  })), _line1836 || (_line1836 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.14,
    y1: 244.21,
    x2: 723.14,
    y2: 254.31
  })), _line1837 || (_line1837 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.88,
    y1: 244.21,
    x2: 712.88,
    y2: 254.31
  })), _line1838 || (_line1838 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.93,
    y1: 240.67,
    x2: 738.93,
    y2: 230.77
  })), _line1839 || (_line1839 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.23,
    y1: 240.67,
    x2: 737.23,
    y2: 230.77
  })), _line1840 || (_line1840 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.63,
    y1: 207.65,
    x2: 738.63,
    y2: 211.8
  })), _line1841 || (_line1841 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.21,
    y1: 211.8,
    x2: 731.21,
    y2: 207.65
  })), _line1842 || (_line1842 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.11,
    y1: 241.92,
    x2: 766.93,
    y2: 241.92
  })), _line1843 || (_line1843 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 764.6,
    y1: 207.65,
    x2: 772.02,
    y2: 207.65
  })), _line1844 || (_line1844 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.21,
    y1: 222.04,
    x2: 772.02,
    y2: 219.13
  })), _line1845 || (_line1845 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 772.02,
    y1: 211.8,
    x2: 772.02,
    y2: 219.13
  })), _line1846 || (_line1846 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 747.12,
    y1: 211.8,
    x2: 772.02,
    y2: 211.8
  })), _line1847 || (_line1847 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.21,
    y1: 230.77,
    x2: 747.12,
    y2: 230.77
  })), _line1848 || (_line1848 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.21,
    y1: 222.04,
    x2: 775.21,
    y2: 230.77
  })), _line1849 || (_line1849 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 747.12,
    y1: 230.77,
    x2: 747.12,
    y2: 211.8
  })), _line1850 || (_line1850 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.2,
    y1: 240.67,
    x2: 774.44,
    y2: 240.67
  })), _line1851 || (_line1851 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.57,
    y1: 240.75,
    x2: 774.44,
    y2: 240.67
  })), _line1852 || (_line1852 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.57,
    y1: 245.87,
    x2: 775.71,
    y2: 245.87
  })), _line1853 || (_line1853 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.2,
    y1: 240.67,
    x2: 768.08,
    y2: 240.75
  })), _polyline340 || (_polyline340 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "774.44 247.03 774.57 247.03 774.57 246.91"
  })), _line1854 || (_line1854 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.44,
    y1: 247.03,
    x2: 768.2,
    y2: 247.03
  })), _line1855 || (_line1855 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.08,
    y1: 251.28,
    x2: 775.71,
    y2: 251.28
  })), _polyline341 || (_polyline341 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "768.08 246.91 768.08 247.03 768.2 247.03"
  })), _line1856 || (_line1856 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.08,
    y1: 251.28,
    x2: 768.08,
    y2: 240.75
  })), _line1857 || (_line1857 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 766.93,
    y1: 241.92,
    x2: 766.93,
    y2: 255.35
  })), _line1858 || (_line1858 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.71,
    y1: 245.87,
    x2: 775.71,
    y2: 251.28
  })), _line1859 || (_line1859 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 774.57,
    y1: 240.75,
    x2: 774.57,
    y2: 246.91
  })), _line1860 || (_line1860 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.11,
    y1: 241.92,
    x2: 749.11,
    y2: 255.35
  })), _line1861 || (_line1861 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.27,
    y1: 244.21,
    x2: 756.54,
    y2: 244.21
  })), _line1862 || (_line1862 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.27,
    y1: 254.31,
    x2: 756.54,
    y2: 254.31
  })), _line1863 || (_line1863 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 766.93,
    y1: 255.35,
    x2: 749.11,
    y2: 255.35
  })), _line1864 || (_line1864 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 756.54,
    y1: 244.21,
    x2: 756.54,
    y2: 254.31
  })), _line1865 || (_line1865 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.27,
    y1: 244.21,
    x2: 746.27,
    y2: 254.31
  })), _line1866 || (_line1866 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 772.32,
    y1: 240.67,
    x2: 772.32,
    y2: 230.77
  })), _line1867 || (_line1867 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 770.75,
    y1: 240.67,
    x2: 770.75,
    y2: 230.77
  })), _line1868 || (_line1868 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 772.02,
    y1: 207.65,
    x2: 772.02,
    y2: 211.8
  })), _line1869 || (_line1869 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 764.6,
    y1: 211.8,
    x2: 764.6,
    y2: 207.65
  })), _line1870 || (_line1870 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.08,
    y1: 241.92,
    x2: 800.2,
    y2: 241.92
  })), _line1871 || (_line1871 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.78,
    y1: 207.65,
    x2: 805.2,
    y2: 207.65
  })), _line1872 || (_line1872 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.39,
    y1: 222.04,
    x2: 805.2,
    y2: 219.13
  })), _line1873 || (_line1873 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 805.2,
    y1: 211.8,
    x2: 805.2,
    y2: 219.13
  })), _line1874 || (_line1874 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.17,
    y1: 211.8,
    x2: 805.2,
    y2: 211.8
  })), _line1875 || (_line1875 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.39,
    y1: 230.77,
    x2: 780.17,
    y2: 230.77
  })), _line1876 || (_line1876 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 808.39,
    y1: 222.04,
    x2: 808.39,
    y2: 230.77
  })), _line1877 || (_line1877 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.17,
    y1: 230.77,
    x2: 780.17,
    y2: 211.8
  })), _line1878 || (_line1878 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 801.26,
    y1: 240.67,
    x2: 807.41,
    y2: 240.67
  })), _line1879 || (_line1879 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.62,
    y1: 240.75,
    x2: 807.41,
    y2: 240.67
  })), _line1880 || (_line1880 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.62,
    y1: 245.87,
    x2: 809.02,
    y2: 245.87
  })), _polyline342 || (_polyline342 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "801.26 240.67 801.26 240.75 801.04 240.75"
  })), _polyline343 || (_polyline343 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "807.41 247.03 807.62 247.03 807.62 246.91"
  })), _line1881 || (_line1881 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.41,
    y1: 247.03,
    x2: 801.26,
    y2: 247.03
  })), _line1882 || (_line1882 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 801.04,
    y1: 251.28,
    x2: 809.02,
    y2: 251.28
  })), _line1883 || (_line1883 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 801.04,
    y1: 246.91,
    x2: 801.26,
    y2: 247.03
  })), _line1884 || (_line1884 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 801.04,
    y1: 251.28,
    x2: 801.04,
    y2: 240.75
  })), _line1885 || (_line1885 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.2,
    y1: 241.92,
    x2: 800.2,
    y2: 255.35
  })), _line1886 || (_line1886 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 809.02,
    y1: 245.87,
    x2: 809.02,
    y2: 251.28
  })), _line1887 || (_line1887 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 807.62,
    y1: 240.75,
    x2: 807.62,
    y2: 246.91
  })), _line1888 || (_line1888 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.08,
    y1: 241.92,
    x2: 782.08,
    y2: 255.35
  })), _line1889 || (_line1889 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.45,
    y1: 244.21,
    x2: 789.72,
    y2: 244.21
  })), _line1890 || (_line1890 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.45,
    y1: 254.31,
    x2: 789.72,
    y2: 254.31
  })), _line1891 || (_line1891 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.2,
    y1: 255.35,
    x2: 782.08,
    y2: 255.35
  })), _line1892 || (_line1892 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 789.72,
    y1: 244.21,
    x2: 789.72,
    y2: 254.31
  })), _line1893 || (_line1893 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.45,
    y1: 244.21,
    x2: 779.45,
    y2: 254.31
  })), _line1894 || (_line1894 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 805.5,
    y1: 240.67,
    x2: 805.5,
    y2: 230.77
  })), _line1895 || (_line1895 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 803.8,
    y1: 240.67,
    x2: 803.8,
    y2: 230.77
  })), _line1896 || (_line1896 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 805.2,
    y1: 207.65,
    x2: 805.2,
    y2: 211.8
  })), _line1897 || (_line1897 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.78,
    y1: 211.8,
    x2: 797.78,
    y2: 207.65
  })), _line1898 || (_line1898 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.26,
    y1: 211.8,
    x2: 537.26,
    y2: 207.44
  })), _line1899 || (_line1899 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.6,
    y1: 156.2,
    x2: 417.57,
    y2: 156.2
  })), _line1900 || (_line1900 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 153.08,
    x2: 418.54,
    y2: 152.58
  })), _line1901 || (_line1901 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.78,
    y1: 124.63,
    x2: 415.78,
    y2: 121.84
  })), _line1902 || (_line1902 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.9,
    y1: 124.63,
    x2: 415.78,
    y2: 124.63
  })), _line1903 || (_line1903 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.9,
    y1: 121.84,
    x2: 417.9,
    y2: 124.63
  })), _line1904 || (_line1904 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 152.58,
    x2: 415.23,
    y2: 152.58
  })), _line1905 || (_line1905 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.57,
    y1: 153.08,
    x2: 421.6,
    y2: 153.08
  })), _line1906 || (_line1906 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 412.6,
    y1: 152.58,
    x2: 412.6,
    y2: 156.61
  })), _line1907 || (_line1907 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.53,
    y1: 121.3,
    x2: 413.96,
    y2: 121.3
  })), _line1908 || (_line1908 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.78,
    y1: 124.42,
    x2: 413.53,
    y2: 124.42
  })), _line1909 || (_line1909 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.53,
    y1: 124.42,
    x2: 413.53,
    y2: 121.3
  })), _line1910 || (_line1910 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 412.6,
    y1: 156.61,
    x2: 415.23,
    y2: 156.61
  })), _line1911 || (_line1911 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.23,
    y1: 152.58,
    x2: 412.6,
    y2: 152.58
  })), _line1912 || (_line1912 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.23,
    y1: 124.42,
    x2: 415.23,
    y2: 152.58
  })), _line1913 || (_line1913 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.96,
    y1: 116.43,
    x2: 413.96,
    y2: 121.84
  })), _line1914 || (_line1914 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.9,
    y1: 116.43,
    x2: 413.96,
    y2: 116.43
  })), _line1915 || (_line1915 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 413.96,
    y1: 121.84,
    x2: 419.9,
    y2: 121.84
  })), _line1916 || (_line1916 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.09,
    y1: 122.55,
    x2: 438.65,
    y2: 122.55
  })), _line1917 || (_line1917 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.09,
    y1: 122.55,
    x2: 421.09,
    y2: 104.12
  })), _line1918 || (_line1918 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.9,
    y1: 121.84,
    x2: 419.9,
    y2: 116.43
  })), _line1919 || (_line1919 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 136.52,
    x2: 421.3,
    y2: 136.52
  })), _line1920 || (_line1920 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.93,
    y1: 148.58,
    x2: 435.17,
    y2: 148.58
  })), _line1921 || (_line1921 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.3,
    y1: 132.24,
    x2: 421.3,
    y2: 140.06
  })), _line1922 || (_line1922 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.3,
    y1: 146.21,
    x2: 435.17,
    y2: 146.21
  })), _line1923 || (_line1923 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.93,
    y1: 136.52,
    x2: 435.17,
    y2: 136.52
  })), _line1924 || (_line1924 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.3,
    y1: 132.24,
    x2: 435.17,
    y2: 132.24
  })), _line1925 || (_line1925 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437.93,
    y1: 136.52,
    x2: 437.93,
    y2: 148.58
  })), _line1926 || (_line1926 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 148.58,
    x2: 421.3,
    y2: 148.58
  })), _line1927 || (_line1927 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 438.65,
    y1: 104.12,
    x2: 438.65,
    y2: 122.55
  })), _line1928 || (_line1928 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.09,
    y1: 104.12,
    x2: 438.65,
    y2: 104.12
  })), _line1929 || (_line1929 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.17,
    y1: 132.24,
    x2: 435.17,
    y2: 140.06
  })), _line1930 || (_line1930 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.3,
    y1: 146.21,
    x2: 421.3,
    y2: 148.58
  })), _line1931 || (_line1931 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 435.17,
    y1: 146.21,
    x2: 435.17,
    y2: 148.58
  })), _line1932 || (_line1932 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.3,
    y1: 140.06,
    x2: 435.17,
    y2: 140.06
  })), _line1933 || (_line1933 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 136.52,
    x2: 418.54,
    y2: 148.58
  })), _line1934 || (_line1934 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 421.6,
    y1: 153.08,
    x2: 421.6,
    y2: 156.2
  })), _line1935 || (_line1935 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 156.61,
    x2: 418.54,
    y2: 156.2
  })), _line1936 || (_line1936 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 415.23,
    y1: 156.61,
    x2: 418.54,
    y2: 156.61
  })), _line1937 || (_line1937 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 418.54,
    y1: 121.84,
    x2: 418.54,
    y2: 132.78
  })), _line1938 || (_line1938 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.56,
    y1: 156.2,
    x2: 450.87,
    y2: 156.2
  })), _line1939 || (_line1939 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 153.08,
    x2: 451.72,
    y2: 152.58
  })), _line1940 || (_line1940 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.96,
    y1: 124.63,
    x2: 448.96,
    y2: 121.84
  })), _line1941 || (_line1941 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.08,
    y1: 124.63,
    x2: 448.96,
    y2: 124.63
  })), _line1942 || (_line1942 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.08,
    y1: 121.84,
    x2: 451.08,
    y2: 124.63
  })), _line1943 || (_line1943 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 152.58,
    x2: 448.41,
    y2: 152.58
  })), _line1944 || (_line1944 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 450.87,
    y1: 153.08,
    x2: 454.56,
    y2: 153.08
  })), _line1945 || (_line1945 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.65,
    y1: 152.45,
    x2: 445.65,
    y2: 156.61
  })), _line1946 || (_line1946 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.63,
    y1: 121.3,
    x2: 447.14,
    y2: 121.3
  })), _line1947 || (_line1947 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.96,
    y1: 124.42,
    x2: 446.63,
    y2: 124.42
  })), _line1948 || (_line1948 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 446.63,
    y1: 124.42,
    x2: 446.63,
    y2: 121.3
  })), _line1949 || (_line1949 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445.65,
    y1: 156.61,
    x2: 448.41,
    y2: 156.61
  })), _line1950 || (_line1950 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.41,
    y1: 152.45,
    x2: 445.65,
    y2: 152.45
  })), _line1951 || (_line1951 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.41,
    y1: 124.42,
    x2: 448.41,
    y2: 152.45
  })), _line1952 || (_line1952 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 447.14,
    y1: 116.43,
    x2: 447.14,
    y2: 121.84
  })), _line1953 || (_line1953 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.99,
    y1: 116.43,
    x2: 447.14,
    y2: 116.43
  })), _line1954 || (_line1954 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 447.14,
    y1: 121.84,
    x2: 452.99,
    y2: 121.84
  })), _line1955 || (_line1955 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.14,
    y1: 122.34,
    x2: 471.83,
    y2: 122.34
  })), _line1956 || (_line1956 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.14,
    y1: 122.34,
    x2: 454.14,
    y2: 104.12
  })), _line1957 || (_line1957 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 452.99,
    y1: 121.84,
    x2: 452.99,
    y2: 116.43
  })), _line1958 || (_line1958 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.59,
    y1: 136.52,
    x2: 454.35,
    y2: 136.52
  })), _line1959 || (_line1959 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.11,
    y1: 148.38,
    x2: 468.44,
    y2: 148.38
  })), _line1960 || (_line1960 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.35,
    y1: 132.24,
    x2: 454.35,
    y2: 140.06
  })), _line1961 || (_line1961 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.35,
    y1: 146.21,
    x2: 468.44,
    y2: 146.21
  })), _line1962 || (_line1962 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.11,
    y1: 136.52,
    x2: 468.44,
    y2: 136.52
  })), _line1963 || (_line1963 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.35,
    y1: 132.24,
    x2: 468.44,
    y2: 132.24
  })), _line1964 || (_line1964 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.11,
    y1: 136.52,
    x2: 471.11,
    y2: 148.38
  })), _line1965 || (_line1965 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.59,
    y1: 148.38,
    x2: 454.35,
    y2: 148.38
  })), _line1966 || (_line1966 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 471.83,
    y1: 104.12,
    x2: 471.83,
    y2: 122.34
  })), _line1967 || (_line1967 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.14,
    y1: 104.12,
    x2: 471.83,
    y2: 104.12
  })), _line1968 || (_line1968 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.44,
    y1: 132.24,
    x2: 468.44,
    y2: 140.06
  })), _line1969 || (_line1969 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.35,
    y1: 146.21,
    x2: 454.35,
    y2: 148.38
  })), _line1970 || (_line1970 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 468.44,
    y1: 146.21,
    x2: 468.44,
    y2: 148.38
  })), _line1971 || (_line1971 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.35,
    y1: 140.06,
    x2: 468.44,
    y2: 140.06
  })), _line1972 || (_line1972 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.59,
    y1: 136.52,
    x2: 451.59,
    y2: 148.38
  })), _line1973 || (_line1973 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 454.56,
    y1: 153.08,
    x2: 454.56,
    y2: 156.2
  })), _line1974 || (_line1974 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 156.61,
    x2: 451.72,
    y2: 156.2
  })), _line1975 || (_line1975 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 448.41,
    y1: 156.61,
    x2: 451.72,
    y2: 156.61
  })), _line1976 || (_line1976 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 451.72,
    y1: 121.84,
    x2: 451.72,
    y2: 132.78
  })), _line1977 || (_line1977 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.96,
    y1: 156.2,
    x2: 484.14,
    y2: 156.2
  })), _line1978 || (_line1978 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.11,
    y1: 153.08,
    x2: 485.11,
    y2: 152.58
  })), _line1979 || (_line1979 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 482.36,
    y1: 124.63,
    x2: 482.36,
    y2: 121.84
  })), _line1980 || (_line1980 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.48,
    y1: 124.63,
    x2: 482.36,
    y2: 124.63
  })), _line1981 || (_line1981 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.48,
    y1: 121.84,
    x2: 484.48,
    y2: 124.63
  })), _line1982 || (_line1982 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.11,
    y1: 152.58,
    x2: 481.72,
    y2: 152.58
  })), _line1983 || (_line1983 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.14,
    y1: 153.08,
    x2: 487.96,
    y2: 153.08
  })), _line1984 || (_line1984 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.17,
    y1: 152.58,
    x2: 479.17,
    y2: 156.61
  })), _line1985 || (_line1985 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 480.11,
    y1: 121.3,
    x2: 480.53,
    y2: 121.3
  })), _line1986 || (_line1986 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 482.36,
    y1: 124.42,
    x2: 480.11,
    y2: 124.42
  })), _line1987 || (_line1987 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 480.11,
    y1: 124.42,
    x2: 480.11,
    y2: 121.3
  })), _line1988 || (_line1988 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 479.17,
    y1: 156.61,
    x2: 481.72,
    y2: 156.61
  })), _line1989 || (_line1989 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 481.72,
    y1: 152.58,
    x2: 479.17,
    y2: 152.58
  })), _line1990 || (_line1990 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 481.72,
    y1: 124.42,
    x2: 481.72,
    y2: 152.58
  })), _line1991 || (_line1991 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 480.53,
    y1: 116.43,
    x2: 480.53,
    y2: 121.84
  })), _line1992 || (_line1992 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.26,
    y1: 116.43,
    x2: 480.53,
    y2: 116.43
  })), _line1993 || (_line1993 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 480.53,
    y1: 121.84,
    x2: 486.26,
    y2: 121.84
  })), _line1994 || (_line1994 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.53,
    y1: 122.55,
    x2: 505.23,
    y2: 122.55
  })), _line1995 || (_line1995 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.53,
    y1: 122.55,
    x2: 487.53,
    y2: 104.12
  })), _line1996 || (_line1996 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 486.26,
    y1: 121.84,
    x2: 486.26,
    y2: 116.43
  })), _line1997 || (_line1997 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.9,
    y1: 136.52,
    x2: 487.66,
    y2: 136.52
  })), _line1998 || (_line1998 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.5,
    y1: 148.58,
    x2: 501.75,
    y2: 148.58
  })), _line1999 || (_line1999 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 132.24,
    x2: 487.66,
    y2: 140.06
  })), _line2000 || (_line2000 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 146.21,
    x2: 501.75,
    y2: 146.21
  })), _line2001 || (_line2001 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.5,
    y1: 136.52,
    x2: 501.75,
    y2: 136.52
  })), _line2002 || (_line2002 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 132.24,
    x2: 501.75,
    y2: 132.24
  })), _line2003 || (_line2003 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 504.5,
    y1: 136.52,
    x2: 504.5,
    y2: 148.58
  })), _line2004 || (_line2004 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.9,
    y1: 148.58,
    x2: 487.66,
    y2: 148.58
  })), _line2005 || (_line2005 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 505.23,
    y1: 104.12,
    x2: 505.23,
    y2: 122.55
  })), _line2006 || (_line2006 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.53,
    y1: 104.12,
    x2: 505.23,
    y2: 104.12
  })), _line2007 || (_line2007 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.75,
    y1: 132.24,
    x2: 501.75,
    y2: 140.06
  })), _line2008 || (_line2008 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 146.21,
    x2: 487.66,
    y2: 148.58
  })), _line2009 || (_line2009 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 501.75,
    y1: 146.21,
    x2: 501.75,
    y2: 148.58
  })), _line2010 || (_line2010 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.66,
    y1: 140.06,
    x2: 501.75,
    y2: 140.06
  })), _line2011 || (_line2011 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.9,
    y1: 136.52,
    x2: 484.9,
    y2: 148.58
  })), _line2012 || (_line2012 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 487.96,
    y1: 153.08,
    x2: 487.96,
    y2: 156.2
  })), _line2013 || (_line2013 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.11,
    y1: 156.61,
    x2: 485.11,
    y2: 156.2
  })), _line2014 || (_line2014 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 481.72,
    y1: 156.61,
    x2: 485.11,
    y2: 156.61
  })), _line2015 || (_line2015 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 485.11,
    y1: 121.84,
    x2: 485.11,
    y2: 132.78
  })), _line2016 || (_line2016 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.14,
    y1: 156.2,
    x2: 517.19,
    y2: 156.2
  })), _line2017 || (_line2017 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.25,
    y1: 153.08,
    x2: 518.25,
    y2: 152.58
  })), _line2018 || (_line2018 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 515.49,
    y1: 124.63,
    x2: 515.49,
    y2: 121.84
  })), _line2019 || (_line2019 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 517.53,
    y1: 124.63,
    x2: 515.49,
    y2: 124.63
  })), _line2020 || (_line2020 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 517.53,
    y1: 121.84,
    x2: 517.53,
    y2: 124.63
  })), _line2021 || (_line2021 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.25,
    y1: 152.58,
    x2: 514.9,
    y2: 152.58
  })), _line2022 || (_line2022 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 517.19,
    y1: 153.08,
    x2: 521.14,
    y2: 153.08
  })), _line2023 || (_line2023 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.23,
    y1: 152.58,
    x2: 512.23,
    y2: 156.61
  })), _line2024 || (_line2024 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 513.07,
    y1: 121.3,
    x2: 513.63,
    y2: 121.3
  })), _line2025 || (_line2025 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 515.49,
    y1: 124.42,
    x2: 513.07,
    y2: 124.42
  })), _line2026 || (_line2026 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 513.07,
    y1: 124.42,
    x2: 513.07,
    y2: 121.3
  })), _line2027 || (_line2027 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 512.23,
    y1: 156.61,
    x2: 514.9,
    y2: 156.61
  })), _line2028 || (_line2028 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 514.9,
    y1: 152.58,
    x2: 512.23,
    y2: 152.58
  })), _line2029 || (_line2029 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 514.9,
    y1: 124.42,
    x2: 514.9,
    y2: 152.58
  })), _line2030 || (_line2030 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 513.63,
    y1: 116.43,
    x2: 513.63,
    y2: 121.84
  })), _line2031 || (_line2031 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.44,
    y1: 116.43,
    x2: 513.63,
    y2: 116.43
  })), _line2032 || (_line2032 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 513.63,
    y1: 121.84,
    x2: 519.44,
    y2: 121.84
  })), _line2033 || (_line2033 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.71,
    y1: 122.55,
    x2: 538.4,
    y2: 122.55
  })), _line2034 || (_line2034 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.71,
    y1: 122.55,
    x2: 520.71,
    y2: 104.12
  })), _line2035 || (_line2035 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 519.44,
    y1: 121.84,
    x2: 519.44,
    y2: 116.43
  })), _line2036 || (_line2036 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.17,
    y1: 136.52,
    x2: 520.8,
    y2: 136.52
  })), _line2037 || (_line2037 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.68,
    y1: 148.58,
    x2: 534.93,
    y2: 148.58
  })), _line2038 || (_line2038 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.8,
    y1: 132.24,
    x2: 520.8,
    y2: 140.06
  })), _line2039 || (_line2039 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.8,
    y1: 146.21,
    x2: 534.93,
    y2: 146.21
  })), _line2040 || (_line2040 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.68,
    y1: 136.52,
    x2: 534.93,
    y2: 136.52
  })), _line2041 || (_line2041 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.8,
    y1: 132.24,
    x2: 534.93,
    y2: 132.24
  })), _line2042 || (_line2042 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 537.68,
    y1: 136.52,
    x2: 537.68,
    y2: 148.58
  })), _line2043 || (_line2043 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.17,
    y1: 148.58,
    x2: 520.8,
    y2: 148.58
  })), _line2044 || (_line2044 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 538.4,
    y1: 104.12,
    x2: 538.4,
    y2: 122.55
  })), _line2045 || (_line2045 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.71,
    y1: 104.12,
    x2: 538.4,
    y2: 104.12
  })), _line2046 || (_line2046 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 534.93,
    y1: 132.24,
    x2: 534.93,
    y2: 140.06
  })), _line2047 || (_line2047 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.8,
    y1: 146.21,
    x2: 520.8,
    y2: 148.58
  })), _line2048 || (_line2048 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 534.93,
    y1: 146.21,
    x2: 534.93,
    y2: 148.58
  })), _line2049 || (_line2049 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 520.8,
    y1: 140.06,
    x2: 534.93,
    y2: 140.06
  })), _line2050 || (_line2050 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.17,
    y1: 136.52,
    x2: 518.17,
    y2: 148.58
  })), _line2051 || (_line2051 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 521.14,
    y1: 153.08,
    x2: 521.14,
    y2: 156.2
  })), _line2052 || (_line2052 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.25,
    y1: 156.61,
    x2: 518.25,
    y2: 156.2
  })), _line2053 || (_line2053 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 514.9,
    y1: 156.61,
    x2: 518.25,
    y2: 156.61
  })), _line2054 || (_line2054 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 518.25,
    y1: 121.84,
    x2: 518.25,
    y2: 132.78
  })), _line2055 || (_line2055 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.53,
    y1: 156.2,
    x2: 550.71,
    y2: 156.2
  })), _line2056 || (_line2056 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.64,
    y1: 153.08,
    x2: 551.64,
    y2: 152.58
  })), _line2057 || (_line2057 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.89,
    y1: 124.63,
    x2: 548.89,
    y2: 121.84
  })), _line2058 || (_line2058 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.01,
    y1: 124.63,
    x2: 548.89,
    y2: 124.63
  })), _line2059 || (_line2059 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.01,
    y1: 121.84,
    x2: 551.01,
    y2: 124.63
  })), _line2060 || (_line2060 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.64,
    y1: 152.58,
    x2: 548.25,
    y2: 152.58
  })), _line2061 || (_line2061 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 550.71,
    y1: 153.08,
    x2: 554.53,
    y2: 153.08
  })), _line2062 || (_line2062 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 545.49,
    y1: 152.58,
    x2: 545.49,
    y2: 156.61
  })), _line2063 || (_line2063 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.47,
    y1: 121.3,
    x2: 547.1,
    y2: 121.3
  })), _line2064 || (_line2064 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.89,
    y1: 124.42,
    x2: 546.47,
    y2: 124.42
  })), _line2065 || (_line2065 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 546.47,
    y1: 124.42,
    x2: 546.47,
    y2: 121.3
  })), _line2066 || (_line2066 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 545.49,
    y1: 156.61,
    x2: 548.25,
    y2: 156.61
  })), _line2067 || (_line2067 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.25,
    y1: 152.58,
    x2: 545.49,
    y2: 152.58
  })), _line2068 || (_line2068 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.25,
    y1: 124.42,
    x2: 548.25,
    y2: 152.58
  })), _line2069 || (_line2069 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.1,
    y1: 116.43,
    x2: 547.1,
    y2: 121.84
  })), _line2070 || (_line2070 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.83,
    y1: 116.43,
    x2: 547.1,
    y2: 116.43
  })), _line2071 || (_line2071 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 547.1,
    y1: 121.84,
    x2: 552.83,
    y2: 121.84
  })), _line2072 || (_line2072 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.98,
    y1: 122.55,
    x2: 571.8,
    y2: 122.55
  })), _line2073 || (_line2073 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.98,
    y1: 122.55,
    x2: 553.98,
    y2: 104.12
  })), _line2074 || (_line2074 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 552.83,
    y1: 121.84,
    x2: 552.83,
    y2: 116.43
  })), _line2075 || (_line2075 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.43,
    y1: 136.52,
    x2: 554.19,
    y2: 136.52
  })), _line2076 || (_line2076 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.03,
    y1: 148.58,
    x2: 568.32,
    y2: 148.58
  })), _line2077 || (_line2077 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.19,
    y1: 132.24,
    x2: 554.19,
    y2: 140.06
  })), _line2078 || (_line2078 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.19,
    y1: 146.21,
    x2: 568.32,
    y2: 146.21
  })), _line2079 || (_line2079 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.03,
    y1: 136.52,
    x2: 568.32,
    y2: 136.52
  })), _line2080 || (_line2080 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.19,
    y1: 132.24,
    x2: 568.32,
    y2: 132.24
  })), _line2081 || (_line2081 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.03,
    y1: 136.52,
    x2: 571.03,
    y2: 148.58
  })), _line2082 || (_line2082 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.43,
    y1: 148.58,
    x2: 554.19,
    y2: 148.58
  })), _line2083 || (_line2083 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 571.8,
    y1: 104.12,
    x2: 571.8,
    y2: 122.55
  })), _line2084 || (_line2084 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.98,
    y1: 104.12,
    x2: 571.8,
    y2: 104.12
  })), _line2085 || (_line2085 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.32,
    y1: 132.24,
    x2: 568.32,
    y2: 140.06
  })), _line2086 || (_line2086 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.19,
    y1: 146.21,
    x2: 554.19,
    y2: 148.58
  })), _line2087 || (_line2087 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 568.32,
    y1: 146.21,
    x2: 568.32,
    y2: 148.58
  })), _line2088 || (_line2088 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.19,
    y1: 140.06,
    x2: 568.32,
    y2: 140.06
  })), _line2089 || (_line2089 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.43,
    y1: 136.52,
    x2: 551.43,
    y2: 148.58
  })), _line2090 || (_line2090 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 554.53,
    y1: 153.08,
    x2: 554.53,
    y2: 156.2
  })), _line2091 || (_line2091 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.64,
    y1: 156.61,
    x2: 551.64,
    y2: 156.2
  })), _line2092 || (_line2092 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 548.25,
    y1: 156.61,
    x2: 551.64,
    y2: 156.61
  })), _line2093 || (_line2093 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 551.64,
    y1: 121.84,
    x2: 551.64,
    y2: 132.78
  })), _line2094 || (_line2094 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.71,
    y1: 156.2,
    x2: 583.76,
    y2: 156.2
  })), _line2095 || (_line2095 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.61,
    y1: 153.08,
    x2: 584.61,
    y2: 152.58
  })), _line2096 || (_line2096 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 582.07,
    y1: 124.63,
    x2: 582.07,
    y2: 121.84
  })), _line2097 || (_line2097 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.1,
    y1: 124.63,
    x2: 582.07,
    y2: 124.63
  })), _line2098 || (_line2098 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.1,
    y1: 121.84,
    x2: 584.1,
    y2: 124.63
  })), _line2099 || (_line2099 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.61,
    y1: 152.58,
    x2: 581.34,
    y2: 152.58
  })), _line2100 || (_line2100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 583.76,
    y1: 153.08,
    x2: 587.71,
    y2: 153.08
  })), _line2101 || (_line2101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 578.8,
    y1: 152.58,
    x2: 578.8,
    y2: 156.61
  })), _line2102 || (_line2102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.65,
    y1: 121.3,
    x2: 580.07,
    y2: 121.3
  })), _line2103 || (_line2103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.98,
    y1: 124.42,
    x2: 579.65,
    y2: 124.42
  })), _line2104 || (_line2104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 579.65,
    y1: 124.42,
    x2: 579.65,
    y2: 121.3
  })), _line2105 || (_line2105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 578.8,
    y1: 156.61,
    x2: 581.34,
    y2: 156.61
  })), _line2106 || (_line2106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.34,
    y1: 152.58,
    x2: 578.8,
    y2: 152.58
  })), _line2107 || (_line2107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.34,
    y1: 124.42,
    x2: 581.34,
    y2: 152.58
  })), _line2108 || (_line2108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.07,
    y1: 116.43,
    x2: 580.07,
    y2: 121.84
  })), _line2109 || (_line2109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.01,
    y1: 116.43,
    x2: 580.07,
    y2: 116.43
  })), _line2110 || (_line2110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 580.07,
    y1: 121.84,
    x2: 586.01,
    y2: 121.84
  })), _line2111 || (_line2111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.28,
    y1: 122.55,
    x2: 604.76,
    y2: 122.55
  })), _line2112 || (_line2112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.28,
    y1: 122.55,
    x2: 587.28,
    y2: 104.12
  })), _line2113 || (_line2113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 586.01,
    y1: 121.84,
    x2: 586.01,
    y2: 116.43
  })), _line2114 || (_line2114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.61,
    y1: 136.52,
    x2: 587.37,
    y2: 136.52
  })), _line2115 || (_line2115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604,
    y1: 148.58,
    x2: 601.37,
    y2: 148.58
  })), _line2116 || (_line2116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.37,
    y1: 132.24,
    x2: 587.37,
    y2: 140.06
  })), _line2117 || (_line2117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.37,
    y1: 146.21,
    x2: 601.37,
    y2: 146.21
  })), _line2118 || (_line2118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604,
    y1: 136.52,
    x2: 601.37,
    y2: 136.52
  })), _line2119 || (_line2119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.37,
    y1: 132.24,
    x2: 601.37,
    y2: 132.24
  })), _line2120 || (_line2120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604,
    y1: 136.52,
    x2: 604,
    y2: 148.58
  })), _line2121 || (_line2121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.61,
    y1: 148.58,
    x2: 587.37,
    y2: 148.58
  })), _line2122 || (_line2122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 604.76,
    y1: 104.12,
    x2: 604.76,
    y2: 122.55
  })), _line2123 || (_line2123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.28,
    y1: 104.12,
    x2: 604.76,
    y2: 104.12
  })), _line2124 || (_line2124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.37,
    y1: 132.24,
    x2: 601.37,
    y2: 140.06
  })), _line2125 || (_line2125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.37,
    y1: 146.21,
    x2: 587.37,
    y2: 148.58
  })), _line2126 || (_line2126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 601.37,
    y1: 146.21,
    x2: 601.37,
    y2: 148.58
  })), _line2127 || (_line2127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.37,
    y1: 140.06,
    x2: 601.37,
    y2: 140.06
  })), _line2128 || (_line2128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.61,
    y1: 136.52,
    x2: 584.61,
    y2: 148.58
  })), _line2129 || (_line2129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 587.71,
    y1: 153.08,
    x2: 587.71,
    y2: 156.2
  })), _line2130 || (_line2130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.61,
    y1: 156.61,
    x2: 584.61,
    y2: 156.2
  })), _line2131 || (_line2131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 581.34,
    y1: 156.61,
    x2: 584.61,
    y2: 156.61
  })), _line2132 || (_line2132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 584.82,
    y1: 121.84,
    x2: 584.82,
    y2: 132.78
  })), _line2133 || (_line2133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.97,
    y1: 156.2,
    x2: 617.07,
    y2: 156.2
  })), _line2134 || (_line2134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.13,
    y1: 153.08,
    x2: 618.13,
    y2: 152.58
  })), _line2135 || (_line2135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.46,
    y1: 124.63,
    x2: 615.46,
    y2: 121.84
  })), _line2136 || (_line2136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 617.37,
    y1: 124.63,
    x2: 615.46,
    y2: 124.63
  })), _line2137 || (_line2137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 617.37,
    y1: 121.84,
    x2: 617.37,
    y2: 124.63
  })), _line2138 || (_line2138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.13,
    y1: 152.58,
    x2: 614.82,
    y2: 152.58
  })), _line2139 || (_line2139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 617.07,
    y1: 153.08,
    x2: 620.97,
    y2: 153.08
  })), _line2140 || (_line2140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.06,
    y1: 152.58,
    x2: 612.06,
    y2: 156.61
  })), _line2141 || (_line2141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.04,
    y1: 121.3,
    x2: 613.46,
    y2: 121.3
  })), _line2142 || (_line2142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 615.46,
    y1: 124.42,
    x2: 613.04,
    y2: 124.42
  })), _line2143 || (_line2143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.04,
    y1: 124.42,
    x2: 613.04,
    y2: 121.3
  })), _line2144 || (_line2144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 612.06,
    y1: 156.61,
    x2: 614.82,
    y2: 156.61
  })), _line2145 || (_line2145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.82,
    y1: 152.58,
    x2: 612.06,
    y2: 152.58
  })), _line2146 || (_line2146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.82,
    y1: 124.42,
    x2: 614.82,
    y2: 152.58
  })), _line2147 || (_line2147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.46,
    y1: 116.43,
    x2: 613.46,
    y2: 121.84
  })), _line2148 || (_line2148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.4,
    y1: 116.43,
    x2: 613.46,
    y2: 116.43
  })), _line2149 || (_line2149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 613.46,
    y1: 121.84,
    x2: 619.4,
    y2: 121.84
  })), _line2150 || (_line2150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.55,
    y1: 122.55,
    x2: 638.24,
    y2: 122.55
  })), _line2151 || (_line2151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.55,
    y1: 122.55,
    x2: 620.55,
    y2: 104.12
  })), _line2152 || (_line2152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 619.4,
    y1: 121.84,
    x2: 619.4,
    y2: 116.43
  })), _line2153 || (_line2153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618,
    y1: 136.52,
    x2: 620.76,
    y2: 136.52
  })), _line2154 || (_line2154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 637.52,
    y1: 148.58,
    x2: 634.85,
    y2: 148.58
  })), _line2155 || (_line2155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.76,
    y1: 132.24,
    x2: 620.76,
    y2: 140.06
  })), _line2156 || (_line2156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.76,
    y1: 146.21,
    x2: 634.85,
    y2: 146.21
  })), _line2157 || (_line2157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 637.52,
    y1: 136.52,
    x2: 634.85,
    y2: 136.52
  })), _line2158 || (_line2158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.76,
    y1: 132.24,
    x2: 634.85,
    y2: 132.24
  })), _line2159 || (_line2159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 637.52,
    y1: 136.52,
    x2: 637.52,
    y2: 148.58
  })), _line2160 || (_line2160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618,
    y1: 148.58,
    x2: 620.76,
    y2: 148.58
  })), _line2161 || (_line2161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 638.24,
    y1: 104.12,
    x2: 638.24,
    y2: 122.55
  })), _line2162 || (_line2162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.55,
    y1: 104.12,
    x2: 638.24,
    y2: 104.12
  })), _line2163 || (_line2163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 132.24,
    x2: 634.85,
    y2: 140.06
  })), _line2164 || (_line2164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.76,
    y1: 146.21,
    x2: 620.76,
    y2: 148.58
  })), _line2165 || (_line2165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 634.85,
    y1: 146.21,
    x2: 634.85,
    y2: 148.58
  })), _line2166 || (_line2166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.76,
    y1: 140.06,
    x2: 634.85,
    y2: 140.06
  })), _line2167 || (_line2167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618,
    y1: 136.52,
    x2: 618,
    y2: 148.58
  })), _line2168 || (_line2168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 620.97,
    y1: 153.08,
    x2: 620.97,
    y2: 156.2
  })), _line2169 || (_line2169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.13,
    y1: 156.61,
    x2: 618.13,
    y2: 156.2
  })), _line2170 || (_line2170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 614.82,
    y1: 156.61,
    x2: 618.13,
    y2: 156.61
  })), _line2171 || (_line2171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 618.13,
    y1: 121.84,
    x2: 618.13,
    y2: 132.78
  })), _line2172 || (_line2172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.24,
    y1: 156.2,
    x2: 650.21,
    y2: 156.2
  })), _line2173 || (_line2173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 153.08,
    x2: 651.18,
    y2: 152.58
  })), _line2174 || (_line2174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.64,
    y1: 124.63,
    x2: 648.64,
    y2: 121.84
  })), _line2175 || (_line2175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 650.55,
    y1: 124.63,
    x2: 648.64,
    y2: 124.63
  })), _line2176 || (_line2176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 650.55,
    y1: 121.84,
    x2: 650.55,
    y2: 124.63
  })), _line2177 || (_line2177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 152.58,
    x2: 647.92,
    y2: 152.58
  })), _line2178 || (_line2178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 650.21,
    y1: 153.08,
    x2: 654.24,
    y2: 153.08
  })), _line2179 || (_line2179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.24,
    y1: 152.58,
    x2: 645.24,
    y2: 156.61
  })), _line2180 || (_line2180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.22,
    y1: 121.3,
    x2: 646.64,
    y2: 121.3
  })), _line2181 || (_line2181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 648.43,
    y1: 124.42,
    x2: 646.22,
    y2: 124.42
  })), _line2182 || (_line2182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.22,
    y1: 124.42,
    x2: 646.22,
    y2: 121.3
  })), _line2183 || (_line2183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 645.24,
    y1: 156.61,
    x2: 647.92,
    y2: 156.61
  })), _line2184 || (_line2184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.92,
    y1: 152.58,
    x2: 645.24,
    y2: 152.58
  })), _line2185 || (_line2185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.92,
    y1: 124.42,
    x2: 647.92,
    y2: 152.58
  })), _line2186 || (_line2186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.64,
    y1: 116.43,
    x2: 646.64,
    y2: 121.84
  })), _line2187 || (_line2187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.54,
    y1: 116.43,
    x2: 646.64,
    y2: 116.43
  })), _line2188 || (_line2188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 646.64,
    y1: 121.84,
    x2: 652.54,
    y2: 121.84
  })), _line2189 || (_line2189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.73,
    y1: 122.55,
    x2: 671.34,
    y2: 122.55
  })), _line2190 || (_line2190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.73,
    y1: 122.55,
    x2: 653.73,
    y2: 104.12
  })), _line2191 || (_line2191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 652.54,
    y1: 121.84,
    x2: 652.54,
    y2: 116.43
  })), _line2192 || (_line2192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 136.52,
    x2: 653.94,
    y2: 136.52
  })), _line2193 || (_line2193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 670.57,
    y1: 148.58,
    x2: 667.82,
    y2: 148.58
  })), _line2194 || (_line2194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.94,
    y1: 132.24,
    x2: 653.94,
    y2: 140.06
  })), _line2195 || (_line2195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.94,
    y1: 146.21,
    x2: 667.82,
    y2: 146.21
  })), _line2196 || (_line2196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 670.57,
    y1: 136.52,
    x2: 667.82,
    y2: 136.52
  })), _line2197 || (_line2197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.94,
    y1: 132.24,
    x2: 667.82,
    y2: 132.24
  })), _line2198 || (_line2198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 670.57,
    y1: 136.52,
    x2: 670.57,
    y2: 148.58
  })), _line2199 || (_line2199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 148.58,
    x2: 653.94,
    y2: 148.58
  })), _line2200 || (_line2200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 671.34,
    y1: 104.12,
    x2: 671.34,
    y2: 122.55
  })), _line2201 || (_line2201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.73,
    y1: 104.12,
    x2: 671.34,
    y2: 104.12
  })), _line2202 || (_line2202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.82,
    y1: 132.24,
    x2: 667.82,
    y2: 140.06
  })), _line2203 || (_line2203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.94,
    y1: 146.21,
    x2: 653.94,
    y2: 148.58
  })), _line2204 || (_line2204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 667.82,
    y1: 146.21,
    x2: 667.82,
    y2: 148.58
  })), _line2205 || (_line2205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 653.94,
    y1: 140.06,
    x2: 667.82,
    y2: 140.06
  })), _line2206 || (_line2206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 136.52,
    x2: 651.18,
    y2: 148.58
  })), _line2207 || (_line2207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 654.24,
    y1: 153.08,
    x2: 654.24,
    y2: 156.2
  })), _line2208 || (_line2208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 156.61,
    x2: 651.18,
    y2: 156.2
  })), _line2209 || (_line2209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 647.92,
    y1: 156.61,
    x2: 651.18,
    y2: 156.61
  })), _line2210 || (_line2210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.18,
    y1: 121.84,
    x2: 651.18,
    y2: 132.78
  })), _line2211 || (_line2211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.55,
    y1: 156.2,
    x2: 683.6,
    y2: 156.2
  })), _line2212 || (_line2212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.58,
    y1: 153.08,
    x2: 684.58,
    y2: 152.58
  })), _line2213 || (_line2213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.9,
    y1: 124.63,
    x2: 681.9,
    y2: 121.84
  })), _line2214 || (_line2214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.94,
    y1: 124.63,
    x2: 681.9,
    y2: 124.63
  })), _line2215 || (_line2215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.94,
    y1: 121.84,
    x2: 683.94,
    y2: 124.63
  })), _line2216 || (_line2216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.58,
    y1: 152.58,
    x2: 681.18,
    y2: 152.58
  })), _line2217 || (_line2217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.6,
    y1: 153.08,
    x2: 687.55,
    y2: 153.08
  })), _line2218 || (_line2218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.64,
    y1: 152.58,
    x2: 678.64,
    y2: 156.61
  })), _line2219 || (_line2219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.48,
    y1: 121.3,
    x2: 679.99,
    y2: 121.3
  })), _line2220 || (_line2220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.82,
    y1: 124.42,
    x2: 679.48,
    y2: 124.42
  })), _line2221 || (_line2221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.48,
    y1: 124.42,
    x2: 679.48,
    y2: 121.3
  })), _line2222 || (_line2222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 678.64,
    y1: 156.61,
    x2: 681.18,
    y2: 156.61
  })), _line2223 || (_line2223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.18,
    y1: 152.58,
    x2: 678.64,
    y2: 152.58
  })), _line2224 || (_line2224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.18,
    y1: 124.42,
    x2: 681.18,
    y2: 152.58
  })), _line2225 || (_line2225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.99,
    y1: 116.43,
    x2: 679.99,
    y2: 121.84
  })), _line2226 || (_line2226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.85,
    y1: 116.43,
    x2: 679.99,
    y2: 116.43
  })), _line2227 || (_line2227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 679.99,
    y1: 121.84,
    x2: 685.85,
    y2: 121.84
  })), _line2228 || (_line2228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.12,
    y1: 122.55,
    x2: 704.69,
    y2: 122.55
  })), _line2229 || (_line2229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.12,
    y1: 122.55,
    x2: 687.12,
    y2: 104.12
  })), _line2230 || (_line2230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685.85,
    y1: 121.84,
    x2: 685.85,
    y2: 116.43
  })), _line2231 || (_line2231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.58,
    y1: 136.52,
    x2: 687.21,
    y2: 136.52
  })), _line2232 || (_line2232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 703.97,
    y1: 148.58,
    x2: 701.21,
    y2: 148.58
  })), _line2233 || (_line2233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.21,
    y1: 132.24,
    x2: 687.21,
    y2: 140.06
  })), _line2234 || (_line2234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.21,
    y1: 146.21,
    x2: 701.21,
    y2: 146.21
  })), _line2235 || (_line2235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 703.97,
    y1: 136.52,
    x2: 701.21,
    y2: 136.52
  })), _line2236 || (_line2236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.21,
    y1: 132.24,
    x2: 701.21,
    y2: 132.24
  })), _line2237 || (_line2237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 703.97,
    y1: 136.52,
    x2: 703.97,
    y2: 148.58
  })), _line2238 || (_line2238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.58,
    y1: 148.58,
    x2: 687.21,
    y2: 148.58
  })), _line2239 || (_line2239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.69,
    y1: 104.12,
    x2: 704.69,
    y2: 122.55
  })), _line2240 || (_line2240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.12,
    y1: 104.12,
    x2: 704.69,
    y2: 104.12
  })), _line2241 || (_line2241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.21,
    y1: 132.24,
    x2: 701.21,
    y2: 140.06
  })), _line2242 || (_line2242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.21,
    y1: 146.21,
    x2: 687.21,
    y2: 148.58
  })), _line2243 || (_line2243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.21,
    y1: 146.21,
    x2: 701.21,
    y2: 148.58
  })), _line2244 || (_line2244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.21,
    y1: 140.06,
    x2: 701.21,
    y2: 140.06
  })), _line2245 || (_line2245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.58,
    y1: 136.52,
    x2: 684.58,
    y2: 148.58
  })), _line2246 || (_line2246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 687.55,
    y1: 153.08,
    x2: 687.55,
    y2: 156.2
  })), _line2247 || (_line2247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.58,
    y1: 156.61,
    x2: 684.58,
    y2: 156.2
  })), _line2248 || (_line2248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.18,
    y1: 156.61,
    x2: 684.58,
    y2: 156.61
  })), _line2249 || (_line2249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 684.66,
    y1: 121.84,
    x2: 684.66,
    y2: 132.78
  })), _line2250 || (_line2250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.6,
    y1: 156.2,
    x2: 716.78,
    y2: 156.2
  })), _line2251 || (_line2251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.76,
    y1: 153.08,
    x2: 717.76,
    y2: 152.58
  })), _line2252 || (_line2252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715,
    y1: 124.63,
    x2: 715,
    y2: 121.84
  })), _line2253 || (_line2253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.12,
    y1: 124.63,
    x2: 715,
    y2: 124.63
  })), _line2254 || (_line2254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.12,
    y1: 121.84,
    x2: 717.12,
    y2: 124.63
  })), _line2255 || (_line2255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.76,
    y1: 152.58,
    x2: 714.36,
    y2: 152.58
  })), _line2256 || (_line2256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.78,
    y1: 153.08,
    x2: 720.6,
    y2: 153.08
  })), _line2257 || (_line2257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 711.82,
    y1: 152.58,
    x2: 711.82,
    y2: 156.61
  })), _line2258 || (_line2258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.75,
    y1: 121.3,
    x2: 713.17,
    y2: 121.3
  })), _line2259 || (_line2259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 715,
    y1: 124.42,
    x2: 712.75,
    y2: 124.42
  })), _line2260 || (_line2260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 712.75,
    y1: 124.42,
    x2: 712.75,
    y2: 121.3
  })), _line2261 || (_line2261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 711.82,
    y1: 156.61,
    x2: 714.36,
    y2: 156.61
  })), _line2262 || (_line2262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.36,
    y1: 152.58,
    x2: 711.82,
    y2: 152.58
  })), _line2263 || (_line2263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.36,
    y1: 124.42,
    x2: 714.36,
    y2: 152.58
  })), _line2264 || (_line2264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 723.7,
    y1: 139.98,
    x2: 747.84,
    y2: 139.98
  })), _line2265 || (_line2265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 713.17,
    y1: 116.43,
    x2: 713.17,
    y2: 121.84
  })), _line2266 || (_line2266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.9,
    y1: 116.43,
    x2: 713.17,
    y2: 116.43
  })), _line2267 || (_line2267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 713.17,
    y1: 121.84,
    x2: 718.9,
    y2: 121.84
  })), _line2268 || (_line2268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 122.55,
    x2: 737.87,
    y2: 122.55
  })), _line2269 || (_line2269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 122.55,
    x2: 720.3,
    y2: 104.12
  })), _line2270 || (_line2270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.9,
    y1: 121.84,
    x2: 718.9,
    y2: 116.43
  })), _line2271 || (_line2271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.54,
    y1: 136.52,
    x2: 720.3,
    y2: 136.52
  })), _line2272 || (_line2272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.15,
    y1: 148.58,
    x2: 734.39,
    y2: 148.58
  })), _line2273 || (_line2273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 132.24,
    x2: 720.3,
    y2: 140.06
  })), _line2274 || (_line2274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 146.21,
    x2: 734.39,
    y2: 146.21
  })), _line2275 || (_line2275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.15,
    y1: 136.52,
    x2: 734.39,
    y2: 136.52
  })), _line2276 || (_line2276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 132.24,
    x2: 734.39,
    y2: 132.24
  })), _line2277 || (_line2277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.15,
    y1: 136.52,
    x2: 737.15,
    y2: 148.58
  })), _line2278 || (_line2278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.54,
    y1: 148.58,
    x2: 720.3,
    y2: 148.58
  })), _line2279 || (_line2279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.87,
    y1: 104.12,
    x2: 737.87,
    y2: 122.55
  })), _line2280 || (_line2280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 104.12,
    x2: 737.87,
    y2: 104.12
  })), _line2281 || (_line2281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.39,
    y1: 132.24,
    x2: 734.39,
    y2: 140.06
  })), _line2282 || (_line2282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 146.21,
    x2: 720.3,
    y2: 148.58
  })), _line2283 || (_line2283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.39,
    y1: 146.21,
    x2: 734.39,
    y2: 148.58
  })), _line2284 || (_line2284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.3,
    y1: 140.06,
    x2: 734.39,
    y2: 140.06
  })), _line2285 || (_line2285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.54,
    y1: 136.52,
    x2: 717.54,
    y2: 148.58
  })), _line2286 || (_line2286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 720.6,
    y1: 153.08,
    x2: 720.6,
    y2: 156.2
  })), _line2287 || (_line2287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.76,
    y1: 156.61,
    x2: 717.76,
    y2: 156.2
  })), _line2288 || (_line2288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.36,
    y1: 156.61,
    x2: 717.76,
    y2: 156.61
  })), _line2289 || (_line2289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 717.76,
    y1: 121.84,
    x2: 717.76,
    y2: 132.78
  })), _line2290 || (_line2290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 754.12,
    y1: 156.2,
    x2: 750.17,
    y2: 156.2
  })), _line2291 || (_line2291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 153.08,
    x2: 751.02,
    y2: 152.58
  })), _line2292 || (_line2292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.47,
    y1: 124.63,
    x2: 748.47,
    y2: 121.84
  })), _line2293 || (_line2293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 750.51,
    y1: 124.63,
    x2: 748.47,
    y2: 124.63
  })), _line2294 || (_line2294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 750.51,
    y1: 121.84,
    x2: 750.51,
    y2: 124.63
  })), _line2295 || (_line2295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 152.58,
    x2: 747.75,
    y2: 152.58
  })), _line2296 || (_line2296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 750.17,
    y1: 153.08,
    x2: 754.12,
    y2: 153.08
  })), _line2297 || (_line2297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.21,
    y1: 152.58,
    x2: 745.21,
    y2: 156.61
  })), _line2298 || (_line2298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.06,
    y1: 121.3,
    x2: 746.48,
    y2: 121.3
  })), _line2299 || (_line2299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.39,
    y1: 124.42,
    x2: 746.06,
    y2: 124.42
  })), _line2300 || (_line2300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.06,
    y1: 124.42,
    x2: 746.06,
    y2: 121.3
  })), _line2301 || (_line2301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 745.21,
    y1: 156.61,
    x2: 747.75,
    y2: 156.61
  })), _line2302 || (_line2302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 747.75,
    y1: 152.58,
    x2: 745.21,
    y2: 152.58
  })), _line2303 || (_line2303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 747.75,
    y1: 124.42,
    x2: 747.75,
    y2: 152.58
  })), _line2304 || (_line2304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.48,
    y1: 116.43,
    x2: 746.48,
    y2: 121.84
  })), _line2305 || (_line2305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.42,
    y1: 116.43,
    x2: 746.48,
    y2: 116.43
  })), _line2306 || (_line2306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 746.48,
    y1: 121.84,
    x2: 752.42,
    y2: 121.84
  })), _line2307 || (_line2307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.69,
    y1: 122.55,
    x2: 771.26,
    y2: 122.55
  })), _line2308 || (_line2308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.69,
    y1: 122.55,
    x2: 753.69,
    y2: 104.12
  })), _line2309 || (_line2309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 752.42,
    y1: 121.84,
    x2: 752.42,
    y2: 116.43
  })), _line2310 || (_line2310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 136.52,
    x2: 753.78,
    y2: 136.52
  })), _line2311 || (_line2311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 770.41,
    y1: 148.58,
    x2: 767.78,
    y2: 148.58
  })), _line2312 || (_line2312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.78,
    y1: 132.24,
    x2: 753.78,
    y2: 140.06
  })), _line2313 || (_line2313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.78,
    y1: 146.21,
    x2: 767.78,
    y2: 146.21
  })), _line2314 || (_line2314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 770.41,
    y1: 136.52,
    x2: 767.78,
    y2: 136.52
  })), _line2315 || (_line2315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.78,
    y1: 132.24,
    x2: 767.78,
    y2: 132.24
  })), _line2316 || (_line2316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 770.41,
    y1: 136.52,
    x2: 770.41,
    y2: 148.58
  })), _line2317 || (_line2317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 148.58,
    x2: 753.78,
    y2: 148.58
  })), _line2318 || (_line2318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.26,
    y1: 104.12,
    x2: 771.26,
    y2: 122.55
  })), _line2319 || (_line2319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.69,
    y1: 104.12,
    x2: 771.26,
    y2: 104.12
  })), _line2320 || (_line2320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 767.78,
    y1: 132.24,
    x2: 767.78,
    y2: 140.06
  })), _line2321 || (_line2321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.78,
    y1: 146.21,
    x2: 753.78,
    y2: 148.58
  })), _line2322 || (_line2322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 767.78,
    y1: 146.21,
    x2: 767.78,
    y2: 148.58
  })), _line2323 || (_line2323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 753.78,
    y1: 140.06,
    x2: 767.78,
    y2: 140.06
  })), _line2324 || (_line2324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 136.52,
    x2: 751.02,
    y2: 148.58
  })), _line2325 || (_line2325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 754.12,
    y1: 153.08,
    x2: 754.12,
    y2: 156.2
  })), _line2326 || (_line2326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 156.61,
    x2: 751.02,
    y2: 156.2
  })), _line2327 || (_line2327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 747.75,
    y1: 156.61,
    x2: 751.02,
    y2: 156.61
  })), _line2328 || (_line2328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.02,
    y1: 121.84,
    x2: 751.02,
    y2: 132.78
  })), _line2329 || (_line2329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 787.17,
    y1: 156.2,
    x2: 783.35,
    y2: 156.2
  })), _line2330 || (_line2330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.28,
    y1: 153.08,
    x2: 784.28,
    y2: 152.58
  })), _line2331 || (_line2331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.57,
    y1: 124.63,
    x2: 781.57,
    y2: 121.84
  })), _line2332 || (_line2332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.69,
    y1: 124.63,
    x2: 781.57,
    y2: 124.63
  })), _line2333 || (_line2333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.69,
    y1: 121.84,
    x2: 783.69,
    y2: 124.63
  })), _line2334 || (_line2334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.28,
    y1: 152.58,
    x2: 780.93,
    y2: 152.58
  })), _line2335 || (_line2335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 783.35,
    y1: 153.08,
    x2: 787.17,
    y2: 153.08
  })), _line2336 || (_line2336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.18,
    y1: 152.58,
    x2: 778.18,
    y2: 156.61
  })), _line2337 || (_line2337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.11,
    y1: 121.3,
    x2: 779.75,
    y2: 121.3
  })), _line2338 || (_line2338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.57,
    y1: 124.42,
    x2: 779.11,
    y2: 124.42
  })), _line2339 || (_line2339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.11,
    y1: 124.42,
    x2: 779.11,
    y2: 121.3
  })), _line2340 || (_line2340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 778.18,
    y1: 156.61,
    x2: 780.93,
    y2: 156.61
  })), _line2341 || (_line2341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.93,
    y1: 152.58,
    x2: 778.18,
    y2: 152.58
  })), _line2342 || (_line2342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.93,
    y1: 124.42,
    x2: 780.93,
    y2: 152.58
  })), _line2343 || (_line2343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.75,
    y1: 116.43,
    x2: 779.75,
    y2: 121.84
  })), _line2344 || (_line2344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.47,
    y1: 116.43,
    x2: 779.75,
    y2: 116.43
  })), _line2345 || (_line2345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 779.75,
    y1: 121.84,
    x2: 785.47,
    y2: 121.84
  })), _line2346 || (_line2346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.62,
    y1: 122.55,
    x2: 804.44,
    y2: 122.55
  })), _line2347 || (_line2347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.62,
    y1: 122.55,
    x2: 786.62,
    y2: 104.12
  })), _line2348 || (_line2348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 785.47,
    y1: 121.84,
    x2: 785.47,
    y2: 116.43
  })), _line2349 || (_line2349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.12,
    y1: 136.52,
    x2: 786.83,
    y2: 136.52
  })), _line2350 || (_line2350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 803.72,
    y1: 148.58,
    x2: 800.96,
    y2: 148.58
  })), _line2351 || (_line2351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.83,
    y1: 132.24,
    x2: 786.83,
    y2: 140.06
  })), _line2352 || (_line2352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.83,
    y1: 146.21,
    x2: 800.96,
    y2: 146.21
  })), _line2353 || (_line2353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 803.72,
    y1: 136.52,
    x2: 800.96,
    y2: 136.52
  })), _line2354 || (_line2354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.83,
    y1: 132.24,
    x2: 800.96,
    y2: 132.24
  })), _line2355 || (_line2355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 803.72,
    y1: 136.52,
    x2: 803.72,
    y2: 148.58
  })), _line2356 || (_line2356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.12,
    y1: 148.58,
    x2: 786.83,
    y2: 148.58
  })), _line2357 || (_line2357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.44,
    y1: 104.12,
    x2: 804.44,
    y2: 122.55
  })), _line2358 || (_line2358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.62,
    y1: 104.12,
    x2: 804.44,
    y2: 104.12
  })), _line2359 || (_line2359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.96,
    y1: 132.24,
    x2: 800.96,
    y2: 140.06
  })), _line2360 || (_line2360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.83,
    y1: 146.21,
    x2: 786.83,
    y2: 148.58
  })), _line2361 || (_line2361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.96,
    y1: 146.21,
    x2: 800.96,
    y2: 148.58
  })), _line2362 || (_line2362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 786.83,
    y1: 140.06,
    x2: 800.96,
    y2: 140.06
  })), _line2363 || (_line2363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.12,
    y1: 136.52,
    x2: 784.12,
    y2: 148.58
  })), _line2364 || (_line2364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 787.17,
    y1: 153.08,
    x2: 787.17,
    y2: 156.2
  })), _line2365 || (_line2365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.28,
    y1: 156.61,
    x2: 784.28,
    y2: 156.2
  })), _line2366 || (_line2366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 780.93,
    y1: 156.61,
    x2: 784.28,
    y2: 156.61
  })), _line2367 || (_line2367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.28,
    y1: 121.84,
    x2: 784.28,
    y2: 132.78
  })), _line2368 || (_line2368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.75,
    y1: 450.42,
    x2: 705.75,
    y2: 444.89
  })), _line2369 || (_line2369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 700.57,
    y1: 450.42,
    x2: 700.57,
    y2: 444.89
  })), _polyline344 || (_polyline344 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "698.45 450.71 698.36 450.71 698.36 451.04"
  })), _polyline345 || (_polyline345 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "698.36 458.24 698.36 458.32 698.45 458.32"
  })), _polyline346 || (_polyline346 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "706.6 458.32 706.81 458.32 706.81 458.24"
  })), _polyline347 || (_polyline347 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "706.81 451.04 706.81 450.71 706.6 450.71"
  })), _line2370 || (_line2370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 706.6,
    y1: 458.32,
    x2: 698.45,
    y2: 458.32
  })), _line2371 || (_line2371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 706.81,
    y1: 451.04,
    x2: 706.81,
    y2: 458.24
  })), _line2372 || (_line2372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.45,
    y1: 450.71,
    x2: 706.6,
    y2: 450.71
  })), _line2373 || (_line2373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 705.45,
    y1: 462.06,
    x2: 705.45,
    y2: 458.45
  })), _line2374 || (_line2374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.72,
    y1: 462.06,
    x2: 699.72,
    y2: 458.45
  })), _line2375 || (_line2375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 700.57,
    y1: 450.42,
    x2: 705.75,
    y2: 450.42
  })), _line2376 || (_line2376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 700.57,
    y1: 444.89,
    x2: 705.75,
    y2: 444.89
  })), _line2377 || (_line2377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.72,
    y1: 462.06,
    x2: 705.45,
    y2: 462.06
  })), _line2378 || (_line2378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.36,
    y1: 458.24,
    x2: 698.36,
    y2: 451.04
  })), _line2379 || (_line2379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 697.39,
    y1: 447.59,
    x2: 697.39,
    y2: 462.4
  })), _line2380 || (_line2380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 706.81,
    y1: 462.4,
    x2: 706.81,
    y2: 469.68
  })), _line2381 || (_line2381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 706.81,
    y1: 469.68,
    x2: 685,
    y2: 469.68
  })), _line2382 || (_line2382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 697.39,
    y1: 447.59,
    x2: 685,
    y2: 447.59
  })), _line2383 || (_line2383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685,
    y1: 447.59,
    x2: 685,
    y2: 469.68
  })), _line2384 || (_line2384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 697.39,
    y1: 462.4,
    x2: 706.81,
    y2: 462.4
  })), _line2385 || (_line2385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 685,
    y1: 469.68,
    x2: 685,
    y2: 469.18
  })), _line2386 || (_line2386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 703.03,
    y1: 436.44,
    x2: 703.03,
    y2: 444.8
  })), _line2387 || (_line2387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.79,
    y1: 436.44,
    x2: 701.33,
    y2: 436.44
  })), _line2388 || (_line2388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.79,
    y1: 444.8,
    x2: 703.03,
    y2: 444.8
  })), _line2389 || (_line2389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 698.79,
    y1: 436.44,
    x2: 698.79,
    y2: 444.8
  })), _line2390 || (_line2390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 702.4,
    y1: 436.44,
    x2: 703.03,
    y2: 436.44
  })), _line2391 || (_line2391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.18,
    y1: 434.07,
    x2: 704.69,
    y2: 434.07
  })), _line2392 || (_line2392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 683.18,
    y1: 434.07,
    x2: 683.18,
    y2: 432.91
  })), _line2393 || (_line2393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.61,
    y1: 432.91,
    x2: 683.18,
    y2: 432.91
  })), _line2394 || (_line2394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.69,
    y1: 412.7,
    x2: 681.61,
    y2: 412.7
  })), _line2395 || (_line2395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 704.69,
    y1: 434.07,
    x2: 704.69,
    y2: 412.7
  })), _line2396 || (_line2396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 681.61,
    y1: 432.91,
    x2: 681.61,
    y2: 412.7
  })), _line2397 || (_line2397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 702.4,
    y1: 434.07,
    x2: 702.4,
    y2: 436.44
  })), _line2398 || (_line2398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.33,
    y1: 434.07,
    x2: 701.33,
    y2: 436.44
  })), _line2399 || (_line2399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.84,
    y1: 450.42,
    x2: 738.84,
    y2: 444.89
  })), _line2400 || (_line2400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 733.62,
    y1: 450.42,
    x2: 733.62,
    y2: 444.89
  })), _polyline348 || (_polyline348 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "731.63 450.71 731.5 450.71 731.29 451.04"
  })), _polyline349 || (_polyline349 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "731.29 458.24 731.5 458.32 731.63 458.32"
  })), _polyline350 || (_polyline350 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "739.69 458.32 739.9 458.32 739.99 458.24"
  })), _polyline351 || (_polyline351 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "739.99 451.04 739.9 450.71 739.69 450.71"
  })), _line2401 || (_line2401 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 739.69,
    y1: 458.32,
    x2: 731.63,
    y2: 458.32
  })), _line2402 || (_line2402 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 739.99,
    y1: 451.04,
    x2: 739.99,
    y2: 458.24
  })), _line2403 || (_line2403 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.63,
    y1: 450.71,
    x2: 739.69,
    y2: 450.71
  })), _line2404 || (_line2404 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.63,
    y1: 462.06,
    x2: 738.63,
    y2: 458.45
  })), _line2405 || (_line2405 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 732.69,
    y1: 462.06,
    x2: 732.69,
    y2: 458.45
  })), _line2406 || (_line2406 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 733.62,
    y1: 450.42,
    x2: 738.84,
    y2: 450.42
  })), _line2407 || (_line2407 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 733.62,
    y1: 444.89,
    x2: 738.84,
    y2: 444.89
  })), _line2408 || (_line2408 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 732.69,
    y1: 462.06,
    x2: 738.63,
    y2: 462.06
  })), _line2409 || (_line2409 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.29,
    y1: 458.24,
    x2: 731.29,
    y2: 451.04
  })), _line2410 || (_line2410 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 730.57,
    y1: 447.59,
    x2: 730.57,
    y2: 462.4
  })), _line2411 || (_line2411 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 739.99,
    y1: 462.4,
    x2: 739.99,
    y2: 469.68
  })), _line2412 || (_line2412 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 739.99,
    y1: 469.68,
    x2: 718.18,
    y2: 469.68
  })), _line2413 || (_line2413 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 730.57,
    y1: 447.59,
    x2: 718.18,
    y2: 447.59
  })), _line2414 || (_line2414 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.18,
    y1: 447.59,
    x2: 718.18,
    y2: 469.68
  })), _line2415 || (_line2415 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 730.57,
    y1: 462.4,
    x2: 739.99,
    y2: 462.4
  })), _line2416 || (_line2416 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 718.18,
    y1: 469.68,
    x2: 718.18,
    y2: 469.18
  })), _line2417 || (_line2417 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 736.17,
    y1: 436.44,
    x2: 736.17,
    y2: 444.8
  })), _line2418 || (_line2418 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.93,
    y1: 436.44,
    x2: 734.39,
    y2: 436.44
  })), _line2419 || (_line2419 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.93,
    y1: 444.8,
    x2: 736.17,
    y2: 444.8
  })), _line2420 || (_line2420 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 731.93,
    y1: 436.44,
    x2: 731.93,
    y2: 444.8
  })), _line2421 || (_line2421 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 735.45,
    y1: 436.44,
    x2: 736.17,
    y2: 436.44
  })), _line2422 || (_line2422 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.36,
    y1: 434.07,
    x2: 737.87,
    y2: 434.07
  })), _line2423 || (_line2423 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 716.36,
    y1: 434.07,
    x2: 716.36,
    y2: 432.91
  })), _line2424 || (_line2424 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.87,
    y1: 432.91,
    x2: 716.36,
    y2: 432.91
  })), _line2425 || (_line2425 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.87,
    y1: 412.7,
    x2: 714.87,
    y2: 412.7
  })), _line2426 || (_line2426 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 737.87,
    y1: 434.07,
    x2: 737.87,
    y2: 412.7
  })), _line2427 || (_line2427 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 714.87,
    y1: 432.91,
    x2: 714.87,
    y2: 412.7
  })), _line2428 || (_line2428 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 735.45,
    y1: 434.07,
    x2: 735.45,
    y2: 436.44
  })), _line2429 || (_line2429 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.39,
    y1: 434.07,
    x2: 734.39,
    y2: 436.44
  })), _line2430 || (_line2430 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 772.32,
    y1: 450.42,
    x2: 772.32,
    y2: 444.89
  })), _line2431 || (_line2431 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 767.14,
    y1: 450.42,
    x2: 767.14,
    y2: 444.89
  })), _polyline352 || (_polyline352 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "765.02 450.71 764.81 450.71 764.68 451.04"
  })), _polyline353 || (_polyline353 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "764.68 458.24 764.81 458.32 765.02 458.32"
  })), _polyline354 || (_polyline354 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "773.08 458.32 773.17 458.32 773.38 458.24"
  })), _polyline355 || (_polyline355 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "773.38 451.04 773.17 450.71 773.08 450.71"
  })), _line2432 || (_line2432 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.08,
    y1: 458.32,
    x2: 765.02,
    y2: 458.32
  })), _line2433 || (_line2433 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.38,
    y1: 451.04,
    x2: 773.38,
    y2: 458.24
  })), _line2434 || (_line2434 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.02,
    y1: 450.71,
    x2: 773.08,
    y2: 450.71
  })), _line2435 || (_line2435 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 772.02,
    y1: 462.06,
    x2: 772.02,
    y2: 458.45
  })), _line2436 || (_line2436 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 766.08,
    y1: 462.06,
    x2: 766.08,
    y2: 458.45
  })), _line2437 || (_line2437 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 767.14,
    y1: 450.42,
    x2: 772.32,
    y2: 450.42
  })), _line2438 || (_line2438 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 766.93,
    y1: 444.89,
    x2: 772.32,
    y2: 444.89
  })), _line2439 || (_line2439 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 766.08,
    y1: 462.06,
    x2: 772.02,
    y2: 462.06
  })), _line2440 || (_line2440 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 764.68,
    y1: 458.24,
    x2: 764.68,
    y2: 451.04
  })), _line2441 || (_line2441 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 763.96,
    y1: 447.59,
    x2: 763.96,
    y2: 462.4
  })), _line2442 || (_line2442 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.38,
    y1: 462.4,
    x2: 773.38,
    y2: 469.68
  })), _line2443 || (_line2443 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 773.38,
    y1: 469.68,
    x2: 751.57,
    y2: 469.68
  })), _line2444 || (_line2444 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 763.96,
    y1: 447.59,
    x2: 751.57,
    y2: 447.59
  })), _line2445 || (_line2445 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.57,
    y1: 447.59,
    x2: 751.57,
    y2: 469.68
  })), _line2446 || (_line2446 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 763.96,
    y1: 462.4,
    x2: 773.38,
    y2: 462.4
  })), _line2447 || (_line2447 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 751.57,
    y1: 469.68,
    x2: 751.57,
    y2: 469.18
  })), _line2448 || (_line2448 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 769.56,
    y1: 436.44,
    x2: 769.56,
    y2: 444.8
  })), _line2449 || (_line2449 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.32,
    y1: 436.44,
    x2: 767.86,
    y2: 436.44
  })), _line2450 || (_line2450 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.32,
    y1: 444.8,
    x2: 769.56,
    y2: 444.8
  })), _line2451 || (_line2451 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 765.32,
    y1: 436.44,
    x2: 765.32,
    y2: 444.8
  })), _line2452 || (_line2452 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.84,
    y1: 436.44,
    x2: 769.56,
    y2: 436.44
  })), _line2453 || (_line2453 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.66,
    y1: 434.07,
    x2: 771.26,
    y2: 434.07
  })), _line2454 || (_line2454 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 749.66,
    y1: 434.07,
    x2: 749.66,
    y2: 432.91
  })), _line2455 || (_line2455 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.18,
    y1: 432.91,
    x2: 749.66,
    y2: 432.91
  })), _line2456 || (_line2456 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.26,
    y1: 412.7,
    x2: 748.18,
    y2: 412.7
  })), _line2457 || (_line2457 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 771.26,
    y1: 434.07,
    x2: 771.26,
    y2: 412.7
  })), _line2458 || (_line2458 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 748.18,
    y1: 432.91,
    x2: 748.18,
    y2: 412.7
  })), _line2459 || (_line2459 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.84,
    y1: 434.07,
    x2: 768.84,
    y2: 436.44
  })), _line2460 || (_line2460 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 767.86,
    y1: 434.07,
    x2: 767.86,
    y2: 436.44
  })), _line2461 || (_line2461 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 805.29,
    y1: 450.42,
    x2: 805.29,
    y2: 444.89
  })), _line2462 || (_line2462 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.2,
    y1: 450.42,
    x2: 800.2,
    y2: 444.89
  })), _polyline356 || (_polyline356 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "798.07 450.71 797.86 450.71 797.86 451.04"
  })), _polyline357 || (_polyline357 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "797.86 458.24 797.86 458.32 798.07 458.32"
  })), _polyline358 || (_polyline358 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "806.26 458.32 806.35 458.32 806.35 458.24"
  })), _polyline359 || (_polyline359 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "806.35 451.04 806.35 450.71 806.26 450.71"
  })), _line2463 || (_line2463 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.26,
    y1: 458.32,
    x2: 798.07,
    y2: 458.32
  })), _line2464 || (_line2464 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.35,
    y1: 451.04,
    x2: 806.35,
    y2: 458.24
  })), _line2465 || (_line2465 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 798.07,
    y1: 450.71,
    x2: 806.26,
    y2: 450.71
  })), _line2466 || (_line2466 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.99,
    y1: 462.06,
    x2: 804.99,
    y2: 458.45
  })), _line2467 || (_line2467 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 799.26,
    y1: 462.06,
    x2: 799.26,
    y2: 458.45
  })), _line2468 || (_line2468 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.2,
    y1: 450.42,
    x2: 805.29,
    y2: 450.42
  })), _line2469 || (_line2469 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.2,
    y1: 444.89,
    x2: 805.29,
    y2: 444.89
  })), _line2470 || (_line2470 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 799.26,
    y1: 462.06,
    x2: 804.99,
    y2: 462.06
  })), _line2471 || (_line2471 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.86,
    y1: 458.24,
    x2: 797.86,
    y2: 451.04
  })), _line2472 || (_line2472 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.14,
    y1: 447.59,
    x2: 797.14,
    y2: 462.4
  })), _line2473 || (_line2473 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.35,
    y1: 462.4,
    x2: 806.35,
    y2: 469.68
  })), _line2474 || (_line2474 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.35,
    y1: 469.68,
    x2: 784.5,
    y2: 469.68
  })), _line2475 || (_line2475 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.14,
    y1: 447.59,
    x2: 784.5,
    y2: 447.59
  })), _line2476 || (_line2476 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.5,
    y1: 447.59,
    x2: 784.5,
    y2: 469.68
  })), _line2477 || (_line2477 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 797.14,
    y1: 462.4,
    x2: 806.35,
    y2: 462.4
  })), _line2478 || (_line2478 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.5,
    y1: 469.68,
    x2: 784.5,
    y2: 469.18
  })), _line2479 || (_line2479 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 802.74,
    y1: 436.44,
    x2: 802.74,
    y2: 444.8
  })), _line2480 || (_line2480 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 798.29,
    y1: 436.44,
    x2: 800.96,
    y2: 436.44
  })), _line2481 || (_line2481 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 798.29,
    y1: 444.8,
    x2: 802.74,
    y2: 444.8
  })), _line2482 || (_line2482 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 798.29,
    y1: 436.44,
    x2: 798.29,
    y2: 444.8
  })), _line2483 || (_line2483 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 802.02,
    y1: 436.44,
    x2: 802.74,
    y2: 436.44
  })), _line2484 || (_line2484 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.93,
    y1: 434.07,
    x2: 804.44,
    y2: 434.07
  })), _line2485 || (_line2485 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 782.93,
    y1: 434.07,
    x2: 782.93,
    y2: 432.91
  })), _line2486 || (_line2486 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.23,
    y1: 432.91,
    x2: 782.93,
    y2: 432.91
  })), _line2487 || (_line2487 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.44,
    y1: 412.7,
    x2: 781.23,
    y2: 412.7
  })), _line2488 || (_line2488 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.44,
    y1: 434.07,
    x2: 804.44,
    y2: 412.7
  })), _line2489 || (_line2489 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.23,
    y1: 432.91,
    x2: 781.23,
    y2: 412.7
  })), _line2490 || (_line2490 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 802.02,
    y1: 434.07,
    x2: 802.02,
    y2: 436.44
  })), _line2491 || (_line2491 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 800.96,
    y1: 434.07,
    x2: 800.96,
    y2: 436.44
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 401.97,
    y: 369.92,
    width: 448.01,
    height: 36.04
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 389.89,
    y: 634.39,
    width: 461.33,
    height: 21.63
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 392.47,
    y: 492.64,
    width: 472.72,
    height: 36.99
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 372.33,
    y: 162.64,
    width: 511,
    height: 33.23
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 402.42,
    y: 132.78,
    width: 423.96,
    height: 98.82
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 406.83,
    y: 589.04,
    width: 418.36,
    height: 44.46,
    transform: "translate(1232.02 1222.53) rotate(180)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 403.48,
    y: 337.33,
    width: 422.9,
    height: 99.53,
    transform: "translate(1229.85 774.19) rotate(180)"
  })), _line2492 || (_line2492 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 409.08,
    y1: 540.08,
    x2: 827.14,
    y2: 540.08
  })), _line2493 || (_line2493 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 489.72,
    x2: 827.67,
    y2: 489.77
  })), _line2494 || (_line2494 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 408.02,
    y1: 588.99,
    x2: 408.02,
    y2: 537.62
  })), _line2495 || (_line2495 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 403.48,
    y1: 489.72,
    x2: 403.48,
    y2: 438.36
  })), _line2496 || (_line2496 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 503.42,
    y1: 260.27,
    x2: 503.42,
    y2: 208.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamiMapsFullCpareAupstairs);
export default __webpack_public_path__ + "static/media/NAMI Maps_Full CP AREA  upstairs.6685e906f3d5eeda7ca86de15e6c222d.svg";
export { ForwardRef as ReactComponent };